var ko = Object.defineProperty;
var Co = (e, t, r) => t in e ? ko(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Se = (e, t, r) => Co(e, typeof t != "symbol" ? t + "" : t, r);
const Mo = "1.2.1", Lo = "1.29.0", Do = {
  "-32700": "ParseError",
  "-32701": "OversizedRequest",
  "-32702": "OversizedResponse",
  "-32600": "InvalidRequest",
  "-32601": "MethodNotFound",
  "-32602": "InvalidParams",
  "-32603": "InternalError",
  "-32604": "ServerBusy",
  "-32000": "CallExecutionFailed",
  "-32001": "UnknownError",
  "-32003": "SubscriptionClosed",
  "-32004": "SubscriptionClosedWithError",
  "-32005": "BatchesNotSupported",
  "-32006": "TooManySubscriptions",
  "-32050": "TransientError",
  "-32002": "TransactionExecutionClientError"
};
class as extends Error {
}
class fs extends as {
  constructor(t, r) {
    super(t), this.code = r, this.type = Do[r] ?? "ServerError";
  }
}
class Fo extends as {
  constructor(t, r, n) {
    super(t), this.status = r, this.statusText = n;
  }
}
var mi = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, Zt = (e, t, r) => (mi(e, t, "read from private field"), r ? r.call(e) : t.get(e)), tr = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, Mr = (e, t, r, n) => (mi(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), Ro = (e, t, r, n) => ({
  set _(a) {
    Mr(e, t, a, r);
  },
  get _() {
    return Zt(e, t, n);
  }
}), cs = (e, t, r) => (mi(e, t, "access private method"), r), gr, Xr, Ze, wr, en, Lr, ii, us, Ei, ls;
function Po(e) {
  const t = new URL(e);
  return t.protocol = t.protocol.replace("http", "ws"), t.toString();
}
const $o = {
  // We fudge the typing because we also check for undefined in the constructor:
  WebSocketConstructor: typeof WebSocket < "u" ? WebSocket : void 0,
  callTimeout: 3e4,
  reconnectTimeout: 3e3,
  maxReconnects: 5
};
class Vo {
  constructor(t, r = {}) {
    if (tr(this, ii), tr(this, Ei), tr(this, gr, 0), tr(this, Xr, 0), tr(this, Ze, null), tr(this, wr, null), tr(this, en, /* @__PURE__ */ new Set()), tr(this, Lr, /* @__PURE__ */ new Map()), this.endpoint = t, this.options = { ...$o, ...r }, !this.options.WebSocketConstructor)
      throw new Error("Missing WebSocket constructor");
    this.endpoint.startsWith("http") && (this.endpoint = Po(this.endpoint));
  }
  async makeRequest(t, r) {
    const n = await cs(this, ii, us).call(this);
    return new Promise((a, u) => {
      Mr(this, gr, Zt(this, gr) + 1), Zt(this, Lr).set(Zt(this, gr), {
        resolve: a,
        reject: u,
        timeout: setTimeout(() => {
          Zt(this, Lr).delete(Zt(this, gr)), u(new Error(`Request timeout: ${t}`));
        }, this.options.callTimeout)
      }), n.send(JSON.stringify({ jsonrpc: "2.0", id: Zt(this, gr), method: t, params: r }));
    }).then(({ error: a, result: u }) => {
      if (a)
        throw new fs(a.message, a.code);
      return u;
    });
  }
  async subscribe(t) {
    const r = new zo(t);
    return Zt(this, en).add(r), await r.subscribe(this), () => r.unsubscribe(this);
  }
}
gr = /* @__PURE__ */ new WeakMap();
Xr = /* @__PURE__ */ new WeakMap();
Ze = /* @__PURE__ */ new WeakMap();
wr = /* @__PURE__ */ new WeakMap();
en = /* @__PURE__ */ new WeakMap();
Lr = /* @__PURE__ */ new WeakMap();
ii = /* @__PURE__ */ new WeakSet();
us = function() {
  return Zt(this, wr) ? Zt(this, wr) : (Mr(this, wr, new Promise((e) => {
    var t;
    (t = Zt(this, Ze)) == null || t.close(), Mr(this, Ze, new this.options.WebSocketConstructor(this.endpoint)), Zt(this, Ze).addEventListener("open", () => {
      Mr(this, Xr, 0), e(Zt(this, Ze));
    }), Zt(this, Ze).addEventListener("close", () => {
      Ro(this, Xr)._++, Zt(this, Xr) <= this.options.maxReconnects && setTimeout(() => {
        cs(this, Ei, ls).call(this);
      }, this.options.reconnectTimeout);
    }), Zt(this, Ze).addEventListener("message", ({ data: r }) => {
      let n;
      try {
        n = JSON.parse(r);
      } catch (a) {
        console.error(new Error(`Failed to parse RPC message: ${r}`, { cause: a }));
        return;
      }
      if ("id" in n && n.id != null && Zt(this, Lr).has(n.id)) {
        const { resolve: a, timeout: u } = Zt(this, Lr).get(n.id);
        clearTimeout(u), a(n);
      } else if ("params" in n) {
        const { params: a } = n;
        Zt(this, en).forEach((u) => {
          u.subscriptionId === a.subscription && a.subscription === u.subscriptionId && u.onMessage(a.result);
        });
      }
    });
  })), Zt(this, wr));
};
Ei = /* @__PURE__ */ new WeakSet();
ls = async function() {
  var e;
  return (e = Zt(this, Ze)) == null || e.close(), Mr(this, wr, null), Promise.allSettled(
    [...Zt(this, en)].map((t) => t.subscribe(this))
  );
};
class zo {
  constructor(t) {
    this.subscriptionId = null, this.subscribed = !1, this.input = t;
  }
  onMessage(t) {
    this.subscribed && this.input.onMessage(t);
  }
  async unsubscribe(t) {
    const { subscriptionId: r } = this;
    return this.subscribed = !1, r == null ? !1 : (this.subscriptionId = null, t.makeRequest(this.input.unsubscribe, [r]));
  }
  async subscribe(t) {
    this.subscriptionId = null, this.subscribed = !0;
    const r = await t.makeRequest(
      this.input.method,
      this.input.params
    );
    this.subscribed && (this.subscriptionId = r);
  }
}
var Si = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, Le = (e, t, r) => (Si(e, t, "read from private field"), r ? r.call(e) : t.get(e)), hn = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, si = (e, t, r, n) => (Si(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), jo = (e, t, r) => (Si(e, t, "access private method"), r), Wr, Re, Jr, oi, hs;
class qo {
  constructor(t) {
    hn(this, oi), hn(this, Wr, 0), hn(this, Re, void 0), hn(this, Jr, void 0), si(this, Re, t);
  }
  fetch(t, r) {
    const n = Le(this, Re).fetch ?? fetch;
    if (!n)
      throw new Error(
        "The current environment does not support fetch, you can provide a fetch implementation in the options for SuiHTTPTransport."
      );
    return n(t, r);
  }
  async request(t) {
    var a, u;
    si(this, Wr, Le(this, Wr) + 1);
    const r = await this.fetch(((a = Le(this, Re).rpc) == null ? void 0 : a.url) ?? Le(this, Re).url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Client-Sdk-Type": "typescript",
        "Client-Sdk-Version": Mo,
        "Client-Target-Api-Version": Lo,
        ...(u = Le(this, Re).rpc) == null ? void 0 : u.headers
      },
      body: JSON.stringify({
        jsonrpc: "2.0",
        id: Le(this, Wr),
        method: t.method,
        params: t.params
      })
    });
    if (!r.ok)
      throw new Fo(
        `Unexpected status code: ${r.status}`,
        r.status,
        r.statusText
      );
    const n = await r.json();
    if ("error" in n && n.error != null)
      throw new fs(n.error.message, n.error.code);
    return n.result;
  }
  async subscribe(t) {
    const r = await jo(this, oi, hs).call(this).subscribe(t);
    return async () => !!await r();
  }
}
Wr = /* @__PURE__ */ new WeakMap();
Re = /* @__PURE__ */ new WeakMap();
Jr = /* @__PURE__ */ new WeakMap();
oi = /* @__PURE__ */ new WeakSet();
hs = function() {
  var e;
  if (!Le(this, Jr)) {
    const t = Le(this, Re).WebSocketConstructor ?? WebSocket;
    if (!t)
      throw new Error(
        "The current environment does not support WebSocket, you can provide a WebSocketConstructor in the options for SuiHTTPTransport."
      );
    si(this, Jr, new Vo(
      ((e = Le(this, Re).websocket) == null ? void 0 : e.url) ?? Le(this, Re).url,
      {
        WebSocketConstructor: t,
        ...Le(this, Re).websocket
      }
    ));
  }
  return Le(this, Jr);
};
function ds(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Go(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
function Yo(e) {
  if (e.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), r = 0; r < t.length; r++)
    t[r] = 255;
  for (var n = 0; n < e.length; n++) {
    var a = e.charAt(n), u = a.charCodeAt(0);
    if (t[u] !== 255)
      throw new TypeError(a + " is ambiguous");
    t[u] = n;
  }
  var p = e.length, c = e.charAt(0), y = Math.log(p) / Math.log(256), m = Math.log(256) / Math.log(p);
  function T(M) {
    if (M instanceof Uint8Array || (ArrayBuffer.isView(M) ? M = new Uint8Array(M.buffer, M.byteOffset, M.byteLength) : Array.isArray(M) && (M = Uint8Array.from(M))), !(M instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (M.length === 0)
      return "";
    for (var F = 0, N = 0, D = 0, P = M.length; D !== P && M[D] === 0; )
      D++, F++;
    for (var et = (P - D) * m + 1 >>> 0, K = new Uint8Array(et); D !== P; ) {
      for (var ot = M[D], nt = 0, j = et - 1; (ot !== 0 || nt < N) && j !== -1; j--, nt++)
        ot += 256 * K[j] >>> 0, K[j] = ot % p >>> 0, ot = ot / p >>> 0;
      if (ot !== 0)
        throw new Error("Non-zero carry");
      N = nt, D++;
    }
    for (var it = et - N; it !== et && K[it] === 0; )
      it++;
    for (var lt = c.repeat(F); it < et; ++it)
      lt += e.charAt(K[it]);
    return lt;
  }
  function v(M) {
    if (typeof M != "string")
      throw new TypeError("Expected String");
    if (M.length === 0)
      return new Uint8Array();
    for (var F = 0, N = 0, D = 0; M[F] === c; )
      N++, F++;
    for (var P = (M.length - F) * y + 1 >>> 0, et = new Uint8Array(P); M[F]; ) {
      var K = t[M.charCodeAt(F)];
      if (K === 255)
        return;
      for (var ot = 0, nt = P - 1; (K !== 0 || ot < D) && nt !== -1; nt--, ot++)
        K += p * et[nt] >>> 0, et[nt] = K % 256 >>> 0, K = K / 256 >>> 0;
      if (K !== 0)
        throw new Error("Non-zero carry");
      D = ot, F++;
    }
    for (var j = P - D; j !== P && et[j] === 0; )
      j++;
    for (var it = new Uint8Array(N + (P - j)), lt = N; j !== P; )
      it[lt++] = et[j++];
    return it;
  }
  function V(M) {
    var F = v(M);
    if (F)
      return F;
    throw new Error("Non-base" + p + " character");
  }
  return {
    encode: T,
    decodeUnsafe: v,
    decode: V
  };
}
var Wo = Yo;
const Ho = Wo, Ko = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var Zo = Ho(Ko);
const ps = /* @__PURE__ */ ds(Zo), vi = (e) => ps.encode(e), rn = (e) => ps.decode(e);
function Ne(e) {
  return Uint8Array.from(atob(e), (t) => t.charCodeAt(0));
}
const Gn = 8192;
function ee(e) {
  if (e.length < Gn)
    return btoa(String.fromCharCode(...e));
  let t = "";
  for (var r = 0; r < e.length; r += Gn) {
    const n = e.slice(r, r + Gn);
    t += String.fromCharCode(...n);
  }
  return btoa(t);
}
function gs(e) {
  var a;
  const t = e.startsWith("0x") ? e.slice(2) : e, n = ((a = (t.length % 2 === 0 ? t : `0${t}}`).match(/.{2}/g)) == null ? void 0 : a.map((u) => parseInt(u, 16))) ?? [];
  return Uint8Array.from(n);
}
function nn(e) {
  return e.reduce((t, r) => t + r.toString(16).padStart(2, "0"), "");
}
function Bi(e) {
  let t = [], r = 0;
  if (e === 0)
    return [0];
  for (; e > 0; )
    t[r] = e & 127, (e >>= 7) && (t[r] |= 128), r += 1;
  return t;
}
function Xo(e) {
  let t = 0, r = 0, n = 0;
  for (; ; ) {
    let a = e[n];
    if (n += 1, t |= (a & 127) << r, !(a & 128))
      break;
    r += 7;
  }
  return {
    value: t,
    length: n
  };
}
class Jo {
  /**
   * @param {Uint8Array} data Data to use as a buffer.
   */
  constructor(t) {
    this.bytePosition = 0, this.dataView = new DataView(t.buffer);
  }
  /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */
  shift(t) {
    return this.bytePosition += t, this;
  }
  /**
   * Read U8 value from the buffer and shift cursor by 1.
   * @returns
   */
  read8() {
    let t = this.dataView.getUint8(this.bytePosition);
    return this.shift(1), t;
  }
  /**
   * Read U16 value from the buffer and shift cursor by 2.
   * @returns
   */
  read16() {
    let t = this.dataView.getUint16(this.bytePosition, !0);
    return this.shift(2), t;
  }
  /**
   * Read U32 value from the buffer and shift cursor by 4.
   * @returns
   */
  read32() {
    let t = this.dataView.getUint32(this.bytePosition, !0);
    return this.shift(4), t;
  }
  /**
   * Read U64 value from the buffer and shift cursor by 8.
   * @returns
   */
  read64() {
    let t = this.read32(), n = this.read32().toString(16) + t.toString(16).padStart(8, "0");
    return BigInt("0x" + n).toString(10);
  }
  /**
   * Read U128 value from the buffer and shift cursor by 16.
   */
  read128() {
    let t = BigInt(this.read64()), n = BigInt(this.read64()).toString(16) + t.toString(16).padStart(16, "0");
    return BigInt("0x" + n).toString(10);
  }
  /**
   * Read U128 value from the buffer and shift cursor by 32.
   * @returns
   */
  read256() {
    let t = BigInt(this.read128()), n = BigInt(this.read128()).toString(16) + t.toString(16).padStart(32, "0");
    return BigInt("0x" + n).toString(10);
  }
  /**
   * Read `num` number of bytes from the buffer and shift cursor by `num`.
   * @param num Number of bytes to read.
   */
  readBytes(t) {
    let r = this.bytePosition + this.dataView.byteOffset, n = new Uint8Array(this.dataView.buffer, r, t);
    return this.shift(t), n;
  }
  /**
   * Read ULEB value - an integer of varying size. Used for enum indexes and
   * vector lengths.
   * @returns {Number} The ULEB value.
   */
  readULEB() {
    let t = this.bytePosition + this.dataView.byteOffset, r = new Uint8Array(this.dataView.buffer, t), { value: n, length: a } = Xo(r);
    return this.shift(a), n;
  }
  /**
   * Read a BCS vector: read a length and then apply function `cb` X times
   * where X is the length of the vector, defined as ULEB in BCS bytes.
   * @param cb Callback to process elements of vector.
   * @returns {Array<Any>} Array of the resulting values, returned by callback.
   */
  readVec(t) {
    let r = this.readULEB(), n = [];
    for (let a = 0; a < r; a++)
      n.push(t(this, a, r));
    return n;
  }
}
function Qo(e, t) {
  switch (t) {
    case "base58":
      return vi(e);
    case "base64":
      return ee(e);
    case "hex":
      return nn(e);
    default:
      throw new Error("Unsupported encoding, supported values are: base64, hex");
  }
}
function ta(e, t = ["<", ">"]) {
  const [r, n] = t, a = [];
  let u = "", p = 0;
  for (let c = 0; c < e.length; c++) {
    const y = e[c];
    if (y === r && p++, y === n && p--, p === 0 && y === ",") {
      a.push(u.trim()), u = "";
      continue;
    }
    u += y;
  }
  return a.push(u.trim()), a;
}
class ea {
  constructor({
    initialSize: t = 1024,
    maxSize: r = 1 / 0,
    allocateSize: n = 1024
  } = {}) {
    this.bytePosition = 0, this.size = t, this.maxSize = r, this.allocateSize = n, this.dataView = new DataView(new ArrayBuffer(t));
  }
  ensureSizeOrGrow(t) {
    const r = this.bytePosition + t;
    if (r > this.size) {
      const n = Math.min(this.maxSize, this.size + this.allocateSize);
      if (r > n)
        throw new Error(
          `Attempting to serialize to BCS, but buffer does not have enough size. Allocated size: ${this.size}, Max size: ${this.maxSize}, Required size: ${r}`
        );
      this.size = n;
      const a = new ArrayBuffer(this.size);
      new Uint8Array(a).set(new Uint8Array(this.dataView.buffer)), this.dataView = new DataView(a);
    }
  }
  /**
   * Shift current cursor position by `bytes`.
   *
   * @param {Number} bytes Number of bytes to
   * @returns {this} Self for possible chaining.
   */
  shift(t) {
    return this.bytePosition += t, this;
  }
  /**
   * Write a U8 value into a buffer and shift cursor position by 1.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write8(t) {
    return this.ensureSizeOrGrow(1), this.dataView.setUint8(this.bytePosition, Number(t)), this.shift(1);
  }
  /**
   * Write a U16 value into a buffer and shift cursor position by 2.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write16(t) {
    return this.ensureSizeOrGrow(2), this.dataView.setUint16(this.bytePosition, Number(t), !0), this.shift(2);
  }
  /**
   * Write a U32 value into a buffer and shift cursor position by 4.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  write32(t) {
    return this.ensureSizeOrGrow(4), this.dataView.setUint32(this.bytePosition, Number(t), !0), this.shift(4);
  }
  /**
   * Write a U64 value into a buffer and shift cursor position by 8.
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write64(t) {
    return Yn(BigInt(t), 8).forEach((r) => this.write8(r)), this;
  }
  /**
   * Write a U128 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write128(t) {
    return Yn(BigInt(t), 16).forEach((r) => this.write8(r)), this;
  }
  /**
   * Write a U256 value into a buffer and shift cursor position by 16.
   *
   * @param {bigint} value Value to write.
   * @returns {this}
   */
  write256(t) {
    return Yn(BigInt(t), 32).forEach((r) => this.write8(r)), this;
  }
  /**
   * Write a ULEB value into a buffer and shift cursor position by number of bytes
   * written.
   * @param {Number} value Value to write.
   * @returns {this}
   */
  writeULEB(t) {
    return Bi(t).forEach((r) => this.write8(r)), this;
  }
  /**
   * Write a vector into a buffer by first writing the vector length and then calling
   * a callback on each passed value.
   *
   * @param {Array<Any>} vector Array of elements to write.
   * @param {WriteVecCb} cb Callback to call on each element of the vector.
   * @returns {this}
   */
  writeVec(t, r) {
    return this.writeULEB(t.length), Array.from(t).forEach((n, a) => r(this, n, a, t.length)), this;
  }
  /**
   * Adds support for iterations over the object.
   * @returns {Uint8Array}
   */
  *[Symbol.iterator]() {
    for (let t = 0; t < this.bytePosition; t++)
      yield this.dataView.getUint8(t);
    return this.toBytes();
  }
  /**
   * Get underlying buffer taking only value bytes (in case initial buffer size was bigger).
   * @returns {Uint8Array} Resulting bcs.
   */
  toBytes() {
    return new Uint8Array(this.dataView.buffer.slice(0, this.bytePosition));
  }
  /**
   * Represent data as 'hex' or 'base64'
   * @param encoding Encoding to use: 'base64' or 'hex'
   */
  toString(t) {
    return Qo(this.toBytes(), t);
  }
}
function Yn(e, t) {
  let r = new Uint8Array(t), n = 0;
  for (; e > 0; )
    r[n] = Number(e % BigInt(256)), e = e / BigInt(256), n += 1;
  return r;
}
var xs = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, Pe = (e, t, r) => (xs(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Tn = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, Nn = (e, t, r, n) => (xs(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), Ur, Hr, Sn, sr;
const ys = class {
  constructor(e) {
    Tn(this, Ur, void 0), Tn(this, Hr, void 0), this.name = e.name, this.read = e.read, this.serializedSize = e.serializedSize ?? (() => null), Nn(this, Ur, e.write), Nn(this, Hr, e.serialize ?? ((t, r) => {
      const n = new ea({
        initialSize: this.serializedSize(t) ?? void 0,
        ...r
      });
      return Pe(this, Ur).call(this, t, n), n.toBytes();
    })), this.validate = e.validate ?? (() => {
    });
  }
  write(e, t) {
    this.validate(e), Pe(this, Ur).call(this, e, t);
  }
  serialize(e, t) {
    return this.validate(e), new na(this, Pe(this, Hr).call(this, e, t));
  }
  parse(e) {
    const t = new Jo(e);
    return this.read(t);
  }
  fromHex(e) {
    return this.parse(gs(e));
  }
  fromBase58(e) {
    return this.parse(rn(e));
  }
  fromBase64(e) {
    return this.parse(Ne(e));
  }
  transform({
    name: e,
    input: t,
    output: r,
    validate: n
  }) {
    return new ys({
      name: e ?? this.name,
      read: (a) => r(this.read(a)),
      write: (a, u) => Pe(this, Ur).call(this, t(a), u),
      serializedSize: (a) => this.serializedSize(t(a)),
      serialize: (a, u) => Pe(this, Hr).call(this, t(a), u),
      validate: (a) => {
        n == null || n(a), this.validate(t(a));
      }
    });
  }
};
let Xe = ys;
Ur = /* @__PURE__ */ new WeakMap();
Hr = /* @__PURE__ */ new WeakMap();
const ra = Symbol.for("@mysten/serialized-bcs");
class na {
  constructor(t, r) {
    Tn(this, Sn, void 0), Tn(this, sr, void 0), Nn(this, Sn, t), Nn(this, sr, r);
  }
  // Used to brand SerializedBcs so that they can be identified, even between multiple copies
  // of the @mysten/bcs package are installed
  get [ra]() {
    return !0;
  }
  toBytes() {
    return Pe(this, sr);
  }
  toHex() {
    return nn(Pe(this, sr));
  }
  toBase64() {
    return ee(Pe(this, sr));
  }
  toBase58() {
    return vi(Pe(this, sr));
  }
  parse() {
    return Pe(this, Sn).parse(Pe(this, sr));
  }
}
Sn = /* @__PURE__ */ new WeakMap();
sr = /* @__PURE__ */ new WeakMap();
function Un({
  size: e,
  ...t
}) {
  return new Xe({
    ...t,
    serializedSize: () => e
  });
}
function Wn({
  readMethod: e,
  writeMethod: t,
  ...r
}) {
  return Un({
    ...r,
    read: (n) => n[e](),
    write: (n, a) => a[t](n),
    validate: (n) => {
      var a;
      if (n < 0 || n > r.maxValue)
        throw new TypeError(
          `Invalid ${r.name} value: ${n}. Expected value in range 0-${r.maxValue}`
        );
      (a = r.validate) == null || a.call(r, n);
    }
  });
}
function Hn({
  readMethod: e,
  writeMethod: t,
  ...r
}) {
  return Un({
    ...r,
    read: (n) => n[e](),
    write: (n, a) => a[t](BigInt(n)),
    validate: (n) => {
      var u;
      const a = BigInt(n);
      if (a < 0 || a > r.maxValue)
        throw new TypeError(
          `Invalid ${r.name} value: ${a}. Expected value in range 0-${r.maxValue}`
        );
      (u = r.validate) == null || u.call(r, a);
    }
  });
}
function ia({
  serialize: e,
  ...t
}) {
  const r = new Xe({
    ...t,
    serialize: e,
    write: (n, a) => {
      for (const u of r.serialize(n).toBytes())
        a.write8(u);
    }
  });
  return r;
}
function sa({
  toBytes: e,
  fromBytes: t,
  ...r
}) {
  return new Xe({
    ...r,
    read: (n) => {
      const a = n.readULEB(), u = n.readBytes(a);
      return t(u);
    },
    write: (n, a) => {
      const u = e(n);
      a.writeULEB(u.length);
      for (let p = 0; p < u.length; p++)
        a.write8(u[p]);
    },
    serialize: (n) => {
      const a = e(n), u = Bi(a.length), p = new Uint8Array(u.length + a.length);
      return p.set(u, 0), p.set(a, u.length), p;
    },
    validate: (n) => {
      var a;
      if (typeof n != "string")
        throw new TypeError(`Invalid ${r.name} value: ${n}. Expected string`);
      (a = r.validate) == null || a.call(r, n);
    }
  });
}
function oa(e) {
  let t = null;
  function r() {
    return t || (t = e()), t;
  }
  return new Xe({
    name: "lazy",
    read: (n) => r().read(n),
    serializedSize: (n) => r().serializedSize(n),
    write: (n, a) => r().write(n, a),
    serialize: (n, a) => r().serialize(n, a).toBytes()
  });
}
const w = {
  /**
   * Creates a BcsType that can be used to read and write an 8-bit unsigned integer.
   * @example
   * bcs.u8().serialize(255).toBytes() // Uint8Array [ 255 ]
   */
  u8(e) {
    return Wn({
      name: "u8",
      readMethod: "read8",
      writeMethod: "write8",
      size: 1,
      maxValue: 2 ** 8 - 1,
      ...e
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 16-bit unsigned integer.
   * @example
   * bcs.u16().serialize(65535).toBytes() // Uint8Array [ 255, 255 ]
   */
  u16(e) {
    return Wn({
      name: "u16",
      readMethod: "read16",
      writeMethod: "write16",
      size: 2,
      maxValue: 2 ** 16 - 1,
      ...e
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 32-bit unsigned integer.
   * @example
   * bcs.u32().serialize(4294967295).toBytes() // Uint8Array [ 255, 255, 255, 255 ]
   */
  u32(e) {
    return Wn({
      name: "u32",
      readMethod: "read32",
      writeMethod: "write32",
      size: 4,
      maxValue: 2 ** 32 - 1,
      ...e
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 64-bit unsigned integer.
   * @example
   * bcs.u64().serialize(1).toBytes() // Uint8Array [ 1, 0, 0, 0, 0, 0, 0, 0 ]
   */
  u64(e) {
    return Hn({
      name: "u64",
      readMethod: "read64",
      writeMethod: "write64",
      size: 8,
      maxValue: 2n ** 64n - 1n,
      ...e
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 128-bit unsigned integer.
   * @example
   * bcs.u128().serialize(1).toBytes() // Uint8Array [ 1, ..., 0 ]
   */
  u128(e) {
    return Hn({
      name: "u128",
      readMethod: "read128",
      writeMethod: "write128",
      size: 16,
      maxValue: 2n ** 128n - 1n,
      ...e
    });
  },
  /**
   * Creates a BcsType that can be used to read and write a 256-bit unsigned integer.
   * @example
   * bcs.u256().serialize(1).toBytes() // Uint8Array [ 1, ..., 0 ]
   */
  u256(e) {
    return Hn({
      name: "u256",
      readMethod: "read256",
      writeMethod: "write256",
      size: 32,
      maxValue: 2n ** 256n - 1n,
      ...e
    });
  },
  /**
   * Creates a BcsType that can be used to read and write boolean values.
   * @example
   * bcs.bool().serialize(true).toBytes() // Uint8Array [ 1 ]
   */
  bool(e) {
    return Un({
      name: "bool",
      size: 1,
      read: (t) => t.read8() === 1,
      write: (t, r) => r.write8(t ? 1 : 0),
      ...e,
      validate: (t) => {
        var r;
        if ((r = e == null ? void 0 : e.validate) == null || r.call(e, t), typeof t != "boolean")
          throw new TypeError(`Expected boolean, found ${typeof t}`);
      }
    });
  },
  /**
   * Creates a BcsType that can be used to read and write unsigned LEB encoded integers
   * @example
   *
   */
  uleb128(e) {
    return ia({
      name: "uleb128",
      read: (t) => t.readULEB(),
      serialize: (t) => Uint8Array.from(Bi(t)),
      ...e
    });
  },
  /**
   * Creates a BcsType representing a fixed length byte array
   * @param size The number of bytes this types represents
   * @example
   * bcs.bytes(3).serialize(new Uint8Array([1, 2, 3])).toBytes() // Uint8Array [1, 2, 3]
   */
  bytes(e, t) {
    return Un({
      name: `bytes[${e}]`,
      size: e,
      read: (r) => r.readBytes(e),
      write: (r, n) => {
        for (let a = 0; a < e; a++)
          n.write8(r[a] ?? 0);
      },
      ...t,
      validate: (r) => {
        var n;
        if ((n = t == null ? void 0 : t.validate) == null || n.call(t, r), !r || typeof r != "object" || !("length" in r))
          throw new TypeError(`Expected array, found ${typeof r}`);
        if (r.length !== e)
          throw new TypeError(`Expected array of length ${e}, found ${r.length}`);
      }
    });
  },
  /**
   * Creates a BcsType that can ser/de string values.  Strings will be UTF-8 encoded
   * @example
   * bcs.string().serialize('a').toBytes() // Uint8Array [ 1, 97 ]
   */
  string(e) {
    return sa({
      name: "string",
      toBytes: (t) => new TextEncoder().encode(t),
      fromBytes: (t) => new TextDecoder().decode(t),
      ...e
    });
  },
  /**
   * Creates a BcsType that represents a fixed length array of a given type
   * @param size The number of elements in the array
   * @param type The BcsType of each element in the array
   * @example
   * bcs.fixedArray(3, bcs.u8()).serialize([1, 2, 3]).toBytes() // Uint8Array [ 1, 2, 3 ]
   */
  fixedArray(e, t, r) {
    return new Xe({
      name: `${t.name}[${e}]`,
      read: (n) => {
        const a = new Array(e);
        for (let u = 0; u < e; u++)
          a[u] = t.read(n);
        return a;
      },
      write: (n, a) => {
        for (const u of n)
          t.write(u, a);
      },
      ...r,
      validate: (n) => {
        var a;
        if ((a = r == null ? void 0 : r.validate) == null || a.call(r, n), !n || typeof n != "object" || !("length" in n))
          throw new TypeError(`Expected array, found ${typeof n}`);
        if (n.length !== e)
          throw new TypeError(`Expected array of length ${e}, found ${n.length}`);
      }
    });
  },
  /**
   * Creates a BcsType representing an optional value
   * @param type The BcsType of the optional value
   * @example
   * bcs.option(bcs.u8()).serialize(null).toBytes() // Uint8Array [ 0 ]
   * bcs.option(bcs.u8()).serialize(1).toBytes() // Uint8Array [ 1, 1 ]
   */
  option(e) {
    return w.enum(`Option<${e.name}>`, {
      None: null,
      Some: e
    }).transform({
      input: (t) => t == null ? { None: !0 } : { Some: t },
      output: (t) => t.$kind === "Some" ? t.Some : null
    });
  },
  /**
   * Creates a BcsType representing a variable length vector of a given type
   * @param type The BcsType of each element in the vector
   *
   * @example
   * bcs.vector(bcs.u8()).toBytes([1, 2, 3]) // Uint8Array [ 3, 1, 2, 3 ]
   */
  vector(e, t) {
    return new Xe({
      name: `vector<${e.name}>`,
      read: (r) => {
        const n = r.readULEB(), a = new Array(n);
        for (let u = 0; u < n; u++)
          a[u] = e.read(r);
        return a;
      },
      write: (r, n) => {
        n.writeULEB(r.length);
        for (const a of r)
          e.write(a, n);
      },
      ...t,
      validate: (r) => {
        var n;
        if ((n = t == null ? void 0 : t.validate) == null || n.call(t, r), !r || typeof r != "object" || !("length" in r))
          throw new TypeError(`Expected array, found ${typeof r}`);
      }
    });
  },
  /**
   * Creates a BcsType representing a tuple of a given set of types
   * @param types The BcsTypes for each element in the tuple
   *
   * @example
   * const tuple = bcs.tuple([bcs.u8(), bcs.string(), bcs.bool()])
   * tuple.serialize([1, 'a', true]).toBytes() // Uint8Array [ 1, 1, 97, 1 ]
   */
  tuple(e, t) {
    return new Xe({
      name: `(${e.map((r) => r.name).join(", ")})`,
      serializedSize: (r) => {
        let n = 0;
        for (let a = 0; a < e.length; a++) {
          const u = e[a].serializedSize(r[a]);
          if (u == null)
            return null;
          n += u;
        }
        return n;
      },
      read: (r) => {
        const n = [];
        for (const a of e)
          n.push(a.read(r));
        return n;
      },
      write: (r, n) => {
        for (let a = 0; a < e.length; a++)
          e[a].write(r[a], n);
      },
      ...t,
      validate: (r) => {
        var n;
        if ((n = t == null ? void 0 : t.validate) == null || n.call(t, r), !Array.isArray(r))
          throw new TypeError(`Expected array, found ${typeof r}`);
        if (r.length !== e.length)
          throw new TypeError(`Expected array of length ${e.length}, found ${r.length}`);
      }
    });
  },
  /**
   * Creates a BcsType representing a struct of a given set of fields
   * @param name The name of the struct
   * @param fields The fields of the struct. The order of the fields affects how data is serialized and deserialized
   *
   * @example
   * const struct = bcs.struct('MyStruct', {
   *  a: bcs.u8(),
   *  b: bcs.string(),
   * })
   * struct.serialize({ a: 1, b: 'a' }).toBytes() // Uint8Array [ 1, 1, 97 ]
   */
  struct(e, t, r) {
    const n = Object.entries(t);
    return new Xe({
      name: e,
      serializedSize: (a) => {
        let u = 0;
        for (const [p, c] of n) {
          const y = c.serializedSize(a[p]);
          if (y == null)
            return null;
          u += y;
        }
        return u;
      },
      read: (a) => {
        const u = {};
        for (const [p, c] of n)
          u[p] = c.read(a);
        return u;
      },
      write: (a, u) => {
        for (const [p, c] of n)
          c.write(a[p], u);
      },
      ...r,
      validate: (a) => {
        var u;
        if ((u = r == null ? void 0 : r.validate) == null || u.call(r, a), typeof a != "object" || a == null)
          throw new TypeError(`Expected object, found ${typeof a}`);
      }
    });
  },
  /**
   * Creates a BcsType representing an enum of a given set of options
   * @param name The name of the enum
   * @param values The values of the enum. The order of the values affects how data is serialized and deserialized.
   * null can be used to represent a variant with no data.
   *
   * @example
   * const enum = bcs.enum('MyEnum', {
   *   A: bcs.u8(),
   *   B: bcs.string(),
   *   C: null,
   * })
   * enum.serialize({ A: 1 }).toBytes() // Uint8Array [ 0, 1 ]
   * enum.serialize({ B: 'a' }).toBytes() // Uint8Array [ 1, 1, 97 ]
   * enum.serialize({ C: true }).toBytes() // Uint8Array [ 2 ]
   */
  enum(e, t, r) {
    const n = Object.entries(t);
    return new Xe({
      name: e,
      read: (a) => {
        const u = a.readULEB(), [p, c] = n[u];
        return {
          [p]: (c == null ? void 0 : c.read(a)) ?? !0,
          $kind: p
        };
      },
      write: (a, u) => {
        const [p, c] = Object.entries(a).filter(
          ([y]) => Object.hasOwn(t, y)
        )[0];
        for (let y = 0; y < n.length; y++) {
          const [m, T] = n[y];
          if (m === p) {
            u.writeULEB(y), T == null || T.write(c, u);
            return;
          }
        }
      },
      ...r,
      validate: (a) => {
        var c;
        if ((c = r == null ? void 0 : r.validate) == null || c.call(r, a), typeof a != "object" || a == null)
          throw new TypeError(`Expected object, found ${typeof a}`);
        const u = Object.keys(a).filter(
          (y) => a[y] !== void 0 && Object.hasOwn(t, y)
        );
        if (u.length !== 1)
          throw new TypeError(
            `Expected object with one key, but found ${u.length} for type ${e}}`
          );
        const [p] = u;
        if (!Object.hasOwn(t, p))
          throw new TypeError(`Invalid enum variant ${p}`);
      }
    });
  },
  /**
   * Creates a BcsType representing a map of a given key and value type
   * @param keyType The BcsType of the key
   * @param valueType The BcsType of the value
   * @example
   * const map = bcs.map(bcs.u8(), bcs.string())
   * map.serialize(new Map([[2, 'a']])).toBytes() // Uint8Array [ 1, 2, 1, 97 ]
   */
  map(e, t) {
    return w.vector(w.tuple([e, t])).transform({
      name: `Map<${e.name}, ${t.name}>`,
      input: (r) => [...r.entries()],
      output: (r) => {
        const n = /* @__PURE__ */ new Map();
        for (const [a, u] of r)
          n.set(a, u);
        return n;
      }
    });
  },
  /**
   * Creates a BcsType that wraps another BcsType which is lazily evaluated. This is useful for creating recursive types.
   * @param cb A callback that returns the BcsType
   */
  lazy(e) {
    return oa(e);
  }
}, aa = 32;
function $i(e) {
  try {
    return rn(e).length === aa;
  } catch {
    return !1;
  }
}
const Dn = 32;
function ar(e) {
  return fa(e) && ca(e) === Dn;
}
function dn(e) {
  return ar(e);
}
function _e(e, t = !1) {
  let r = e.toLowerCase();
  return !t && r.startsWith("0x") && (r = r.slice(2)), `0x${r.padStart(Dn * 2, "0")}`;
}
function pn(e, t = !1) {
  return _e(e, t);
}
function fa(e) {
  return /^(0x|0X)?[a-fA-F0-9]+$/.test(e) && e.length % 2 === 0;
}
function ca(e) {
  return /^(0x|0X)/.test(e) ? (e.length - 2) / 2 : e.length / 2;
}
const ua = /^vector<(.+)>$/, la = /^([^:]+)::([^:]+)::([^<]+)(<(.+)>)?/;
class fr {
  static parseFromStr(t, r = !1) {
    if (t === "address")
      return { address: null };
    if (t === "bool")
      return { bool: null };
    if (t === "u8")
      return { u8: null };
    if (t === "u16")
      return { u16: null };
    if (t === "u32")
      return { u32: null };
    if (t === "u64")
      return { u64: null };
    if (t === "u128")
      return { u128: null };
    if (t === "u256")
      return { u256: null };
    if (t === "signer")
      return { signer: null };
    const n = t.match(ua);
    if (n)
      return {
        vector: fr.parseFromStr(n[1], r)
      };
    const a = t.match(la);
    if (a)
      return {
        struct: {
          address: r ? _e(a[1]) : a[1],
          module: a[2],
          name: a[3],
          typeParams: a[5] === void 0 ? [] : fr.parseStructTypeArgs(a[5], r)
        }
      };
    throw new Error(`Encountered unexpected token when parsing type args for ${t}`);
  }
  static parseStructTypeArgs(t, r = !1) {
    return ta(t).map(
      (n) => fr.parseFromStr(n, r)
    );
  }
  static tagToString(t) {
    if ("bool" in t)
      return "bool";
    if ("u8" in t)
      return "u8";
    if ("u16" in t)
      return "u16";
    if ("u32" in t)
      return "u32";
    if ("u64" in t)
      return "u64";
    if ("u128" in t)
      return "u128";
    if ("u256" in t)
      return "u256";
    if ("address" in t)
      return "address";
    if ("signer" in t)
      return "signer";
    if ("vector" in t)
      return `vector<${fr.tagToString(t.vector)}>`;
    if ("struct" in t) {
      const r = t.struct, n = r.typeParams.map(fr.tagToString).join(", ");
      return `${r.address}::${r.module}::${r.name}${n ? `<${n}>` : ""}`;
    }
    throw new Error("Invalid TypeTag");
  }
}
function ha(e) {
  return w.u64({
    name: "unsafe_u64",
    ...e
  }).transform({
    input: (t) => t,
    output: (t) => Number(t)
  });
}
function da(e) {
  return w.enum("Option", {
    None: null,
    Some: e
  });
}
const re = w.bytes(Dn).transform({
  validate: (e) => {
    const t = typeof e == "string" ? e : nn(e);
    if (!t || !ar(_e(t)))
      throw new Error(`Invalid Sui address ${t}`);
  },
  input: (e) => typeof e == "string" ? gs(_e(e)) : e,
  output: (e) => _e(nn(e))
}), $e = w.vector(w.u8()).transform({
  name: "ObjectDigest",
  input: (e) => rn(e),
  output: (e) => vi(new Uint8Array(e)),
  validate: (e) => {
    if (rn(e).length !== 32)
      throw new Error("ObjectDigest must be 32 bytes");
  }
}), Ce = w.struct("SuiObjectRef", {
  objectId: re,
  version: w.u64(),
  digest: $e
}), ws = w.struct("SharedObjectRef", {
  objectId: re,
  initialSharedVersion: w.u64(),
  mutable: w.bool()
}), bs = w.enum("ObjectArg", {
  ImmOrOwnedObject: Ce,
  SharedObject: ws,
  Receiving: Ce
}), ms = w.enum("CallArg", {
  Pure: w.struct("Pure", {
    bytes: w.vector(w.u8()).transform({
      input: (e) => typeof e == "string" ? Ne(e) : e,
      output: (e) => ee(new Uint8Array(e))
    })
  }),
  Object: bs
}), Ii = w.enum("TypeTag", {
  bool: null,
  u8: null,
  u64: null,
  u128: null,
  address: null,
  signer: null,
  vector: w.lazy(() => Ii),
  struct: w.lazy(() => As),
  u16: null,
  u32: null,
  u256: null
}), Ai = Ii.transform({
  input: (e) => typeof e == "string" ? fr.parseFromStr(e, !0) : e,
  output: (e) => fr.tagToString(e)
}), ze = w.enum("Argument", {
  GasCoin: null,
  Input: w.u16(),
  Result: w.u16(),
  NestedResult: w.tuple([w.u16(), w.u16()])
}), Es = w.struct("ProgrammableMoveCall", {
  package: re,
  module: w.string(),
  function: w.string(),
  typeArguments: w.vector(Ai),
  arguments: w.vector(ze)
}), Ss = w.enum("Command", {
  /**
   * A Move Call - any public Move function can be called via
   * this transaction. The results can be used that instant to pass
   * into the next transaction.
   */
  MoveCall: Es,
  /**
   * Transfer vector of objects to a receiver.
   */
  TransferObjects: w.struct("TransferObjects", {
    objects: w.vector(ze),
    address: ze
  }),
  // /**
  //  * Split `amount` from a `coin`.
  //  */
  SplitCoins: w.struct("SplitCoins", {
    coin: ze,
    amounts: w.vector(ze)
  }),
  // /**
  //  * Merge Vector of Coins (`sources`) into a `destination`.
  //  */
  MergeCoins: w.struct("MergeCoins", {
    destination: ze,
    sources: w.vector(ze)
  }),
  // /**
  //  * Publish a Move module.
  //  */
  Publish: w.struct("Publish", {
    modules: w.vector(
      w.vector(w.u8()).transform({
        input: (e) => typeof e == "string" ? Ne(e) : e,
        output: (e) => ee(new Uint8Array(e))
      })
    ),
    dependencies: w.vector(re)
  }),
  // /**
  //  * Build a vector of objects using the input arguments.
  //  * It is impossible to export construct a `vector<T: key>` otherwise,
  //  * so this call serves a utility function.
  //  */
  MakeMoveVec: w.struct("MakeMoveVec", {
    type: da(Ai).transform({
      input: (e) => e === null ? {
        None: !0
      } : {
        Some: e
      },
      output: (e) => e.Some ?? null
    }),
    elements: w.vector(ze)
  }),
  Upgrade: w.struct("Upgrade", {
    modules: w.vector(
      w.vector(w.u8()).transform({
        input: (e) => typeof e == "string" ? Ne(e) : e,
        output: (e) => ee(new Uint8Array(e))
      })
    ),
    dependencies: w.vector(re),
    package: re,
    ticket: ze
  })
}), vs = w.struct("ProgrammableTransaction", {
  inputs: w.vector(ms),
  commands: w.vector(Ss)
}), Bs = w.enum("TransactionKind", {
  ProgrammableTransaction: vs,
  ChangeEpoch: null,
  Genesis: null,
  ConsensusCommitPrologue: null
}), Is = w.enum("TransactionExpiration", {
  None: null,
  Epoch: ha()
}), As = w.struct("StructTag", {
  address: re,
  module: w.string(),
  name: w.string(),
  typeParams: w.vector(Ii)
}), _s = w.struct("GasData", {
  payment: w.vector(Ce),
  owner: re,
  price: w.u64(),
  budget: w.u64()
}), Ts = w.struct("TransactionDataV1", {
  kind: Bs,
  sender: re,
  gasData: _s,
  expiration: Is
}), Ns = w.enum("TransactionData", {
  V1: Ts
}), Us = w.enum("IntentScope", {
  TransactionData: null,
  TransactionEffects: null,
  CheckpointSummary: null,
  PersonalMessage: null
}), Os = w.enum("IntentVersion", {
  V0: null
}), ks = w.enum("AppId", {
  Sui: null
}), Cs = w.struct("Intent", {
  scope: Us,
  version: Os,
  appId: ks
});
function Ms(e) {
  return w.struct(`IntentMessage<${e.name}>`, {
    intent: Cs,
    value: e
  });
}
const Ls = w.enum("CompressedSignature", {
  ED25519: w.fixedArray(64, w.u8()),
  Secp256k1: w.fixedArray(64, w.u8()),
  Secp256r1: w.fixedArray(64, w.u8()),
  ZkLogin: w.vector(w.u8())
}), Ds = w.enum("PublicKey", {
  ED25519: w.fixedArray(32, w.u8()),
  Secp256k1: w.fixedArray(33, w.u8()),
  Secp256r1: w.fixedArray(33, w.u8()),
  ZkLogin: w.vector(w.u8())
}), Fs = w.struct("MultiSigPkMap", {
  pubKey: Ds,
  weight: w.u8()
}), Rs = w.struct("MultiSigPublicKey", {
  pk_map: w.vector(Fs),
  threshold: w.u16()
}), pa = w.struct("MultiSig", {
  sigs: w.vector(Ls),
  bitmap: w.u16(),
  multisig_pk: Rs
}), ga = w.vector(w.u8()).transform({
  input: (e) => typeof e == "string" ? Ne(e) : e,
  output: (e) => ee(new Uint8Array(e))
}), Ps = w.struct("SenderSignedTransaction", {
  intentMessage: Ms(Ns),
  txSignatures: w.vector(ga)
}), xa = w.vector(Ps, {
  name: "SenderSignedData"
}), ya = w.enum("PackageUpgradeError", {
  UnableToFetchPackage: w.struct("UnableToFetchPackage", { packageId: re }),
  NotAPackage: w.struct("NotAPackage", { objectId: re }),
  IncompatibleUpgrade: null,
  DigestDoesNotMatch: w.struct("DigestDoesNotMatch", { digest: w.vector(w.u8()) }),
  UnknownUpgradePolicy: w.struct("UnknownUpgradePolicy", { policy: w.u8() }),
  PackageIDDoesNotMatch: w.struct("PackageIDDoesNotMatch", {
    packageId: re,
    ticketId: re
  })
}), wa = w.struct("ModuleId", {
  address: re,
  name: w.string()
}), Vi = w.struct("MoveLocation", {
  module: wa,
  function: w.u16(),
  instruction: w.u16(),
  functionName: w.option(w.string())
}), ba = w.enum("CommandArgumentError", {
  TypeMismatch: null,
  InvalidBCSBytes: null,
  InvalidUsageOfPureArg: null,
  InvalidArgumentToPrivateEntryFunction: null,
  IndexOutOfBounds: w.struct("IndexOutOfBounds", { idx: w.u16() }),
  SecondaryIndexOutOfBounds: w.struct("SecondaryIndexOutOfBounds", {
    resultIdx: w.u16(),
    secondaryIdx: w.u16()
  }),
  InvalidResultArity: w.struct("InvalidResultArity", { resultIdx: w.u16() }),
  InvalidGasCoinUsage: null,
  InvalidValueUsage: null,
  InvalidObjectByValue: null,
  InvalidObjectByMutRef: null,
  SharedObjectOperationNotAllowed: null
}), ma = w.enum("TypeArgumentError", {
  TypeNotFound: null,
  ConstraintNotSatisfied: null
}), Ea = w.enum("ExecutionFailureStatus", {
  InsufficientGas: null,
  InvalidGasObject: null,
  InvariantViolation: null,
  FeatureNotYetSupported: null,
  MoveObjectTooBig: w.struct("MoveObjectTooBig", {
    objectSize: w.u64(),
    maxObjectSize: w.u64()
  }),
  MovePackageTooBig: w.struct("MovePackageTooBig", {
    objectSize: w.u64(),
    maxObjectSize: w.u64()
  }),
  CircularObjectOwnership: w.struct("CircularObjectOwnership", { object: re }),
  InsufficientCoinBalance: null,
  CoinBalanceOverflow: null,
  PublishErrorNonZeroAddress: null,
  SuiMoveVerificationError: null,
  MovePrimitiveRuntimeError: w.option(Vi),
  MoveAbort: w.tuple([Vi, w.u64()]),
  VMVerificationOrDeserializationError: null,
  VMInvariantViolation: null,
  FunctionNotFound: null,
  ArityMismatch: null,
  TypeArityMismatch: null,
  NonEntryFunctionInvoked: null,
  CommandArgumentError: w.struct("CommandArgumentError", {
    argIdx: w.u16(),
    kind: ba
  }),
  TypeArgumentError: w.struct("TypeArgumentError", {
    argumentIdx: w.u16(),
    kind: ma
  }),
  UnusedValueWithoutDrop: w.struct("UnusedValueWithoutDrop", {
    resultIdx: w.u16(),
    secondaryIdx: w.u16()
  }),
  InvalidPublicFunctionReturnType: w.struct("InvalidPublicFunctionReturnType", {
    idx: w.u16()
  }),
  InvalidTransferObject: null,
  EffectsTooLarge: w.struct("EffectsTooLarge", { currentSize: w.u64(), maxSize: w.u64() }),
  PublishUpgradeMissingDependency: null,
  PublishUpgradeDependencyDowngrade: null,
  PackageUpgradeError: w.struct("PackageUpgradeError", { upgradeError: ya }),
  WrittenObjectsTooLarge: w.struct("WrittenObjectsTooLarge", {
    currentSize: w.u64(),
    maxSize: w.u64()
  }),
  CertificateDenied: null,
  SuiMoveVerificationTimedout: null,
  SharedObjectOperationNotAllowed: null,
  InputObjectDeleted: null
}), $s = w.enum("ExecutionStatus", {
  Success: null,
  Failed: w.struct("ExecutionFailed", {
    error: Ea,
    command: w.option(w.u64())
  })
}), Vs = w.struct("GasCostSummary", {
  computationCost: w.u64(),
  storageCost: w.u64(),
  storageRebate: w.u64(),
  nonRefundableStorageFee: w.u64()
}), Cr = w.enum("Owner", {
  AddressOwner: re,
  ObjectOwner: re,
  Shared: w.struct("Shared", {
    initialSharedVersion: w.u64()
  }),
  Immutable: null
}), Sa = w.struct("TransactionEffectsV1", {
  status: $s,
  executedEpoch: w.u64(),
  gasUsed: Vs,
  modifiedAtVersions: w.vector(w.tuple([re, w.u64()])),
  sharedObjects: w.vector(Ce),
  transactionDigest: $e,
  created: w.vector(w.tuple([Ce, Cr])),
  mutated: w.vector(w.tuple([Ce, Cr])),
  unwrapped: w.vector(w.tuple([Ce, Cr])),
  deleted: w.vector(Ce),
  unwrappedThenDeleted: w.vector(Ce),
  wrapped: w.vector(Ce),
  gasObject: w.tuple([Ce, Cr]),
  eventsDigest: w.option($e),
  dependencies: w.vector($e)
}), _i = w.tuple([w.u64(), $e]), va = w.enum("ObjectIn", {
  NotExist: null,
  Exist: w.tuple([_i, Cr])
}), Ba = w.enum("ObjectOut", {
  NotExist: null,
  ObjectWrite: w.tuple([$e, Cr]),
  PackageWrite: _i
}), Ia = w.enum("IDOperation", {
  None: null,
  Created: null,
  Deleted: null
}), Aa = w.struct("EffectsObjectChange", {
  inputState: va,
  outputState: Ba,
  idOperation: Ia
}), _a = w.enum("UnchangedSharedKind", {
  ReadOnlyRoot: _i,
  MutateDeleted: w.u64(),
  ReadDeleted: w.u64()
}), Ta = w.struct("TransactionEffectsV2", {
  status: $s,
  executedEpoch: w.u64(),
  gasUsed: Vs,
  transactionDigest: $e,
  gasObjectIndex: w.option(w.u32()),
  eventsDigest: w.option($e),
  dependencies: w.vector($e),
  lamportVersion: w.u64(),
  changedObjects: w.vector(w.tuple([re, Aa])),
  unchangedSharedObjects: w.vector(w.tuple([re, _a])),
  auxDataDigest: w.option($e)
}), Na = w.enum("TransactionEffects", {
  V1: Sa,
  V2: Ta
}), Ae = {
  ...w,
  U8: w.u8(),
  U16: w.u16(),
  U32: w.u32(),
  U64: w.u64(),
  U128: w.u128(),
  U256: w.u256(),
  ULEB128: w.uleb128(),
  Bool: w.bool(),
  String: w.string(),
  Address: re,
  AppId: ks,
  Argument: ze,
  CallArg: ms,
  CompressedSignature: Ls,
  GasData: _s,
  Intent: Cs,
  IntentMessage: Ms,
  IntentScope: Us,
  IntentVersion: Os,
  MultiSig: pa,
  MultiSigPkMap: Fs,
  MultiSigPublicKey: Rs,
  ObjectArg: bs,
  ObjectDigest: $e,
  ProgrammableMoveCall: Es,
  ProgrammableTransaction: vs,
  PublicKey: Ds,
  SenderSignedData: xa,
  SenderSignedTransaction: Ps,
  SharedObjectRef: ws,
  StructTag: As,
  SuiObjectRef: Ce,
  Command: Ss,
  TransactionData: Ns,
  TransactionDataV1: Ts,
  TransactionExpiration: Is,
  TransactionKind: Bs,
  TypeTag: Ai,
  TransactionEffects: Na
}, Ua = /^(?!.*(^(?!@)|[-.@])($|[-.@]))(?:[a-z0-9-]{0,63}(?:\.[a-z0-9-]{0,63})*)?@[a-z0-9-]{0,63}$/i, Oa = /^(?!.*(^|[-.])($|[-.]))(?:[a-z0-9-]{0,63}\.)+sui$/i;
function ka(e, t = "at") {
  const r = e.toLowerCase();
  let n;
  if (r.includes("@")) {
    if (!Ua.test(r))
      throw new Error(`Invalid SuiNS name ${e}`);
    const [a, u] = r.split("@");
    n = [...a ? a.split(".") : [], u];
  } else {
    if (!Oa.test(r))
      throw new Error(`Invalid SuiNS name ${e}`);
    n = r.split(".").slice(0, -1);
  }
  return t === "dot" ? `${n.join(".")}.sui` : `${n.slice(0, -1).join(".")}@${n[n.length - 1]}`;
}
function Qr(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`positive integer expected, not ${e}`);
}
function Ca(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function an(e, ...t) {
  if (!Ca(e))
    throw new Error("Uint8Array expected");
  if (t.length > 0 && !t.includes(e.length))
    throw new Error(`Uint8Array expected of length ${t}, not of length=${e.length}`);
}
function Ma(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Qr(e.outputLen), Qr(e.blockLen);
}
function Rr(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function zs(e, t) {
  an(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const Kn = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const On = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), Zn = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), Ve = (e, t) => e << 32 - t | e >>> t, xr = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, js = (e) => e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255, Ke = xr ? (e) => e : (e) => js(e);
function Tr(e) {
  for (let t = 0; t < e.length; t++)
    e[t] = js(e[t]);
}
const La = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function qs(e) {
  an(e);
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += La[e[r]];
  return t;
}
const We = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function zi(e) {
  if (e >= We._0 && e <= We._9)
    return e - We._0;
  if (e >= We._A && e <= We._F)
    return e - (We._A - 10);
  if (e >= We._a && e <= We._f)
    return e - (We._a - 10);
}
function Da(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length, r = t / 2;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const n = new Uint8Array(r);
  for (let a = 0, u = 0; a < r; a++, u += 2) {
    const p = zi(e.charCodeAt(u)), c = zi(e.charCodeAt(u + 1));
    if (p === void 0 || c === void 0) {
      const y = e[u] + e[u + 1];
      throw new Error('hex string expected, got non-hex character "' + y + '" at index ' + u);
    }
    n[a] = p * 16 + c;
  }
  return n;
}
function Fa(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function cr(e) {
  return typeof e == "string" && (e = Fa(e)), an(e), e;
}
function Ra(...e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    an(a), t += a.length;
  }
  const r = new Uint8Array(t);
  for (let n = 0, a = 0; n < e.length; n++) {
    const u = e[n];
    r.set(u, a), a += u.length;
  }
  return r;
}
class Ti {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function Pa(e) {
  const t = (n) => e().update(cr(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function $a(e) {
  const t = (n, a) => e(a).update(cr(n)).digest(), r = e({});
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (n) => e(n), t;
}
function Va(e = 32) {
  if (Kn && typeof Kn.getRandomValues == "function")
    return Kn.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
const za = /* @__PURE__ */ new Uint8Array([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3
]);
class ja extends Ti {
  constructor(t, r, n = {}, a, u, p) {
    if (super(), this.blockLen = t, this.outputLen = r, this.length = 0, this.pos = 0, this.finished = !1, this.destroyed = !1, Qr(t), Qr(r), Qr(a), r < 0 || r > a)
      throw new Error("outputLen bigger than keyLen");
    if (n.key !== void 0 && (n.key.length < 1 || n.key.length > a))
      throw new Error(`key must be up 1..${a} byte long or undefined`);
    if (n.salt !== void 0 && n.salt.length !== u)
      throw new Error(`salt must be ${u} byte long or undefined`);
    if (n.personalization !== void 0 && n.personalization.length !== p)
      throw new Error(`personalization must be ${p} byte long or undefined`);
    this.buffer32 = On(this.buffer = new Uint8Array(t));
  }
  update(t) {
    Rr(this);
    const { blockLen: r, buffer: n, buffer32: a } = this;
    t = cr(t);
    const u = t.length, p = t.byteOffset, c = t.buffer;
    for (let y = 0; y < u; ) {
      this.pos === r && (xr || Tr(a), this.compress(a, 0, !1), xr || Tr(a), this.pos = 0);
      const m = Math.min(r - this.pos, u - y), T = p + y;
      if (m === r && !(T % 4) && y + m < u) {
        const v = new Uint32Array(c, T, Math.floor((u - y) / 4));
        xr || Tr(v);
        for (let V = 0; y + r < u; V += a.length, y += r)
          this.length += r, this.compress(v, V, !1);
        xr || Tr(v);
        continue;
      }
      n.set(t.subarray(y, y + m), this.pos), this.pos += m, this.length += m, y += m;
    }
    return this;
  }
  digestInto(t) {
    Rr(this), zs(t, this);
    const { pos: r, buffer32: n } = this;
    this.finished = !0, this.buffer.subarray(r).fill(0), xr || Tr(n), this.compress(n, 0, !0), xr || Tr(n);
    const a = On(t);
    this.get().forEach((u, p) => a[p] = Ke(u));
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    const { buffer: r, length: n, finished: a, destroyed: u, outputLen: p, pos: c } = this;
    return t || (t = new this.constructor({ dkLen: p })), t.set(...this.get()), t.length = n, t.finished = a, t.destroyed = u, t.outputLen = p, t.buffer.set(r), t.pos = c, t;
  }
}
const gn = /* @__PURE__ */ BigInt(2 ** 32 - 1), ai = /* @__PURE__ */ BigInt(32);
function Gs(e, t = !1) {
  return t ? { h: Number(e & gn), l: Number(e >> ai & gn) } : { h: Number(e >> ai & gn) | 0, l: Number(e & gn) | 0 };
}
function qa(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let a = 0; a < e.length; a++) {
    const { h: u, l: p } = Gs(e[a], t);
    [r[a], n[a]] = [u, p];
  }
  return [r, n];
}
const Ga = (e, t) => BigInt(e >>> 0) << ai | BigInt(t >>> 0), Ya = (e, t, r) => e >>> r, Wa = (e, t, r) => e << 32 - r | t >>> r, Ha = (e, t, r) => e >>> r | t << 32 - r, Ka = (e, t, r) => e << 32 - r | t >>> r, Za = (e, t, r) => e << 64 - r | t >>> r - 32, Xa = (e, t, r) => e >>> r - 32 | t << 64 - r, Ja = (e, t) => t, Qa = (e, t) => e, tf = (e, t, r) => e << r | t >>> 32 - r, ef = (e, t, r) => t << r | e >>> 32 - r, rf = (e, t, r) => t << r - 32 | e >>> 64 - r, nf = (e, t, r) => e << r - 32 | t >>> 64 - r;
function sf(e, t, r, n) {
  const a = (t >>> 0) + (n >>> 0);
  return { h: e + r + (a / 2 ** 32 | 0) | 0, l: a | 0 };
}
const of = (e, t, r) => (e >>> 0) + (t >>> 0) + (r >>> 0), af = (e, t, r, n) => t + r + n + (e / 2 ** 32 | 0) | 0, ff = (e, t, r, n) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0), cf = (e, t, r, n, a) => t + r + n + a + (e / 2 ** 32 | 0) | 0, uf = (e, t, r, n, a) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (a >>> 0), lf = (e, t, r, n, a, u) => t + r + n + a + u + (e / 2 ** 32 | 0) | 0, ge = {
  fromBig: Gs,
  split: qa,
  toBig: Ga,
  shrSH: Ya,
  shrSL: Wa,
  rotrSH: Ha,
  rotrSL: Ka,
  rotrBH: Za,
  rotrBL: Xa,
  rotr32H: Ja,
  rotr32L: Qa,
  rotlSH: tf,
  rotlSL: ef,
  rotlBH: rf,
  rotlBL: nf,
  add: sf,
  add3L: of,
  add3H: af,
  add4L: ff,
  add4H: cf,
  add5H: lf,
  add5L: uf
}, oe = /* @__PURE__ */ new Uint32Array([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), G = /* @__PURE__ */ new Uint32Array(32);
function er(e, t, r, n, a, u) {
  const p = a[u], c = a[u + 1];
  let y = G[2 * e], m = G[2 * e + 1], T = G[2 * t], v = G[2 * t + 1], V = G[2 * r], M = G[2 * r + 1], F = G[2 * n], N = G[2 * n + 1], D = ge.add3L(y, T, p);
  m = ge.add3H(D, m, v, c), y = D | 0, { Dh: N, Dl: F } = { Dh: N ^ m, Dl: F ^ y }, { Dh: N, Dl: F } = { Dh: ge.rotr32H(N, F), Dl: ge.rotr32L(N, F) }, { h: M, l: V } = ge.add(M, V, N, F), { Bh: v, Bl: T } = { Bh: v ^ M, Bl: T ^ V }, { Bh: v, Bl: T } = { Bh: ge.rotrSH(v, T, 24), Bl: ge.rotrSL(v, T, 24) }, G[2 * e] = y, G[2 * e + 1] = m, G[2 * t] = T, G[2 * t + 1] = v, G[2 * r] = V, G[2 * r + 1] = M, G[2 * n] = F, G[2 * n + 1] = N;
}
function rr(e, t, r, n, a, u) {
  const p = a[u], c = a[u + 1];
  let y = G[2 * e], m = G[2 * e + 1], T = G[2 * t], v = G[2 * t + 1], V = G[2 * r], M = G[2 * r + 1], F = G[2 * n], N = G[2 * n + 1], D = ge.add3L(y, T, p);
  m = ge.add3H(D, m, v, c), y = D | 0, { Dh: N, Dl: F } = { Dh: N ^ m, Dl: F ^ y }, { Dh: N, Dl: F } = { Dh: ge.rotrSH(N, F, 16), Dl: ge.rotrSL(N, F, 16) }, { h: M, l: V } = ge.add(M, V, N, F), { Bh: v, Bl: T } = { Bh: v ^ M, Bl: T ^ V }, { Bh: v, Bl: T } = { Bh: ge.rotrBH(v, T, 63), Bl: ge.rotrBL(v, T, 63) }, G[2 * e] = y, G[2 * e + 1] = m, G[2 * t] = T, G[2 * t + 1] = v, G[2 * r] = V, G[2 * r + 1] = M, G[2 * n] = F, G[2 * n + 1] = N;
}
class hf extends ja {
  constructor(t = {}) {
    super(128, t.dkLen === void 0 ? 64 : t.dkLen, t, 64, 16, 16), this.v0l = oe[0] | 0, this.v0h = oe[1] | 0, this.v1l = oe[2] | 0, this.v1h = oe[3] | 0, this.v2l = oe[4] | 0, this.v2h = oe[5] | 0, this.v3l = oe[6] | 0, this.v3h = oe[7] | 0, this.v4l = oe[8] | 0, this.v4h = oe[9] | 0, this.v5l = oe[10] | 0, this.v5h = oe[11] | 0, this.v6l = oe[12] | 0, this.v6h = oe[13] | 0, this.v7l = oe[14] | 0, this.v7h = oe[15] | 0;
    const r = t.key ? t.key.length : 0;
    if (this.v0l ^= this.outputLen | r << 8 | 65536 | 1 << 24, t.salt) {
      const n = On(cr(t.salt));
      this.v4l ^= Ke(n[0]), this.v4h ^= Ke(n[1]), this.v5l ^= Ke(n[2]), this.v5h ^= Ke(n[3]);
    }
    if (t.personalization) {
      const n = On(cr(t.personalization));
      this.v6l ^= Ke(n[0]), this.v6h ^= Ke(n[1]), this.v7l ^= Ke(n[2]), this.v7h ^= Ke(n[3]);
    }
    if (t.key) {
      const n = new Uint8Array(this.blockLen);
      n.set(cr(t.key)), this.update(n);
    }
  }
  // prettier-ignore
  get() {
    let { v0l: t, v0h: r, v1l: n, v1h: a, v2l: u, v2h: p, v3l: c, v3h: y, v4l: m, v4h: T, v5l: v, v5h: V, v6l: M, v6h: F, v7l: N, v7h: D } = this;
    return [t, r, n, a, u, p, c, y, m, T, v, V, M, F, N, D];
  }
  // prettier-ignore
  set(t, r, n, a, u, p, c, y, m, T, v, V, M, F, N, D) {
    this.v0l = t | 0, this.v0h = r | 0, this.v1l = n | 0, this.v1h = a | 0, this.v2l = u | 0, this.v2h = p | 0, this.v3l = c | 0, this.v3h = y | 0, this.v4l = m | 0, this.v4h = T | 0, this.v5l = v | 0, this.v5h = V | 0, this.v6l = M | 0, this.v6h = F | 0, this.v7l = N | 0, this.v7h = D | 0;
  }
  compress(t, r, n) {
    this.get().forEach((y, m) => G[m] = y), G.set(oe, 16);
    let { h: a, l: u } = ge.fromBig(BigInt(this.length));
    G[24] = oe[8] ^ u, G[25] = oe[9] ^ a, n && (G[28] = ~G[28], G[29] = ~G[29]);
    let p = 0;
    const c = za;
    for (let y = 0; y < 12; y++)
      er(0, 4, 8, 12, t, r + 2 * c[p++]), rr(0, 4, 8, 12, t, r + 2 * c[p++]), er(1, 5, 9, 13, t, r + 2 * c[p++]), rr(1, 5, 9, 13, t, r + 2 * c[p++]), er(2, 6, 10, 14, t, r + 2 * c[p++]), rr(2, 6, 10, 14, t, r + 2 * c[p++]), er(3, 7, 11, 15, t, r + 2 * c[p++]), rr(3, 7, 11, 15, t, r + 2 * c[p++]), er(0, 5, 10, 15, t, r + 2 * c[p++]), rr(0, 5, 10, 15, t, r + 2 * c[p++]), er(1, 6, 11, 12, t, r + 2 * c[p++]), rr(1, 6, 11, 12, t, r + 2 * c[p++]), er(2, 7, 8, 13, t, r + 2 * c[p++]), rr(2, 7, 8, 13, t, r + 2 * c[p++]), er(3, 4, 9, 14, t, r + 2 * c[p++]), rr(3, 4, 9, 14, t, r + 2 * c[p++]);
    this.v0l ^= G[0] ^ G[16], this.v0h ^= G[1] ^ G[17], this.v1l ^= G[2] ^ G[18], this.v1h ^= G[3] ^ G[19], this.v2l ^= G[4] ^ G[20], this.v2h ^= G[5] ^ G[21], this.v3l ^= G[6] ^ G[22], this.v3h ^= G[7] ^ G[23], this.v4l ^= G[8] ^ G[24], this.v4h ^= G[9] ^ G[25], this.v5l ^= G[10] ^ G[26], this.v5h ^= G[11] ^ G[27], this.v6l ^= G[12] ^ G[28], this.v6h ^= G[13] ^ G[29], this.v7l ^= G[14] ^ G[30], this.v7h ^= G[15] ^ G[31], G.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer32.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const kn = /* @__PURE__ */ $a((e) => new hf(e)), df = Symbol.for("@mysten/transaction");
function pf(e) {
  return !!e && typeof e == "object" && e[df] === !0;
}
const gf = Symbol.for("@mysten/SuiClient");
class xf {
  get [gf]() {
    return !0;
  }
  /**
   * Establish a connection to a Sui RPC endpoint
   *
   * @param options configuration options for the API Client
   */
  constructor(t) {
    this.transport = t.transport ?? new qo({ url: t.url });
  }
  async getRpcApiVersion() {
    return (await this.transport.request({
      method: "rpc.discover",
      params: []
    })).info.version;
  }
  /**
   * Get all Coin<`coin_type`> objects owned by an address.
   */
  async getCoins(t) {
    if (!t.owner || !ar(_e(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({
      method: "suix_getCoins",
      params: [t.owner, t.coinType, t.cursor, t.limit]
    });
  }
  /**
   * Get all Coin objects owned by an address.
   */
  async getAllCoins(t) {
    if (!t.owner || !ar(_e(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({
      method: "suix_getAllCoins",
      params: [t.owner, t.cursor, t.limit]
    });
  }
  /**
   * Get the total coin balance for one coin type, owned by the address owner.
   */
  async getBalance(t) {
    if (!t.owner || !ar(_e(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({
      method: "suix_getBalance",
      params: [t.owner, t.coinType]
    });
  }
  /**
   * Get the total coin balance for all coin types, owned by the address owner.
   */
  async getAllBalances(t) {
    if (!t.owner || !ar(_e(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({ method: "suix_getAllBalances", params: [t.owner] });
  }
  /**
   * Fetch CoinMetadata for a given coin type
   */
  async getCoinMetadata(t) {
    return await this.transport.request({
      method: "suix_getCoinMetadata",
      params: [t.coinType]
    });
  }
  /**
   *  Fetch total supply for a coin
   */
  async getTotalSupply(t) {
    return await this.transport.request({
      method: "suix_getTotalSupply",
      params: [t.coinType]
    });
  }
  /**
   * Invoke any RPC method
   * @param method the method to be invoked
   * @param args the arguments to be passed to the RPC request
   */
  async call(t, r) {
    return await this.transport.request({ method: t, params: r });
  }
  /**
   * Get Move function argument types like read, write and full access
   */
  async getMoveFunctionArgTypes(t) {
    return await this.transport.request({
      method: "sui_getMoveFunctionArgTypes",
      params: [t.package, t.module, t.function]
    });
  }
  /**
   * Get a map from module name to
   * structured representations of Move modules
   */
  async getNormalizedMoveModulesByPackage(t) {
    return await this.transport.request({
      method: "sui_getNormalizedMoveModulesByPackage",
      params: [t.package]
    });
  }
  /**
   * Get a structured representation of Move module
   */
  async getNormalizedMoveModule(t) {
    return await this.transport.request({
      method: "sui_getNormalizedMoveModule",
      params: [t.package, t.module]
    });
  }
  /**
   * Get a structured representation of Move function
   */
  async getNormalizedMoveFunction(t) {
    return await this.transport.request({
      method: "sui_getNormalizedMoveFunction",
      params: [t.package, t.module, t.function]
    });
  }
  /**
   * Get a structured representation of Move struct
   */
  async getNormalizedMoveStruct(t) {
    return await this.transport.request({
      method: "sui_getNormalizedMoveStruct",
      params: [t.package, t.module, t.struct]
    });
  }
  /**
   * Get all objects owned by an address
   */
  async getOwnedObjects(t) {
    if (!t.owner || !ar(_e(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({
      method: "suix_getOwnedObjects",
      params: [
        t.owner,
        {
          filter: t.filter,
          options: t.options
        },
        t.cursor,
        t.limit
      ]
    });
  }
  /**
   * Get details about an object
   */
  async getObject(t) {
    if (!t.id || !dn(pn(t.id)))
      throw new Error("Invalid Sui Object id");
    return await this.transport.request({
      method: "sui_getObject",
      params: [t.id, t.options]
    });
  }
  async tryGetPastObject(t) {
    return await this.transport.request({
      method: "sui_tryGetPastObject",
      params: [t.id, t.version, t.options]
    });
  }
  /**
   * Batch get details about a list of objects. If any of the object ids are duplicates the call will fail
   */
  async multiGetObjects(t) {
    if (t.ids.forEach((n) => {
      if (!n || !dn(pn(n)))
        throw new Error(`Invalid Sui Object id ${n}`);
    }), t.ids.length !== new Set(t.ids).size)
      throw new Error(`Duplicate object ids in batch call ${t.ids}`);
    return await this.transport.request({
      method: "sui_multiGetObjects",
      params: [t.ids, t.options]
    });
  }
  /**
   * Get transaction blocks for a given query criteria
   */
  async queryTransactionBlocks(t) {
    return await this.transport.request({
      method: "suix_queryTransactionBlocks",
      params: [
        {
          filter: t.filter,
          options: t.options
        },
        t.cursor,
        t.limit,
        (t.order || "descending") === "descending"
      ]
    });
  }
  async getTransactionBlock(t) {
    if (!$i(t.digest))
      throw new Error("Invalid Transaction digest");
    return await this.transport.request({
      method: "sui_getTransactionBlock",
      params: [t.digest, t.options]
    });
  }
  async multiGetTransactionBlocks(t) {
    if (t.digests.forEach((n) => {
      if (!$i(n))
        throw new Error(`Invalid Transaction digest ${n}`);
    }), t.digests.length !== new Set(t.digests).size)
      throw new Error(`Duplicate digests in batch call ${t.digests}`);
    return await this.transport.request({
      method: "sui_multiGetTransactionBlocks",
      params: [t.digests, t.options]
    });
  }
  async executeTransactionBlock(t) {
    return await this.transport.request({
      method: "sui_executeTransactionBlock",
      params: [
        typeof t.transactionBlock == "string" ? t.transactionBlock : ee(t.transactionBlock),
        Array.isArray(t.signature) ? t.signature : [t.signature],
        t.options,
        t.requestType
      ]
    });
  }
  async signAndExecuteTransaction({
    transaction: t,
    signer: r,
    ...n
  }) {
    let a;
    t instanceof Uint8Array ? a = t : (t.setSenderIfNotSet(r.toSuiAddress()), a = await t.build({ client: this }));
    const { signature: u, bytes: p } = await r.signTransaction(a);
    return this.executeTransactionBlock({
      transactionBlock: p,
      signature: u,
      ...n
    });
  }
  /**
   * Get total number of transactions
   */
  async getTotalTransactionBlocks() {
    const t = await this.transport.request({
      method: "sui_getTotalTransactionBlocks",
      params: []
    });
    return BigInt(t);
  }
  /**
   * Getting the reference gas price for the network
   */
  async getReferenceGasPrice() {
    const t = await this.transport.request({
      method: "suix_getReferenceGasPrice",
      params: []
    });
    return BigInt(t);
  }
  /**
   * Return the delegated stakes for an address
   */
  async getStakes(t) {
    if (!t.owner || !ar(_e(t.owner)))
      throw new Error("Invalid Sui address");
    return await this.transport.request({ method: "suix_getStakes", params: [t.owner] });
  }
  /**
   * Return the delegated stakes queried by id.
   */
  async getStakesByIds(t) {
    return t.stakedSuiIds.forEach((r) => {
      if (!r || !dn(pn(r)))
        throw new Error(`Invalid Sui Stake id ${r}`);
    }), await this.transport.request({
      method: "suix_getStakesByIds",
      params: [t.stakedSuiIds]
    });
  }
  /**
   * Return the latest system state content.
   */
  async getLatestSuiSystemState() {
    return await this.transport.request({ method: "suix_getLatestSuiSystemState", params: [] });
  }
  /**
   * Get events for a given query criteria
   */
  async queryEvents(t) {
    return await this.transport.request({
      method: "suix_queryEvents",
      params: [
        t.query,
        t.cursor,
        t.limit,
        (t.order || "descending") === "descending"
      ]
    });
  }
  /**
   * Subscribe to get notifications whenever an event matching the filter occurs
   */
  async subscribeEvent(t) {
    return this.transport.subscribe({
      method: "suix_subscribeEvent",
      unsubscribe: "suix_unsubscribeEvent",
      params: [t.filter],
      onMessage: t.onMessage
    });
  }
  async subscribeTransaction(t) {
    return this.transport.subscribe({
      method: "suix_subscribeTransaction",
      unsubscribe: "suix_unsubscribeTransaction",
      params: [t.filter],
      onMessage: t.onMessage
    });
  }
  /**
   * Runs the transaction block in dev-inspect mode. Which allows for nearly any
   * transaction (or Move call) with any arguments. Detailed results are
   * provided, including both the transaction effects and any return values.
   */
  async devInspectTransactionBlock(t) {
    var n;
    let r;
    if (pf(t.transactionBlock))
      t.transactionBlock.setSenderIfNotSet(t.sender), r = ee(
        await t.transactionBlock.build({
          client: this,
          onlyTransactionKind: !0
        })
      );
    else if (typeof t.transactionBlock == "string")
      r = t.transactionBlock;
    else if (t.transactionBlock instanceof Uint8Array)
      r = ee(t.transactionBlock);
    else
      throw new Error("Unknown transaction block format.");
    return await this.transport.request({
      method: "sui_devInspectTransactionBlock",
      params: [t.sender, r, (n = t.gasPrice) == null ? void 0 : n.toString(), t.epoch]
    });
  }
  /**
   * Dry run a transaction block and return the result.
   */
  async dryRunTransactionBlock(t) {
    return await this.transport.request({
      method: "sui_dryRunTransactionBlock",
      params: [
        typeof t.transactionBlock == "string" ? t.transactionBlock : ee(t.transactionBlock)
      ]
    });
  }
  /**
   * Return the list of dynamic field objects owned by an object
   */
  async getDynamicFields(t) {
    if (!t.parentId || !dn(pn(t.parentId)))
      throw new Error("Invalid Sui Object id");
    return await this.transport.request({
      method: "suix_getDynamicFields",
      params: [t.parentId, t.cursor, t.limit]
    });
  }
  /**
   * Return the dynamic field object information for a specified object
   */
  async getDynamicFieldObject(t) {
    return await this.transport.request({
      method: "suix_getDynamicFieldObject",
      params: [t.parentId, t.name]
    });
  }
  /**
   * Get the sequence number of the latest checkpoint that has been executed
   */
  async getLatestCheckpointSequenceNumber() {
    const t = await this.transport.request({
      method: "sui_getLatestCheckpointSequenceNumber",
      params: []
    });
    return String(t);
  }
  /**
   * Returns information about a given checkpoint
   */
  async getCheckpoint(t) {
    return await this.transport.request({ method: "sui_getCheckpoint", params: [t.id] });
  }
  /**
   * Returns historical checkpoints paginated
   */
  async getCheckpoints(t) {
    return await this.transport.request({
      method: "sui_getCheckpoints",
      params: [t.cursor, t == null ? void 0 : t.limit, t.descendingOrder]
    });
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getCommitteeInfo(t) {
    return await this.transport.request({
      method: "suix_getCommitteeInfo",
      params: [t == null ? void 0 : t.epoch]
    });
  }
  async getNetworkMetrics() {
    return await this.transport.request({ method: "suix_getNetworkMetrics", params: [] });
  }
  async getAddressMetrics() {
    return await this.transport.request({ method: "suix_getLatestAddressMetrics", params: [] });
  }
  async getEpochMetrics(t) {
    return await this.transport.request({
      method: "suix_getEpochMetrics",
      params: [t == null ? void 0 : t.cursor, t == null ? void 0 : t.limit, t == null ? void 0 : t.descendingOrder]
    });
  }
  async getAllEpochAddressMetrics(t) {
    return await this.transport.request({
      method: "suix_getAllEpochAddressMetrics",
      params: [t == null ? void 0 : t.descendingOrder]
    });
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getEpochs(t) {
    return await this.transport.request({
      method: "suix_getEpochs",
      params: [t == null ? void 0 : t.cursor, t == null ? void 0 : t.limit, t == null ? void 0 : t.descendingOrder]
    });
  }
  /**
   * Returns list of top move calls by usage
   */
  async getMoveCallMetrics() {
    return await this.transport.request({ method: "suix_getMoveCallMetrics", params: [] });
  }
  /**
   * Return the committee information for the asked epoch
   */
  async getCurrentEpoch() {
    return await this.transport.request({ method: "suix_getCurrentEpoch", params: [] });
  }
  /**
   * Return the Validators APYs
   */
  async getValidatorsApy() {
    return await this.transport.request({ method: "suix_getValidatorsApy", params: [] });
  }
  // TODO: Migrate this to `sui_getChainIdentifier` once it is widely available.
  async getChainIdentifier() {
    const t = await this.getCheckpoint({ id: "0" }), r = rn(t.digest);
    return nn(r.slice(0, 4));
  }
  async resolveNameServiceAddress(t) {
    return await this.transport.request({
      method: "suix_resolveNameServiceAddress",
      params: [t.name]
    });
  }
  async resolveNameServiceNames({
    format: t = "dot",
    ...r
  }) {
    const { nextCursor: n, hasNextPage: a, data: u } = await this.transport.request({
      method: "suix_resolveNameServiceNames",
      params: [r.address, r.cursor, r.limit]
    });
    return {
      hasNextPage: a,
      nextCursor: n,
      data: u.map((p) => ka(p, t))
    };
  }
  async getProtocolConfig(t) {
    return await this.transport.request({
      method: "sui_getProtocolConfig",
      params: [t == null ? void 0 : t.version]
    });
  }
  /**
   * Wait for a transaction block result to be available over the API.
   * This can be used in conjunction with `executeTransactionBlock` to wait for the transaction to
   * be available via the API.
   * This currently polls the `getTransactionBlock` API to check for the transaction.
   */
  async waitForTransaction({
    signal: t,
    timeout: r = 60 * 1e3,
    pollInterval: n = 2 * 1e3,
    ...a
  }) {
    const u = AbortSignal.timeout(r), p = new Promise((c, y) => {
      u.addEventListener("abort", () => y(u.reason));
    });
    for (p.catch(() => {
    }); !u.aborted; ) {
      t == null || t.throwIfAborted();
      try {
        return await this.getTransactionBlock(a);
      } catch {
        await Promise.race([
          new Promise((y) => setTimeout(y, n)),
          p
        ]);
      }
    }
    throw u.throwIfAborted(), new Error("Unexpected error while waiting for transaction block.");
  }
}
const qe = {
  LOCALNET: "localnet",
  DEVNET: "devnet",
  TESTNET: "testnet",
  MAINNET: "mainnet"
}, yf = {
  [qe.LOCALNET]: "http://127.0.0.1:9000",
  [qe.DEVNET]: "https://fullnode.devnet.sui.io:443",
  [qe.TESTNET]: "https://fullnode.testnet.sui.io:443",
  [qe.MAINNET]: "https://fullnode.mainnet.sui.io:443"
}, wf = {
  [qe.LOCALNET]: "https://sui-devnet.mystenlabs.com/graphql",
  [qe.DEVNET]: "https://sui-devnet.mystenlabs.com/graphql",
  [qe.TESTNET]: "https://sui-testnet.mystenlabs.com/graphql",
  [qe.MAINNET]: "https://sui-mainnet.mystenlabs.com/graphql"
}, Ys = {
  SIGN_TRANSACTION: "signTransaction",
  SIGN_PERSONAL_MESSAGE: "signPersonalMessage"
}, bf = {
  ERROR: "ERROR",
  INIT: "INIT",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT"
}, tn = {
  LOCAL: "local",
  STAGING: "staging",
  PROD: "prod"
}, Xn = {
  PROD: "https://sui.credenza3.com",
  STAGING: "https://sui.staging.credenza3.com",
  LOCAL: "http://localhost:8083"
};
function Ws(e) {
  switch (e.env) {
    case tn.LOCAL:
      return Xn.LOCAL;
    case tn.STAGING:
      return Xn.STAGING;
    case tn.PROD:
      return Xn.PROD;
    default:
      throw new Error("Invalid sdk env");
  }
}
async function mf(e) {
  try {
    const t = await fetch(`${Ws(e)}/accounts/address`, {
      headers: {
        Authorization: `Bearer ${e.getAccessToken()}`
      }
    });
    if (!t.ok) throw new Error(t.statusText);
    return await t.json();
  } catch (t) {
    throw new Error(`Error requesting SUI address: ${t.message}`);
  }
}
async function Hs(e, t) {
  try {
    const r = await fetch(`${Ws(e)}/accounts/sign`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${e.getAccessToken()}`,
        "Content-type": "application/json"
      },
      body: JSON.stringify(t)
    });
    if (!r.ok) throw new Error(r.statusText);
    return await await r.json();
  } catch (r) {
    throw new Error(`Error Signing SUI data: ${r.message}`);
  }
}
var Ni = {}, Fn = {};
Fn.byteLength = vf;
Fn.toByteArray = If;
Fn.fromByteArray = Tf;
var je = [], ke = [], Ef = typeof Uint8Array < "u" ? Uint8Array : Array, Jn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Nr = 0, Sf = Jn.length; Nr < Sf; ++Nr)
  je[Nr] = Jn[Nr], ke[Jn.charCodeAt(Nr)] = Nr;
ke[45] = 62;
ke[95] = 63;
function Ks(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = e.indexOf("=");
  r === -1 && (r = t);
  var n = r === t ? 0 : 4 - r % 4;
  return [r, n];
}
function vf(e) {
  var t = Ks(e), r = t[0], n = t[1];
  return (r + n) * 3 / 4 - n;
}
function Bf(e, t, r) {
  return (t + r) * 3 / 4 - r;
}
function If(e) {
  var t, r = Ks(e), n = r[0], a = r[1], u = new Ef(Bf(e, n, a)), p = 0, c = a > 0 ? n - 4 : n, y;
  for (y = 0; y < c; y += 4)
    t = ke[e.charCodeAt(y)] << 18 | ke[e.charCodeAt(y + 1)] << 12 | ke[e.charCodeAt(y + 2)] << 6 | ke[e.charCodeAt(y + 3)], u[p++] = t >> 16 & 255, u[p++] = t >> 8 & 255, u[p++] = t & 255;
  return a === 2 && (t = ke[e.charCodeAt(y)] << 2 | ke[e.charCodeAt(y + 1)] >> 4, u[p++] = t & 255), a === 1 && (t = ke[e.charCodeAt(y)] << 10 | ke[e.charCodeAt(y + 1)] << 4 | ke[e.charCodeAt(y + 2)] >> 2, u[p++] = t >> 8 & 255, u[p++] = t & 255), u;
}
function Af(e) {
  return je[e >> 18 & 63] + je[e >> 12 & 63] + je[e >> 6 & 63] + je[e & 63];
}
function _f(e, t, r) {
  for (var n, a = [], u = t; u < r; u += 3)
    n = (e[u] << 16 & 16711680) + (e[u + 1] << 8 & 65280) + (e[u + 2] & 255), a.push(Af(n));
  return a.join("");
}
function Tf(e) {
  for (var t, r = e.length, n = r % 3, a = [], u = 16383, p = 0, c = r - n; p < c; p += u)
    a.push(_f(e, p, p + u > c ? c : p + u));
  return n === 1 ? (t = e[r - 1], a.push(
    je[t >> 2] + je[t << 4 & 63] + "=="
  )) : n === 2 && (t = (e[r - 2] << 8) + e[r - 1], a.push(
    je[t >> 10] + je[t >> 4 & 63] + je[t << 2 & 63] + "="
  )), a.join("");
}
var Ui = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
Ui.read = function(e, t, r, n, a) {
  var u, p, c = a * 8 - n - 1, y = (1 << c) - 1, m = y >> 1, T = -7, v = r ? a - 1 : 0, V = r ? -1 : 1, M = e[t + v];
  for (v += V, u = M & (1 << -T) - 1, M >>= -T, T += c; T > 0; u = u * 256 + e[t + v], v += V, T -= 8)
    ;
  for (p = u & (1 << -T) - 1, u >>= -T, T += n; T > 0; p = p * 256 + e[t + v], v += V, T -= 8)
    ;
  if (u === 0)
    u = 1 - m;
  else {
    if (u === y)
      return p ? NaN : (M ? -1 : 1) * (1 / 0);
    p = p + Math.pow(2, n), u = u - m;
  }
  return (M ? -1 : 1) * p * Math.pow(2, u - n);
};
Ui.write = function(e, t, r, n, a, u) {
  var p, c, y, m = u * 8 - a - 1, T = (1 << m) - 1, v = T >> 1, V = a === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, M = n ? 0 : u - 1, F = n ? 1 : -1, N = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (c = isNaN(t) ? 1 : 0, p = T) : (p = Math.floor(Math.log(t) / Math.LN2), t * (y = Math.pow(2, -p)) < 1 && (p--, y *= 2), p + v >= 1 ? t += V / y : t += V * Math.pow(2, 1 - v), t * y >= 2 && (p++, y /= 2), p + v >= T ? (c = 0, p = T) : p + v >= 1 ? (c = (t * y - 1) * Math.pow(2, a), p = p + v) : (c = t * Math.pow(2, v - 1) * Math.pow(2, a), p = 0)); a >= 8; e[r + M] = c & 255, M += F, c /= 256, a -= 8)
    ;
  for (p = p << a | c, m += a; m > 0; e[r + M] = p & 255, M += F, p /= 256, m -= 8)
    ;
  e[r + M - F] |= N * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = Fn, r = Ui, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = c, e.SlowBuffer = et, e.INSPECT_MAX_BYTES = 50;
  const a = 2147483647;
  e.kMaxLength = a, c.TYPED_ARRAY_SUPPORT = u(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function u() {
    try {
      const h = new Uint8Array(1), s = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(s, Uint8Array.prototype), Object.setPrototypeOf(h, s), h.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(c.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(c.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.byteOffset;
    }
  });
  function p(h) {
    if (h > a)
      throw new RangeError('The value "' + h + '" is invalid for option "size"');
    const s = new Uint8Array(h);
    return Object.setPrototypeOf(s, c.prototype), s;
  }
  function c(h, s, o) {
    if (typeof h == "number") {
      if (typeof s == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return v(h);
    }
    return y(h, s, o);
  }
  c.poolSize = 8192;
  function y(h, s, o) {
    if (typeof h == "string")
      return V(h, s);
    if (ArrayBuffer.isView(h))
      return F(h);
    if (h == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof h
      );
    if (Ee(h, ArrayBuffer) || h && Ee(h.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (Ee(h, SharedArrayBuffer) || h && Ee(h.buffer, SharedArrayBuffer)))
      return N(h, s, o);
    if (typeof h == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const x = h.valueOf && h.valueOf();
    if (x != null && x !== h)
      return c.from(x, s, o);
    const E = D(h);
    if (E) return E;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof h[Symbol.toPrimitive] == "function")
      return c.from(h[Symbol.toPrimitive]("string"), s, o);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof h
    );
  }
  c.from = function(h, s, o) {
    return y(h, s, o);
  }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array);
  function m(h) {
    if (typeof h != "number")
      throw new TypeError('"size" argument must be of type number');
    if (h < 0)
      throw new RangeError('The value "' + h + '" is invalid for option "size"');
  }
  function T(h, s, o) {
    return m(h), h <= 0 ? p(h) : s !== void 0 ? typeof o == "string" ? p(h).fill(s, o) : p(h).fill(s) : p(h);
  }
  c.alloc = function(h, s, o) {
    return T(h, s, o);
  };
  function v(h) {
    return m(h), p(h < 0 ? 0 : P(h) | 0);
  }
  c.allocUnsafe = function(h) {
    return v(h);
  }, c.allocUnsafeSlow = function(h) {
    return v(h);
  };
  function V(h, s) {
    if ((typeof s != "string" || s === "") && (s = "utf8"), !c.isEncoding(s))
      throw new TypeError("Unknown encoding: " + s);
    const o = K(h, s) | 0;
    let x = p(o);
    const E = x.write(h, s);
    return E !== o && (x = x.slice(0, E)), x;
  }
  function M(h) {
    const s = h.length < 0 ? 0 : P(h.length) | 0, o = p(s);
    for (let x = 0; x < s; x += 1)
      o[x] = h[x] & 255;
    return o;
  }
  function F(h) {
    if (Ee(h, Uint8Array)) {
      const s = new Uint8Array(h);
      return N(s.buffer, s.byteOffset, s.byteLength);
    }
    return M(h);
  }
  function N(h, s, o) {
    if (s < 0 || h.byteLength < s)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (h.byteLength < s + (o || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let x;
    return s === void 0 && o === void 0 ? x = new Uint8Array(h) : o === void 0 ? x = new Uint8Array(h, s) : x = new Uint8Array(h, s, o), Object.setPrototypeOf(x, c.prototype), x;
  }
  function D(h) {
    if (c.isBuffer(h)) {
      const s = P(h.length) | 0, o = p(s);
      return o.length === 0 || h.copy(o, 0, 0, s), o;
    }
    if (h.length !== void 0)
      return typeof h.length != "number" || dr(h.length) ? p(0) : M(h);
    if (h.type === "Buffer" && Array.isArray(h.data))
      return M(h.data);
  }
  function P(h) {
    if (h >= a)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
    return h | 0;
  }
  function et(h) {
    return +h != h && (h = 0), c.alloc(+h);
  }
  c.isBuffer = function(s) {
    return s != null && s._isBuffer === !0 && s !== c.prototype;
  }, c.compare = function(s, o) {
    if (Ee(s, Uint8Array) && (s = c.from(s, s.offset, s.byteLength)), Ee(o, Uint8Array) && (o = c.from(o, o.offset, o.byteLength)), !c.isBuffer(s) || !c.isBuffer(o))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (s === o) return 0;
    let x = s.length, E = o.length;
    for (let I = 0, U = Math.min(x, E); I < U; ++I)
      if (s[I] !== o[I]) {
        x = s[I], E = o[I];
        break;
      }
    return x < E ? -1 : E < x ? 1 : 0;
  }, c.isEncoding = function(s) {
    switch (String(s).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, c.concat = function(s, o) {
    if (!Array.isArray(s))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (s.length === 0)
      return c.alloc(0);
    let x;
    if (o === void 0)
      for (o = 0, x = 0; x < s.length; ++x)
        o += s[x].length;
    const E = c.allocUnsafe(o);
    let I = 0;
    for (x = 0; x < s.length; ++x) {
      let U = s[x];
      if (Ee(U, Uint8Array))
        I + U.length > E.length ? (c.isBuffer(U) || (U = c.from(U)), U.copy(E, I)) : Uint8Array.prototype.set.call(
          E,
          U,
          I
        );
      else if (c.isBuffer(U))
        U.copy(E, I);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      I += U.length;
    }
    return E;
  };
  function K(h, s) {
    if (c.isBuffer(h))
      return h.length;
    if (ArrayBuffer.isView(h) || Ee(h, ArrayBuffer))
      return h.byteLength;
    if (typeof h != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof h
      );
    const o = h.length, x = arguments.length > 2 && arguments[2] === !0;
    if (!x && o === 0) return 0;
    let E = !1;
    for (; ; )
      switch (s) {
        case "ascii":
        case "latin1":
        case "binary":
          return o;
        case "utf8":
        case "utf-8":
          return Br(h).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return o * 2;
        case "hex":
          return o >>> 1;
        case "base64":
          return lr(h).length;
        default:
          if (E)
            return x ? -1 : Br(h).length;
          s = ("" + s).toLowerCase(), E = !0;
      }
  }
  c.byteLength = K;
  function ot(h, s, o) {
    let x = !1;
    if ((s === void 0 || s < 0) && (s = 0), s > this.length || ((o === void 0 || o > this.length) && (o = this.length), o <= 0) || (o >>>= 0, s >>>= 0, o <= s))
      return "";
    for (h || (h = "utf8"); ; )
      switch (h) {
        case "hex":
          return _t(this, s, o);
        case "utf8":
        case "utf-8":
          return pe(this, s, o);
        case "ascii":
          return yt(this, s, o);
        case "latin1":
        case "binary":
          return Ut(this, s, o);
        case "base64":
          return ae(this, s, o);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Gt(this, s, o);
        default:
          if (x) throw new TypeError("Unknown encoding: " + h);
          h = (h + "").toLowerCase(), x = !0;
      }
  }
  c.prototype._isBuffer = !0;
  function nt(h, s, o) {
    const x = h[s];
    h[s] = h[o], h[o] = x;
  }
  c.prototype.swap16 = function() {
    const s = this.length;
    if (s % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let o = 0; o < s; o += 2)
      nt(this, o, o + 1);
    return this;
  }, c.prototype.swap32 = function() {
    const s = this.length;
    if (s % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let o = 0; o < s; o += 4)
      nt(this, o, o + 3), nt(this, o + 1, o + 2);
    return this;
  }, c.prototype.swap64 = function() {
    const s = this.length;
    if (s % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let o = 0; o < s; o += 8)
      nt(this, o, o + 7), nt(this, o + 1, o + 6), nt(this, o + 2, o + 5), nt(this, o + 3, o + 4);
    return this;
  }, c.prototype.toString = function() {
    const s = this.length;
    return s === 0 ? "" : arguments.length === 0 ? pe(this, 0, s) : ot.apply(this, arguments);
  }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(s) {
    if (!c.isBuffer(s)) throw new TypeError("Argument must be a Buffer");
    return this === s ? !0 : c.compare(this, s) === 0;
  }, c.prototype.inspect = function() {
    let s = "";
    const o = e.INSPECT_MAX_BYTES;
    return s = this.toString("hex", 0, o).replace(/(.{2})/g, "$1 ").trim(), this.length > o && (s += " ... "), "<Buffer " + s + ">";
  }, n && (c.prototype[n] = c.prototype.inspect), c.prototype.compare = function(s, o, x, E, I) {
    if (Ee(s, Uint8Array) && (s = c.from(s, s.offset, s.byteLength)), !c.isBuffer(s))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof s
      );
    if (o === void 0 && (o = 0), x === void 0 && (x = s ? s.length : 0), E === void 0 && (E = 0), I === void 0 && (I = this.length), o < 0 || x > s.length || E < 0 || I > this.length)
      throw new RangeError("out of range index");
    if (E >= I && o >= x)
      return 0;
    if (E >= I)
      return -1;
    if (o >= x)
      return 1;
    if (o >>>= 0, x >>>= 0, E >>>= 0, I >>>= 0, this === s) return 0;
    let U = I - E, xt = x - o;
    const Vt = Math.min(U, xt), $t = this.slice(E, I), jt = s.slice(o, x);
    for (let Mt = 0; Mt < Vt; ++Mt)
      if ($t[Mt] !== jt[Mt]) {
        U = $t[Mt], xt = jt[Mt];
        break;
      }
    return U < xt ? -1 : xt < U ? 1 : 0;
  };
  function j(h, s, o, x, E) {
    if (h.length === 0) return -1;
    if (typeof o == "string" ? (x = o, o = 0) : o > 2147483647 ? o = 2147483647 : o < -2147483648 && (o = -2147483648), o = +o, dr(o) && (o = E ? 0 : h.length - 1), o < 0 && (o = h.length + o), o >= h.length) {
      if (E) return -1;
      o = h.length - 1;
    } else if (o < 0)
      if (E) o = 0;
      else return -1;
    if (typeof s == "string" && (s = c.from(s, x)), c.isBuffer(s))
      return s.length === 0 ? -1 : it(h, s, o, x, E);
    if (typeof s == "number")
      return s = s & 255, typeof Uint8Array.prototype.indexOf == "function" ? E ? Uint8Array.prototype.indexOf.call(h, s, o) : Uint8Array.prototype.lastIndexOf.call(h, s, o) : it(h, [s], o, x, E);
    throw new TypeError("val must be string, number or Buffer");
  }
  function it(h, s, o, x, E) {
    let I = 1, U = h.length, xt = s.length;
    if (x !== void 0 && (x = String(x).toLowerCase(), x === "ucs2" || x === "ucs-2" || x === "utf16le" || x === "utf-16le")) {
      if (h.length < 2 || s.length < 2)
        return -1;
      I = 2, U /= 2, xt /= 2, o /= 2;
    }
    function Vt(jt, Mt) {
      return I === 1 ? jt[Mt] : jt.readUInt16BE(Mt * I);
    }
    let $t;
    if (E) {
      let jt = -1;
      for ($t = o; $t < U; $t++)
        if (Vt(h, $t) === Vt(s, jt === -1 ? 0 : $t - jt)) {
          if (jt === -1 && (jt = $t), $t - jt + 1 === xt) return jt * I;
        } else
          jt !== -1 && ($t -= $t - jt), jt = -1;
    } else
      for (o + xt > U && (o = U - xt), $t = o; $t >= 0; $t--) {
        let jt = !0;
        for (let Mt = 0; Mt < xt; Mt++)
          if (Vt(h, $t + Mt) !== Vt(s, Mt)) {
            jt = !1;
            break;
          }
        if (jt) return $t;
      }
    return -1;
  }
  c.prototype.includes = function(s, o, x) {
    return this.indexOf(s, o, x) !== -1;
  }, c.prototype.indexOf = function(s, o, x) {
    return j(this, s, o, x, !0);
  }, c.prototype.lastIndexOf = function(s, o, x) {
    return j(this, s, o, x, !1);
  };
  function lt(h, s, o, x) {
    o = Number(o) || 0;
    const E = h.length - o;
    x ? (x = Number(x), x > E && (x = E)) : x = E;
    const I = s.length;
    x > I / 2 && (x = I / 2);
    let U;
    for (U = 0; U < x; ++U) {
      const xt = parseInt(s.substr(U * 2, 2), 16);
      if (dr(xt)) return U;
      h[o + U] = xt;
    }
    return U;
  }
  function ce(h, s, o, x) {
    return hr(Br(s, h.length - o), h, o, x);
  }
  function Pt(h, s, o, x) {
    return hr(ln(s), h, o, x);
  }
  function At(h, s, o, x) {
    return hr(lr(s), h, o, x);
  }
  function ie(h, s, o, x) {
    return hr(Ge(s, h.length - o), h, o, x);
  }
  c.prototype.write = function(s, o, x, E) {
    if (o === void 0)
      E = "utf8", x = this.length, o = 0;
    else if (x === void 0 && typeof o == "string")
      E = o, x = this.length, o = 0;
    else if (isFinite(o))
      o = o >>> 0, isFinite(x) ? (x = x >>> 0, E === void 0 && (E = "utf8")) : (E = x, x = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const I = this.length - o;
    if ((x === void 0 || x > I) && (x = I), s.length > 0 && (x < 0 || o < 0) || o > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    E || (E = "utf8");
    let U = !1;
    for (; ; )
      switch (E) {
        case "hex":
          return lt(this, s, o, x);
        case "utf8":
        case "utf-8":
          return ce(this, s, o, x);
        case "ascii":
        case "latin1":
        case "binary":
          return Pt(this, s, o, x);
        case "base64":
          return At(this, s, o, x);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ie(this, s, o, x);
        default:
          if (U) throw new TypeError("Unknown encoding: " + E);
          E = ("" + E).toLowerCase(), U = !0;
      }
  }, c.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function ae(h, s, o) {
    return s === 0 && o === h.length ? t.fromByteArray(h) : t.fromByteArray(h.slice(s, o));
  }
  function pe(h, s, o) {
    o = Math.min(h.length, o);
    const x = [];
    let E = s;
    for (; E < o; ) {
      const I = h[E];
      let U = null, xt = I > 239 ? 4 : I > 223 ? 3 : I > 191 ? 2 : 1;
      if (E + xt <= o) {
        let Vt, $t, jt, Mt;
        switch (xt) {
          case 1:
            I < 128 && (U = I);
            break;
          case 2:
            Vt = h[E + 1], (Vt & 192) === 128 && (Mt = (I & 31) << 6 | Vt & 63, Mt > 127 && (U = Mt));
            break;
          case 3:
            Vt = h[E + 1], $t = h[E + 2], (Vt & 192) === 128 && ($t & 192) === 128 && (Mt = (I & 15) << 12 | (Vt & 63) << 6 | $t & 63, Mt > 2047 && (Mt < 55296 || Mt > 57343) && (U = Mt));
            break;
          case 4:
            Vt = h[E + 1], $t = h[E + 2], jt = h[E + 3], (Vt & 192) === 128 && ($t & 192) === 128 && (jt & 192) === 128 && (Mt = (I & 15) << 18 | (Vt & 63) << 12 | ($t & 63) << 6 | jt & 63, Mt > 65535 && Mt < 1114112 && (U = Mt));
        }
      }
      U === null ? (U = 65533, xt = 1) : U > 65535 && (U -= 65536, x.push(U >>> 10 & 1023 | 55296), U = 56320 | U & 1023), x.push(U), E += xt;
    }
    return Y(x);
  }
  const z = 4096;
  function Y(h) {
    const s = h.length;
    if (s <= z)
      return String.fromCharCode.apply(String, h);
    let o = "", x = 0;
    for (; x < s; )
      o += String.fromCharCode.apply(
        String,
        h.slice(x, x += z)
      );
    return o;
  }
  function yt(h, s, o) {
    let x = "";
    o = Math.min(h.length, o);
    for (let E = s; E < o; ++E)
      x += String.fromCharCode(h[E] & 127);
    return x;
  }
  function Ut(h, s, o) {
    let x = "";
    o = Math.min(h.length, o);
    for (let E = s; E < o; ++E)
      x += String.fromCharCode(h[E]);
    return x;
  }
  function _t(h, s, o) {
    const x = h.length;
    (!s || s < 0) && (s = 0), (!o || o < 0 || o > x) && (o = x);
    let E = "";
    for (let I = s; I < o; ++I)
      E += Ir[h[I]];
    return E;
  }
  function Gt(h, s, o) {
    const x = h.slice(s, o);
    let E = "";
    for (let I = 0; I < x.length - 1; I += 2)
      E += String.fromCharCode(x[I] + x[I + 1] * 256);
    return E;
  }
  c.prototype.slice = function(s, o) {
    const x = this.length;
    s = ~~s, o = o === void 0 ? x : ~~o, s < 0 ? (s += x, s < 0 && (s = 0)) : s > x && (s = x), o < 0 ? (o += x, o < 0 && (o = 0)) : o > x && (o = x), o < s && (o = s);
    const E = this.subarray(s, o);
    return Object.setPrototypeOf(E, c.prototype), E;
  };
  function Tt(h, s, o) {
    if (h % 1 !== 0 || h < 0) throw new RangeError("offset is not uint");
    if (h + s > o) throw new RangeError("Trying to access beyond buffer length");
  }
  c.prototype.readUintLE = c.prototype.readUIntLE = function(s, o, x) {
    s = s >>> 0, o = o >>> 0, x || Tt(s, o, this.length);
    let E = this[s], I = 1, U = 0;
    for (; ++U < o && (I *= 256); )
      E += this[s + U] * I;
    return E;
  }, c.prototype.readUintBE = c.prototype.readUIntBE = function(s, o, x) {
    s = s >>> 0, o = o >>> 0, x || Tt(s, o, this.length);
    let E = this[s + --o], I = 1;
    for (; o > 0 && (I *= 256); )
      E += this[s + --o] * I;
    return E;
  }, c.prototype.readUint8 = c.prototype.readUInt8 = function(s, o) {
    return s = s >>> 0, o || Tt(s, 1, this.length), this[s];
  }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 2, this.length), this[s] | this[s + 1] << 8;
  }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 2, this.length), this[s] << 8 | this[s + 1];
  }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 4, this.length), (this[s] | this[s + 1] << 8 | this[s + 2] << 16) + this[s + 3] * 16777216;
  }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 4, this.length), this[s] * 16777216 + (this[s + 1] << 16 | this[s + 2] << 8 | this[s + 3]);
  }, c.prototype.readBigUInt64LE = Ue(function(s) {
    s = s >>> 0, Jt(s, "offset");
    const o = this[s], x = this[s + 7];
    (o === void 0 || x === void 0) && me(s, this.length - 8);
    const E = o + this[++s] * 2 ** 8 + this[++s] * 2 ** 16 + this[++s] * 2 ** 24, I = this[++s] + this[++s] * 2 ** 8 + this[++s] * 2 ** 16 + x * 2 ** 24;
    return BigInt(E) + (BigInt(I) << BigInt(32));
  }), c.prototype.readBigUInt64BE = Ue(function(s) {
    s = s >>> 0, Jt(s, "offset");
    const o = this[s], x = this[s + 7];
    (o === void 0 || x === void 0) && me(s, this.length - 8);
    const E = o * 2 ** 24 + this[++s] * 2 ** 16 + this[++s] * 2 ** 8 + this[++s], I = this[++s] * 2 ** 24 + this[++s] * 2 ** 16 + this[++s] * 2 ** 8 + x;
    return (BigInt(E) << BigInt(32)) + BigInt(I);
  }), c.prototype.readIntLE = function(s, o, x) {
    s = s >>> 0, o = o >>> 0, x || Tt(s, o, this.length);
    let E = this[s], I = 1, U = 0;
    for (; ++U < o && (I *= 256); )
      E += this[s + U] * I;
    return I *= 128, E >= I && (E -= Math.pow(2, 8 * o)), E;
  }, c.prototype.readIntBE = function(s, o, x) {
    s = s >>> 0, o = o >>> 0, x || Tt(s, o, this.length);
    let E = o, I = 1, U = this[s + --E];
    for (; E > 0 && (I *= 256); )
      U += this[s + --E] * I;
    return I *= 128, U >= I && (U -= Math.pow(2, 8 * o)), U;
  }, c.prototype.readInt8 = function(s, o) {
    return s = s >>> 0, o || Tt(s, 1, this.length), this[s] & 128 ? (255 - this[s] + 1) * -1 : this[s];
  }, c.prototype.readInt16LE = function(s, o) {
    s = s >>> 0, o || Tt(s, 2, this.length);
    const x = this[s] | this[s + 1] << 8;
    return x & 32768 ? x | 4294901760 : x;
  }, c.prototype.readInt16BE = function(s, o) {
    s = s >>> 0, o || Tt(s, 2, this.length);
    const x = this[s + 1] | this[s] << 8;
    return x & 32768 ? x | 4294901760 : x;
  }, c.prototype.readInt32LE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 4, this.length), this[s] | this[s + 1] << 8 | this[s + 2] << 16 | this[s + 3] << 24;
  }, c.prototype.readInt32BE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 4, this.length), this[s] << 24 | this[s + 1] << 16 | this[s + 2] << 8 | this[s + 3];
  }, c.prototype.readBigInt64LE = Ue(function(s) {
    s = s >>> 0, Jt(s, "offset");
    const o = this[s], x = this[s + 7];
    (o === void 0 || x === void 0) && me(s, this.length - 8);
    const E = this[s + 4] + this[s + 5] * 2 ** 8 + this[s + 6] * 2 ** 16 + (x << 24);
    return (BigInt(E) << BigInt(32)) + BigInt(o + this[++s] * 2 ** 8 + this[++s] * 2 ** 16 + this[++s] * 2 ** 24);
  }), c.prototype.readBigInt64BE = Ue(function(s) {
    s = s >>> 0, Jt(s, "offset");
    const o = this[s], x = this[s + 7];
    (o === void 0 || x === void 0) && me(s, this.length - 8);
    const E = (o << 24) + // Overflow
    this[++s] * 2 ** 16 + this[++s] * 2 ** 8 + this[++s];
    return (BigInt(E) << BigInt(32)) + BigInt(this[++s] * 2 ** 24 + this[++s] * 2 ** 16 + this[++s] * 2 ** 8 + x);
  }), c.prototype.readFloatLE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 4, this.length), r.read(this, s, !0, 23, 4);
  }, c.prototype.readFloatBE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 4, this.length), r.read(this, s, !1, 23, 4);
  }, c.prototype.readDoubleLE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 8, this.length), r.read(this, s, !0, 52, 8);
  }, c.prototype.readDoubleBE = function(s, o) {
    return s = s >>> 0, o || Tt(s, 8, this.length), r.read(this, s, !1, 52, 8);
  };
  function Ct(h, s, o, x, E, I) {
    if (!c.isBuffer(h)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (s > E || s < I) throw new RangeError('"value" argument is out of bounds');
    if (o + x > h.length) throw new RangeError("Index out of range");
  }
  c.prototype.writeUintLE = c.prototype.writeUIntLE = function(s, o, x, E) {
    if (s = +s, o = o >>> 0, x = x >>> 0, !E) {
      const xt = Math.pow(2, 8 * x) - 1;
      Ct(this, s, o, x, xt, 0);
    }
    let I = 1, U = 0;
    for (this[o] = s & 255; ++U < x && (I *= 256); )
      this[o + U] = s / I & 255;
    return o + x;
  }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(s, o, x, E) {
    if (s = +s, o = o >>> 0, x = x >>> 0, !E) {
      const xt = Math.pow(2, 8 * x) - 1;
      Ct(this, s, o, x, xt, 0);
    }
    let I = x - 1, U = 1;
    for (this[o + I] = s & 255; --I >= 0 && (U *= 256); )
      this[o + I] = s / U & 255;
    return o + x;
  }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 1, 255, 0), this[o] = s & 255, o + 1;
  }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 2, 65535, 0), this[o] = s & 255, this[o + 1] = s >>> 8, o + 2;
  }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 2, 65535, 0), this[o] = s >>> 8, this[o + 1] = s & 255, o + 2;
  }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 4, 4294967295, 0), this[o + 3] = s >>> 24, this[o + 2] = s >>> 16, this[o + 1] = s >>> 8, this[o] = s & 255, o + 4;
  }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 4, 4294967295, 0), this[o] = s >>> 24, this[o + 1] = s >>> 16, this[o + 2] = s >>> 8, this[o + 3] = s & 255, o + 4;
  };
  function Yt(h, s, o, x, E) {
    be(s, x, E, h, o, 7);
    let I = Number(s & BigInt(4294967295));
    h[o++] = I, I = I >> 8, h[o++] = I, I = I >> 8, h[o++] = I, I = I >> 8, h[o++] = I;
    let U = Number(s >> BigInt(32) & BigInt(4294967295));
    return h[o++] = U, U = U >> 8, h[o++] = U, U = U >> 8, h[o++] = U, U = U >> 8, h[o++] = U, o;
  }
  function qt(h, s, o, x, E) {
    be(s, x, E, h, o, 7);
    let I = Number(s & BigInt(4294967295));
    h[o + 7] = I, I = I >> 8, h[o + 6] = I, I = I >> 8, h[o + 5] = I, I = I >> 8, h[o + 4] = I;
    let U = Number(s >> BigInt(32) & BigInt(4294967295));
    return h[o + 3] = U, U = U >> 8, h[o + 2] = U, U = U >> 8, h[o + 1] = U, U = U >> 8, h[o] = U, o + 8;
  }
  c.prototype.writeBigUInt64LE = Ue(function(s, o = 0) {
    return Yt(this, s, o, BigInt(0), BigInt("0xffffffffffffffff"));
  }), c.prototype.writeBigUInt64BE = Ue(function(s, o = 0) {
    return qt(this, s, o, BigInt(0), BigInt("0xffffffffffffffff"));
  }), c.prototype.writeIntLE = function(s, o, x, E) {
    if (s = +s, o = o >>> 0, !E) {
      const Vt = Math.pow(2, 8 * x - 1);
      Ct(this, s, o, x, Vt - 1, -Vt);
    }
    let I = 0, U = 1, xt = 0;
    for (this[o] = s & 255; ++I < x && (U *= 256); )
      s < 0 && xt === 0 && this[o + I - 1] !== 0 && (xt = 1), this[o + I] = (s / U >> 0) - xt & 255;
    return o + x;
  }, c.prototype.writeIntBE = function(s, o, x, E) {
    if (s = +s, o = o >>> 0, !E) {
      const Vt = Math.pow(2, 8 * x - 1);
      Ct(this, s, o, x, Vt - 1, -Vt);
    }
    let I = x - 1, U = 1, xt = 0;
    for (this[o + I] = s & 255; --I >= 0 && (U *= 256); )
      s < 0 && xt === 0 && this[o + I + 1] !== 0 && (xt = 1), this[o + I] = (s / U >> 0) - xt & 255;
    return o + x;
  }, c.prototype.writeInt8 = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 1, 127, -128), s < 0 && (s = 255 + s + 1), this[o] = s & 255, o + 1;
  }, c.prototype.writeInt16LE = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 2, 32767, -32768), this[o] = s & 255, this[o + 1] = s >>> 8, o + 2;
  }, c.prototype.writeInt16BE = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 2, 32767, -32768), this[o] = s >>> 8, this[o + 1] = s & 255, o + 2;
  }, c.prototype.writeInt32LE = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 4, 2147483647, -2147483648), this[o] = s & 255, this[o + 1] = s >>> 8, this[o + 2] = s >>> 16, this[o + 3] = s >>> 24, o + 4;
  }, c.prototype.writeInt32BE = function(s, o, x) {
    return s = +s, o = o >>> 0, x || Ct(this, s, o, 4, 2147483647, -2147483648), s < 0 && (s = 4294967295 + s + 1), this[o] = s >>> 24, this[o + 1] = s >>> 16, this[o + 2] = s >>> 8, this[o + 3] = s & 255, o + 4;
  }, c.prototype.writeBigInt64LE = Ue(function(s, o = 0) {
    return Yt(this, s, o, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), c.prototype.writeBigInt64BE = Ue(function(s, o = 0) {
    return qt(this, s, o, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function ct(h, s, o, x, E, I) {
    if (o + x > h.length) throw new RangeError("Index out of range");
    if (o < 0) throw new RangeError("Index out of range");
  }
  function Xt(h, s, o, x, E) {
    return s = +s, o = o >>> 0, E || ct(h, s, o, 4), r.write(h, s, o, x, 23, 4), o + 4;
  }
  c.prototype.writeFloatLE = function(s, o, x) {
    return Xt(this, s, o, !0, x);
  }, c.prototype.writeFloatBE = function(s, o, x) {
    return Xt(this, s, o, !1, x);
  };
  function ye(h, s, o, x, E) {
    return s = +s, o = o >>> 0, E || ct(h, s, o, 8), r.write(h, s, o, x, 52, 8), o + 8;
  }
  c.prototype.writeDoubleLE = function(s, o, x) {
    return ye(this, s, o, !0, x);
  }, c.prototype.writeDoubleBE = function(s, o, x) {
    return ye(this, s, o, !1, x);
  }, c.prototype.copy = function(s, o, x, E) {
    if (!c.isBuffer(s)) throw new TypeError("argument should be a Buffer");
    if (x || (x = 0), !E && E !== 0 && (E = this.length), o >= s.length && (o = s.length), o || (o = 0), E > 0 && E < x && (E = x), E === x || s.length === 0 || this.length === 0) return 0;
    if (o < 0)
      throw new RangeError("targetStart out of bounds");
    if (x < 0 || x >= this.length) throw new RangeError("Index out of range");
    if (E < 0) throw new RangeError("sourceEnd out of bounds");
    E > this.length && (E = this.length), s.length - o < E - x && (E = s.length - o + x);
    const I = E - x;
    return this === s && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(o, x, E) : Uint8Array.prototype.set.call(
      s,
      this.subarray(x, E),
      o
    ), I;
  }, c.prototype.fill = function(s, o, x, E) {
    if (typeof s == "string") {
      if (typeof o == "string" ? (E = o, o = 0, x = this.length) : typeof x == "string" && (E = x, x = this.length), E !== void 0 && typeof E != "string")
        throw new TypeError("encoding must be a string");
      if (typeof E == "string" && !c.isEncoding(E))
        throw new TypeError("Unknown encoding: " + E);
      if (s.length === 1) {
        const U = s.charCodeAt(0);
        (E === "utf8" && U < 128 || E === "latin1") && (s = U);
      }
    } else typeof s == "number" ? s = s & 255 : typeof s == "boolean" && (s = Number(s));
    if (o < 0 || this.length < o || this.length < x)
      throw new RangeError("Out of range index");
    if (x <= o)
      return this;
    o = o >>> 0, x = x === void 0 ? this.length : x >>> 0, s || (s = 0);
    let I;
    if (typeof s == "number")
      for (I = o; I < x; ++I)
        this[I] = s;
    else {
      const U = c.isBuffer(s) ? s : c.from(s, E), xt = U.length;
      if (xt === 0)
        throw new TypeError('The value "' + s + '" is invalid for argument "value"');
      for (I = 0; I < x - o; ++I)
        this[I + o] = U[I % xt];
    }
    return this;
  };
  const Be = {};
  function ue(h, s, o) {
    Be[h] = class extends o {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: s.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${h}]`, this.stack, delete this.name;
      }
      get code() {
        return h;
      }
      set code(E) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: E,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${h}]: ${this.message}`;
      }
    };
  }
  ue(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(h) {
      return h ? `${h} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), ue(
    "ERR_INVALID_ARG_TYPE",
    function(h, s) {
      return `The "${h}" argument must be of type number. Received type ${typeof s}`;
    },
    TypeError
  ), ue(
    "ERR_OUT_OF_RANGE",
    function(h, s, o) {
      let x = `The value of "${h}" is out of range.`, E = o;
      return Number.isInteger(o) && Math.abs(o) > 2 ** 32 ? E = we(String(o)) : typeof o == "bigint" && (E = String(o), (o > BigInt(2) ** BigInt(32) || o < -(BigInt(2) ** BigInt(32))) && (E = we(E)), E += "n"), x += ` It must be ${s}. Received ${E}`, x;
    },
    RangeError
  );
  function we(h) {
    let s = "", o = h.length;
    const x = h[0] === "-" ? 1 : 0;
    for (; o >= x + 4; o -= 3)
      s = `_${h.slice(o - 3, o)}${s}`;
    return `${h.slice(0, o)}${s}`;
  }
  function ur(h, s, o) {
    Jt(s, "offset"), (h[s] === void 0 || h[s + o] === void 0) && me(s, h.length - (o + 1));
  }
  function be(h, s, o, x, E, I) {
    if (h > o || h < s) {
      const U = typeof s == "bigint" ? "n" : "";
      let xt;
      throw I > 3 ? s === 0 || s === BigInt(0) ? xt = `>= 0${U} and < 2${U} ** ${(I + 1) * 8}${U}` : xt = `>= -(2${U} ** ${(I + 1) * 8 - 1}${U}) and < 2 ** ${(I + 1) * 8 - 1}${U}` : xt = `>= ${s}${U} and <= ${o}${U}`, new Be.ERR_OUT_OF_RANGE("value", xt, h);
    }
    ur(x, E, I);
  }
  function Jt(h, s) {
    if (typeof h != "number")
      throw new Be.ERR_INVALID_ARG_TYPE(s, "number", h);
  }
  function me(h, s, o) {
    throw Math.floor(h) !== h ? (Jt(h, o), new Be.ERR_OUT_OF_RANGE(o || "offset", "an integer", h)) : s < 0 ? new Be.ERR_BUFFER_OUT_OF_BOUNDS() : new Be.ERR_OUT_OF_RANGE(
      o || "offset",
      `>= ${o ? 1 : 0} and <= ${s}`,
      h
    );
  }
  const Sr = /[^+/0-9A-Za-z-_]/g;
  function vr(h) {
    if (h = h.split("=")[0], h = h.trim().replace(Sr, ""), h.length < 2) return "";
    for (; h.length % 4 !== 0; )
      h = h + "=";
    return h;
  }
  function Br(h, s) {
    s = s || 1 / 0;
    let o;
    const x = h.length;
    let E = null;
    const I = [];
    for (let U = 0; U < x; ++U) {
      if (o = h.charCodeAt(U), o > 55295 && o < 57344) {
        if (!E) {
          if (o > 56319) {
            (s -= 3) > -1 && I.push(239, 191, 189);
            continue;
          } else if (U + 1 === x) {
            (s -= 3) > -1 && I.push(239, 191, 189);
            continue;
          }
          E = o;
          continue;
        }
        if (o < 56320) {
          (s -= 3) > -1 && I.push(239, 191, 189), E = o;
          continue;
        }
        o = (E - 55296 << 10 | o - 56320) + 65536;
      } else E && (s -= 3) > -1 && I.push(239, 191, 189);
      if (E = null, o < 128) {
        if ((s -= 1) < 0) break;
        I.push(o);
      } else if (o < 2048) {
        if ((s -= 2) < 0) break;
        I.push(
          o >> 6 | 192,
          o & 63 | 128
        );
      } else if (o < 65536) {
        if ((s -= 3) < 0) break;
        I.push(
          o >> 12 | 224,
          o >> 6 & 63 | 128,
          o & 63 | 128
        );
      } else if (o < 1114112) {
        if ((s -= 4) < 0) break;
        I.push(
          o >> 18 | 240,
          o >> 12 & 63 | 128,
          o >> 6 & 63 | 128,
          o & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return I;
  }
  function ln(h) {
    const s = [];
    for (let o = 0; o < h.length; ++o)
      s.push(h.charCodeAt(o) & 255);
    return s;
  }
  function Ge(h, s) {
    let o, x, E;
    const I = [];
    for (let U = 0; U < h.length && !((s -= 2) < 0); ++U)
      o = h.charCodeAt(U), x = o >> 8, E = o % 256, I.push(E), I.push(x);
    return I;
  }
  function lr(h) {
    return t.toByteArray(vr(h));
  }
  function hr(h, s, o, x) {
    let E;
    for (E = 0; E < x && !(E + o >= s.length || E >= h.length); ++E)
      s[E + o] = h[E];
    return E;
  }
  function Ee(h, s) {
    return h instanceof s || h != null && h.constructor != null && h.constructor.name != null && h.constructor.name === s.name;
  }
  function dr(h) {
    return h !== h;
  }
  const Ir = function() {
    const h = "0123456789abcdef", s = new Array(256);
    for (let o = 0; o < 16; ++o) {
      const x = o * 16;
      for (let E = 0; E < 16; ++E)
        s[x + E] = h[o] + h[E];
    }
    return s;
  }();
  function Ue(h) {
    return typeof BigInt > "u" ? Ar : h;
  }
  function Ar() {
    throw new Error("BigInt not supported");
  }
})(Ni);
function Zs(e, t) {
  return Ae.IntentMessage(Ae.fixedArray(t.length, Ae.u8())).serialize({
    intent: {
      scope: { [e]: !0 },
      version: { V0: !0 },
      appId: { Sui: !0 }
    },
    value: t
  }).toBytes();
}
function Pr(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
class fn {
  /**
   * Checks if two public keys are equal
   */
  equals(t) {
    return Pr(this.toRawBytes(), t.toRawBytes());
  }
  /**
   * Return the base-64 representation of the public key
   */
  toBase64() {
    return ee(this.toRawBytes());
  }
  toString() {
    throw new Error(
      "`toString` is not implemented on public keys. Use `toBase64()` or `toRawBytes()` instead."
    );
  }
  /**
   * Return the Sui representation of the public key encoded in
   * base-64. A Sui public key is formed by the concatenation
   * of the scheme flag with the raw bytes of the public key
   */
  toSuiPublicKey() {
    const t = this.toSuiBytes();
    return ee(t);
  }
  verifyWithIntent(t, r, n) {
    const a = Zs(n, t), u = kn(a, { dkLen: 32 });
    return this.verify(u, r);
  }
  /**
   * Verifies that the signature is valid for for the provided PersonalMessage
   */
  verifyPersonalMessage(t, r) {
    return this.verifyWithIntent(
      Ae.vector(Ae.u8()).serialize(t).toBytes(),
      r,
      "PersonalMessage"
    );
  }
  /**
   * Verifies that the signature is valid for for the provided Transaction
   */
  verifyTransaction(t, r) {
    return this.verifyWithIntent(t, r, "TransactionData");
  }
  /**
   * Returns the bytes representation of the public key
   * prefixed with the signature scheme flag
   */
  toSuiBytes() {
    const t = this.toRawBytes(), r = new Uint8Array(t.length + 1);
    return r.set([this.flag()]), r.set(t, 1), r;
  }
  /**
   * Return the Sui address associated with this Ed25519 public key
   */
  toSuiAddress() {
    return _e(
      qs(kn(this.toSuiBytes(), { dkLen: 32 })).slice(0, Dn * 2)
    );
  }
}
const Qe = {
  ED25519: 0,
  Secp256k1: 1,
  Secp256r1: 2,
  MultiSig: 3,
  ZkLogin: 5
}, Nf = {
  ED25519: 32,
  Secp256k1: 33,
  Secp256r1: 33
}, Xs = {
  0: "ED25519",
  1: "Secp256k1",
  2: "Secp256r1",
  3: "MultiSig",
  5: "ZkLogin"
};
function Uf(e, t) {
  if (!!!e)
    throw new Error(t);
}
const Js = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Of = new Set(Object.keys(Js));
function ji(e) {
  const t = e == null ? void 0 : e.kind;
  return typeof t == "string" && Of.has(t);
}
var qi;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(qi || (qi = {}));
var fi;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(fi || (fi = {}));
function Gi(e) {
  return e === 9 || e === 32;
}
function kf(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), a = n.length === 1, u = n.length > 1 && n.slice(1).every((M) => M.length === 0 || Gi(M.charCodeAt(0))), p = r.endsWith('\\"""'), c = e.endsWith('"') && !p, y = e.endsWith("\\"), m = c || y, T = !(t != null && t.minimize) && // add leading and trailing new lines only if it improves readability
  (!a || e.length > 70 || m || u || p);
  let v = "";
  const V = a && Gi(e.charCodeAt(0));
  return (T && !V || u) && (v += `
`), v += r, (T || m) && (v += `
`), '"""' + v + '"""';
}
const Cf = 10, Qs = 2;
function Mf(e) {
  return Rn(e, []);
}
function Rn(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return Lf(e, t);
    default:
      return String(e);
  }
}
function Lf(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (Df(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : Rn(n, r);
  } else if (Array.isArray(e))
    return Rf(e, r);
  return Ff(e, r);
}
function Df(e) {
  return typeof e.toJSON == "function";
}
function Ff(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > Qs ? "[" + Pf(e) + "]" : "{ " + r.map(
    ([a, u]) => a + ": " + Rn(u, t)
  ).join(", ") + " }";
}
function Rf(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > Qs)
    return "[Array]";
  const r = Math.min(Cf, e.length), n = e.length - r, a = [];
  for (let u = 0; u < r; ++u)
    a.push(Rn(e[u], t));
  return n === 1 ? a.push("... 1 more item") : n > 1 && a.push(`... ${n} more items`), "[" + a.join(", ") + "]";
}
function Pf(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
function $f(e) {
  return `"${e.replace(Vf, zf)}"`;
}
const Vf = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function zf(e) {
  return jf[e.charCodeAt(0)];
}
const jf = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], qf = Object.freeze({});
function Gf(e, t, r = Js) {
  const n = /* @__PURE__ */ new Map();
  for (const P of Object.values(fi))
    n.set(P, Yf(t, P));
  let a, u = Array.isArray(e), p = [e], c = -1, y = [], m = e, T, v;
  const V = [], M = [];
  do {
    c++;
    const P = c === p.length, et = P && y.length !== 0;
    if (P) {
      if (T = M.length === 0 ? void 0 : V[V.length - 1], m = v, v = M.pop(), et)
        if (u) {
          m = m.slice();
          let ot = 0;
          for (const [nt, j] of y) {
            const it = nt - ot;
            j === null ? (m.splice(it, 1), ot++) : m[it] = j;
          }
        } else {
          m = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(m)
          );
          for (const [ot, nt] of y)
            m[ot] = nt;
        }
      c = a.index, p = a.keys, y = a.edits, u = a.inArray, a = a.prev;
    } else if (v) {
      if (T = u ? c : p[c], m = v[T], m == null)
        continue;
      V.push(T);
    }
    let K;
    if (!Array.isArray(m)) {
      var F, N;
      ji(m) || Uf(!1, `Invalid AST Node: ${Mf(m)}.`);
      const ot = P ? (F = n.get(m.kind)) === null || F === void 0 ? void 0 : F.leave : (N = n.get(m.kind)) === null || N === void 0 ? void 0 : N.enter;
      if (K = ot == null ? void 0 : ot.call(t, m, T, v, V, M), K === qf)
        break;
      if (K === !1) {
        if (!P) {
          V.pop();
          continue;
        }
      } else if (K !== void 0 && (y.push([T, K]), !P))
        if (ji(K))
          m = K;
        else {
          V.pop();
          continue;
        }
    }
    if (K === void 0 && et && y.push([T, m]), P)
      V.pop();
    else {
      var D;
      a = {
        inArray: u,
        index: c,
        keys: p,
        edits: y,
        prev: a
      }, u = Array.isArray(m), p = u ? m : (D = r[m.kind]) !== null && D !== void 0 ? D : [], c = -1, y = [], v && M.push(v), v = m;
    }
  } while (a !== void 0);
  return y.length !== 0 ? y[y.length - 1][1] : e;
}
function Yf(e, t) {
  const r = e[t];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function Wf(e) {
  return Gf(e, Kf);
}
const Hf = 80, Kf = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => Q(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = Nt("(", Q(e.variableDefinitions, ", "), ")"), r = Q(
        [
          e.operation,
          Q([e.name, t]),
          Q(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: r, directives: n }) => e + ": " + t + Nt(" = ", r) + Nt(" ", Q(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => De(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: a }) {
      const u = Nt("", e, ": ") + t;
      let p = u + Nt("(", Q(r, ", "), ")");
      return p.length > Hf && (p = u + Nt(`(
`, vn(Q(r, `
`)), `
)`)), Q([p, Q(n, " "), a], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + Nt(" ", Q(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: r }) => Q(
      [
        "...",
        Nt("on ", e),
        Q(t, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: t, variableDefinitions: r, directives: n, selectionSet: a }) => (
      // or removed in the future.
      `fragment ${e}${Nt("(", Q(r, ", "), ")")} on ${t} ${Nt("", Q(n, " "), " ")}` + a
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? kf(e) : $f(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + Q(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + Q(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + Nt("(", Q(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: r }) => Nt("", e, `
`) + Q(["schema", Q(t, " "), De(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Nt("", e, `
`) + Q(["scalar", t, Q(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: a }) => Nt("", e, `
`) + Q(
      [
        "type",
        t,
        Nt("implements ", Q(r, " & ")),
        Q(n, " "),
        De(a)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: r, type: n, directives: a }) => Nt("", e, `
`) + t + (Yi(r) ? Nt(`(
`, vn(Q(r, `
`)), `
)`) : Nt("(", Q(r, ", "), ")")) + ": " + n + Nt(" ", Q(a, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: r, defaultValue: n, directives: a }) => Nt("", e, `
`) + Q(
      [t + ": " + r, Nt("= ", n), Q(a, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: a }) => Nt("", e, `
`) + Q(
      [
        "interface",
        t,
        Nt("implements ", Q(r, " & ")),
        Q(n, " "),
        De(a)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, types: n }) => Nt("", e, `
`) + Q(
      ["union", t, Q(r, " "), Nt("= ", Q(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, values: n }) => Nt("", e, `
`) + Q(["enum", t, Q(r, " "), De(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: r }) => Nt("", e, `
`) + Q([t, Q(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, fields: n }) => Nt("", e, `
`) + Q(["input", t, Q(r, " "), De(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: a }) => Nt("", e, `
`) + "directive @" + t + (Yi(r) ? Nt(`(
`, vn(Q(r, `
`)), `
)`) : Nt("(", Q(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + Q(a, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => Q(
      ["extend schema", Q(e, " "), De(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => Q(["extend scalar", e, Q(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Q(
      [
        "extend type",
        e,
        Nt("implements ", Q(t, " & ")),
        Q(r, " "),
        De(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => Q(
      [
        "extend interface",
        e,
        Nt("implements ", Q(t, " & ")),
        Q(r, " "),
        De(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: r }) => Q(
      [
        "extend union",
        e,
        Q(t, " "),
        Nt("= ", Q(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: r }) => Q(["extend enum", e, Q(t, " "), De(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: r }) => Q(["extend input", e, Q(t, " "), De(r)], " ")
  }
};
function Q(e, t = "") {
  var r;
  return (r = e == null ? void 0 : e.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
}
function De(e) {
  return Nt(`{
`, vn(Q(e, `
`)), `
}`);
}
function Nt(e, t, r = "") {
  return t != null && t !== "" ? e + t + r : "";
}
function vn(e) {
  return Nt("  ", e.replace(/\n/g, `
  `));
}
function Yi(e) {
  var t;
  return (t = e == null ? void 0 : e.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
var to = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, xn = (e, t, r) => (to(e, t, "read from private field"), r ? r.call(e) : t.get(e)), yn = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, wn = (e, t, r, n) => (to(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), Bn, In, An, _n;
class Zf extends Error {
}
class eo {
  constructor({
    url: t,
    fetch: r = fetch,
    headers: n = {},
    queries: a = {}
  }) {
    yn(this, Bn, void 0), yn(this, In, void 0), yn(this, An, void 0), yn(this, _n, void 0), wn(this, Bn, t), wn(this, In, a), wn(this, An, n), wn(this, _n, (...u) => r(...u));
  }
  async query(t) {
    const r = await xn(this, _n).call(this, xn(this, Bn), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...xn(this, An)
      },
      body: JSON.stringify({
        query: typeof t.query == "string" ? String(t.query) : Wf(t.query),
        variables: t.variables,
        extensions: t.extensions,
        operationName: t.operationName
      })
    });
    if (!r.ok)
      throw new Zf(`GraphQL request failed: ${r.statusText} (${r.status})`);
    return await r.json();
  }
  async execute(t, r) {
    return this.query({
      ...r,
      query: xn(this, In)[t]
    });
  }
}
Bn = /* @__PURE__ */ new WeakMap();
In = /* @__PURE__ */ new WeakMap();
An = /* @__PURE__ */ new WeakMap();
_n = /* @__PURE__ */ new WeakMap();
var bn = {
  NAME: "Name",
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  DIRECTIVE: "Directive",
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType"
};
class Xf extends Error {
  constructor(t, r, n, a, u, p, c) {
    super(t), this.name = "GraphQLError", this.message = t, u && (this.path = u), r && (this.nodes = Array.isArray(r) ? r : [r]), n && (this.source = n), a && (this.positions = a), p && (this.originalError = p);
    var y = c;
    if (!y && p) {
      var m = p.extensions;
      m && typeof m == "object" && (y = m);
    }
    this.extensions = y || {};
  }
  toJSON() {
    return {
      ...this,
      message: this.message
    };
  }
  toString() {
    return this.message;
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
}
var Rt, at;
function ne(e) {
  return new Xf(`Syntax Error: Unexpected token at ${at} in ${e}`);
}
function Te(e) {
  if (e.lastIndex = at, e.test(Rt))
    return Rt.slice(at, at = e.lastIndex);
}
var mn = / +(?=[^\s])/y;
function Jf(e) {
  for (var t = e.split(`
`), r = "", n = 0, a = 0, u = t.length - 1, p = 0; p < t.length; p++)
    mn.lastIndex = 0, mn.test(t[p]) && (p && (!n || mn.lastIndex < n) && (n = mn.lastIndex), a = a || p, u = p);
  for (var c = a; c <= u; c++)
    c !== a && (r += `
`), r += t[c].slice(n).replace(/\\"""/g, '"""');
  return r;
}
function St() {
  for (var e = 0 | Rt.charCodeAt(at++); e === 9 || e === 10 || e === 13 || e === 32 || e === 35 || e === 44 || e === 65279; e = 0 | Rt.charCodeAt(at++))
    if (e === 35)
      for (; (e = Rt.charCodeAt(at++)) !== 10 && e !== 13; )
        ;
  at--;
}
var xe = /[_A-Za-z]\w*/y, Qn = new RegExp("(?:(null|true|false)|\\$(" + xe.source + ')|(-?\\d+)((?:\\.\\d+)?[eE][+-]?\\d+|\\.\\d+)?|("""(?:"""|(?:[\\s\\S]*?[^\\\\])"""))|("(?:"|[^\\r\\n]*?[^\\\\]"))|(' + xe.source + "))", "y"), or = function(e) {
  return e[e.Const = 1] = "Const", e[e.Var = 2] = "Var", e[e.Int = 3] = "Int", e[e.Float = 4] = "Float", e[e.BlockString = 5] = "BlockString", e[e.String = 6] = "String", e[e.Enum = 7] = "Enum", e;
}(or || {}), Qf = /\\/g;
function Cn(e) {
  var t, r;
  if (Qn.lastIndex = at, Rt.charCodeAt(at) === 91) {
    at++, St();
    for (var n = []; Rt.charCodeAt(at) !== 93; )
      n.push(Cn(e));
    return at++, St(), {
      kind: "ListValue",
      values: n
    };
  } else if (Rt.charCodeAt(at) === 123) {
    at++, St();
    for (var a = []; Rt.charCodeAt(at) !== 125; ) {
      if ((t = Te(xe)) == null || (St(), Rt.charCodeAt(at++) !== 58))
        throw ne("ObjectField");
      St(), a.push({
        kind: "ObjectField",
        name: {
          kind: "Name",
          value: t
        },
        value: Cn(e)
      });
    }
    return at++, St(), {
      kind: "ObjectValue",
      fields: a
    };
  } else if ((r = Qn.exec(Rt)) != null) {
    if (at = Qn.lastIndex, St(), (t = r[or.Const]) != null)
      return t === "null" ? {
        kind: "NullValue"
      } : {
        kind: "BooleanValue",
        value: t === "true"
      };
    if ((t = r[or.Var]) != null) {
      if (e)
        throw ne("Variable");
      return {
        kind: "Variable",
        name: {
          kind: "Name",
          value: t
        }
      };
    } else if ((t = r[or.Int]) != null) {
      var u;
      return (u = r[or.Float]) != null ? {
        kind: "FloatValue",
        value: t + u
      } : {
        kind: "IntValue",
        value: t
      };
    } else {
      if ((t = r[or.BlockString]) != null)
        return {
          kind: "StringValue",
          value: Jf(t.slice(3, -3)),
          block: !0
        };
      if ((t = r[or.String]) != null)
        return {
          kind: "StringValue",
          value: Qf.test(t) ? JSON.parse(t) : t.slice(1, -1),
          block: !1
        };
      if ((t = r[or.Enum]) != null)
        return {
          kind: "EnumValue",
          value: t
        };
    }
  }
  throw ne("Value");
}
function ro(e) {
  if (Rt.charCodeAt(at) === 40) {
    var t = [];
    at++, St();
    var r;
    do {
      if ((r = Te(xe)) == null || (St(), Rt.charCodeAt(at++) !== 58))
        throw ne("Argument");
      St(), t.push({
        kind: "Argument",
        name: {
          kind: "Name",
          value: r
        },
        value: Cn(e)
      });
    } while (Rt.charCodeAt(at) !== 41);
    return at++, St(), t;
  }
}
function Dr(e) {
  if (Rt.charCodeAt(at) === 64) {
    var t = [], r;
    do {
      if (at++, (r = Te(xe)) == null)
        throw ne("Directive");
      St(), t.push({
        kind: "Directive",
        name: {
          kind: "Name",
          value: r
        },
        arguments: ro(e)
      });
    } while (Rt.charCodeAt(at) === 64);
    return t;
  }
}
function tc() {
  for (var e, t = 0; Rt.charCodeAt(at) === 91; )
    t++, at++, St();
  if ((e = Te(xe)) == null)
    throw ne("NamedType");
  St();
  var r = {
    kind: "NamedType",
    name: {
      kind: "Name",
      value: e
    }
  };
  do
    if (Rt.charCodeAt(at) === 33 && (at++, St(), r = {
      kind: "NonNullType",
      type: r
    }), t) {
      if (Rt.charCodeAt(at++) !== 93)
        throw ne("NamedType");
      St(), r = {
        kind: "ListType",
        type: r
      };
    }
  while (t--);
  return r;
}
var ti = new RegExp("(?:(\\.{3})|(" + xe.source + "))", "y"), ci = function(e) {
  return e[e.Spread = 1] = "Spread", e[e.Name = 2] = "Name", e;
}(ci || {});
function Mn() {
  var e = [], t, r;
  do
    if (ti.lastIndex = at, (r = ti.exec(Rt)) != null) {
      if (at = ti.lastIndex, r[ci.Spread] != null) {
        St();
        var n = Te(xe);
        if (n != null && n !== "on")
          St(), e.push({
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: n
            },
            directives: Dr(!1)
          });
        else {
          if (St(), n === "on") {
            if ((n = Te(xe)) == null)
              throw ne("NamedType");
            St();
          }
          var a = Dr(!1);
          if (Rt.charCodeAt(at++) !== 123)
            throw ne("InlineFragment");
          St(), e.push({
            kind: "InlineFragment",
            typeCondition: n ? {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: n
              }
            } : void 0,
            directives: a,
            selectionSet: Mn()
          });
        }
      } else if ((t = r[ci.Name]) != null) {
        var u = void 0;
        if (St(), Rt.charCodeAt(at) === 58) {
          if (at++, St(), u = t, (t = Te(xe)) == null)
            throw ne("Field");
          St();
        }
        var p = ro(!1);
        St();
        var c = Dr(!1), y = void 0;
        Rt.charCodeAt(at) === 123 && (at++, St(), y = Mn()), e.push({
          kind: "Field",
          alias: u ? {
            kind: "Name",
            value: u
          } : void 0,
          name: {
            kind: "Name",
            value: t
          },
          arguments: p,
          directives: c,
          selectionSet: y
        });
      }
    } else
      throw ne("SelectionSet");
  while (Rt.charCodeAt(at) !== 125);
  return at++, St(), {
    kind: "SelectionSet",
    selections: e
  };
}
function ec() {
  var e, t;
  if ((e = Te(xe)) == null || (St(), Te(xe) !== "on") || (St(), (t = Te(xe)) == null))
    throw ne("FragmentDefinition");
  St();
  var r = Dr(!1);
  if (Rt.charCodeAt(at++) !== 123)
    throw ne("FragmentDefinition");
  return St(), {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: e
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: t
      }
    },
    directives: r,
    selectionSet: Mn()
  };
}
var rc = /(?:query|mutation|subscription|fragment)/y;
function nc(e) {
  var t, r, n;
  if (e && (St(), t = Te(xe), r = function() {
    if (St(), Rt.charCodeAt(at) === 40) {
      var u = [];
      at++, St();
      var p;
      do {
        if (Rt.charCodeAt(at++) !== 36 || (p = Te(xe)) == null)
          throw ne("Variable");
        if (St(), Rt.charCodeAt(at++) !== 58)
          throw ne("VariableDefinition");
        St();
        var c = tc(), y = void 0;
        Rt.charCodeAt(at) === 61 && (at++, St(), y = Cn(!0)), St(), u.push({
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: p
            }
          },
          type: c,
          defaultValue: y,
          directives: Dr(!0)
        });
      } while (Rt.charCodeAt(at) !== 41);
      return at++, St(), u;
    }
  }(), n = Dr(!1)), Rt.charCodeAt(at) === 123)
    return at++, St(), {
      kind: "OperationDefinition",
      operation: e || "query",
      name: t ? {
        kind: "Name",
        value: t
      } : void 0,
      variableDefinitions: r,
      directives: n,
      selectionSet: Mn()
    };
}
function ic(e, t) {
  return Rt = typeof e.body == "string" ? e.body : e, at = 0, function() {
    var n, a;
    St();
    var u = [];
    do
      if ((n = Te(rc)) === "fragment")
        St(), u.push(ec());
      else if ((a = nc(n)) != null)
        u.push(a);
      else
        throw ne("Document");
    while (at < Rt.length);
    return {
      kind: "Document",
      definitions: u
    };
  }();
}
function no() {
  function e(t, r) {
    var n = ic(t).definitions, a = /* @__PURE__ */ new Set();
    for (var u of r || [])
      for (var p of u.definitions)
        p.kind === bn.FRAGMENT_DEFINITION && !a.has(p) && (n.push(p), a.add(p));
    return n[0].kind === bn.FRAGMENT_DEFINITION && n[0].directives && (n[0].directives = n[0].directives.filter((c) => c.name.value !== "_unmask")), {
      kind: bn.DOCUMENT,
      definitions: n
    };
  }
  return e.scalar = function(r, n) {
    return n;
  }, e.persisted = function(r, n) {
    return {
      kind: bn.DOCUMENT,
      definitions: n ? n.definitions : [],
      documentId: r
    };
  }, e;
}
no();
const sc = no();
function oc(e) {
  if (e.length !== 1)
    throw new Error("Invalid base64Url character: " + e);
  const r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_".indexOf(e);
  if (r === -1)
    throw new Error("Invalid base64Url character: " + e);
  const n = r.toString(2).padStart(6, "0");
  return Array.from(n).map(Number);
}
function ac(e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    const n = e.charAt(r), a = oc(n);
    t = t.concat(a);
  }
  return t;
}
function fc(e, t) {
  if (e.length < 2)
    throw new Error(`Input (s = ${e}) is not tightly packed because s.length < 2`);
  let r = ac(e);
  const n = t % 4;
  if (n !== 0) if (n === 1)
    r = r.slice(2);
  else if (n === 2)
    r = r.slice(4);
  else
    throw new Error(`Input (s = ${e}) is not tightly packed because i%4 = 3 (i = ${t}))`);
  const a = (t + e.length - 1) % 4;
  if (a !== 3) if (a === 2)
    r = r.slice(0, r.length - 2);
  else if (a === 1)
    r = r.slice(0, r.length - 4);
  else
    throw new Error(
      `Input (s = ${e}) is not tightly packed because (i + s.length - 1)%4 = 0 (i = ${t}))`
    );
  if (r.length % 8 !== 0)
    throw new Error("We should never reach here...");
  const u = new Uint8Array(Math.floor(r.length / 8));
  let p = 0;
  for (let c = 0; c < r.length; c += 8) {
    const y = r.slice(c, c + 8), m = parseInt(y.join(""), 2);
    u[p++] = m;
  }
  return new TextDecoder().decode(u);
}
function cc(e) {
  if (!(e.slice(-1) === "}" || e.slice(-1) === ","))
    throw new Error("Invalid claim");
  const t = JSON.parse("{" + e.slice(0, -1) + "}");
  if (Object.keys(t).length !== 1)
    throw new Error("Invalid claim");
  const r = Object.keys(t)[0];
  return [r, t[r]];
}
function uc(e, t) {
  const r = fc(e.value, e.indexMod4), [n, a] = cc(r);
  if (n !== t)
    throw new Error(`Invalid field name: found ${n} expected ${t}`);
  return a;
}
const lc = w.struct("ZkLoginSignature", {
  inputs: w.struct("ZkLoginSignatureInputs", {
    proofPoints: w.struct("ZkLoginSignatureInputsProofPoints", {
      a: w.vector(w.string()),
      b: w.vector(w.vector(w.string())),
      c: w.vector(w.string())
    }),
    issBase64Details: w.struct("ZkLoginSignatureInputsClaim", {
      value: w.string(),
      indexMod4: w.u8()
    }),
    headerBase64: w.string(),
    addressSeed: w.string()
  }),
  maxEpoch: w.u64(),
  userSignature: w.vector(w.u8())
});
function hc(e) {
  return lc.parse(typeof e == "string" ? Ne(e) : e);
}
function dc(e, t) {
  const r = e.toString(16);
  return Da(r.padStart(t * 2, "0").slice(-t * 2));
}
var io = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, ei = (e, t, r) => (io(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Wi = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, En = (e, t, r, n) => (io(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), Or, Kr;
const ui = class extends fn {
  /**
   * Create a new ZkLoginPublicIdentifier object
   * @param value zkLogin public identifier as buffer or base-64 encoded string
   */
  constructor(e, { client: t } = {}) {
    super(), Wi(this, Or, void 0), Wi(this, Kr, void 0), En(this, Kr, t), typeof e == "string" ? En(this, Or, Ne(e)) : e instanceof Uint8Array ? En(this, Or, e) : En(this, Or, Uint8Array.from(e));
  }
  /**
   * Checks if two zkLogin public identifiers are equal
   */
  equals(e) {
    return super.equals(e);
  }
  /**
   * Return the byte array representation of the zkLogin public identifier
   */
  toRawBytes() {
    return ei(this, Or);
  }
  /**
   * Return the Sui address associated with this ZkLogin public identifier
   */
  flag() {
    return Qe.ZkLogin;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(e, t) {
    throw Error("does not support");
  }
  /**
   * Verifies that the signature is valid for for the provided PersonalMessage
   */
  verifyPersonalMessage(e, t) {
    const r = li(t), n = new ui(r.publicKey).toSuiAddress();
    return Hi({
      address: n,
      bytes: ee(e),
      signature: r.serializedSignature,
      intentScope: "PERSONAL_MESSAGE",
      client: ei(this, Kr)
    });
  }
  /**
   * Verifies that the signature is valid for for the provided Transaction
   */
  verifyTransaction(e, t) {
    const r = li(t), n = new ui(r.publicKey).toSuiAddress();
    return Hi({
      address: n,
      bytes: ee(e),
      signature: r.serializedSignature,
      intentScope: "TRANSACTION_DATA",
      client: ei(this, Kr)
    });
  }
};
let so = ui;
Or = /* @__PURE__ */ new WeakMap();
Kr = /* @__PURE__ */ new WeakMap();
function oo(e, t, r) {
  const n = dc(e, 32), a = new TextEncoder().encode(t), u = new Uint8Array(1 + a.length + n.length);
  return u.set([a.length], 0), u.set(a, 1), u.set(n, 1 + a.length), new so(u, r);
}
const pc = sc(`
	query Zklogin(
		$bytes: Base64!
		$signature: Base64!
		$intentScope: ZkLoginIntentScope!
		$author: SuiAddress!
	) {
		verifyZkloginSignature(
			bytes: $bytes
			signature: $signature
			intentScope: $intentScope
			author: $author
		) {
			success
			errors
		}
	}
`);
async function Hi({
  address: e,
  bytes: t,
  signature: r,
  intentScope: n,
  client: a = new eo({
    url: "https://sui-mainnet.mystenlabs.com/graphql"
  })
}) {
  var p, c;
  const u = await a.query({
    query: pc,
    variables: {
      bytes: t,
      signature: r,
      intentScope: n,
      author: e
    }
  });
  return ((p = u.data) == null ? void 0 : p.verifyZkloginSignature.success) === !0 && ((c = u.data) == null ? void 0 : c.verifyZkloginSignature.errors.length) === 0;
}
function li(e) {
  const t = typeof e == "string" ? Ne(e) : e;
  if (t[0] !== Qe.ZkLogin)
    throw new Error("Invalid signature scheme");
  const r = t.slice(1), { inputs: n, maxEpoch: a, userSignature: u } = hc(r), { issBase64Details: p, addressSeed: c } = n, y = uc(p, "iss"), m = oo(BigInt(c), y);
  return {
    serializedSignature: ee(t),
    signatureScheme: "ZkLogin",
    zkLogin: {
      inputs: n,
      maxEpoch: a,
      userSignature: u,
      iss: y,
      addressSeed: BigInt(c)
    },
    signature: t,
    publicKey: m.toRawBytes()
  };
}
function gc({
  signature: e,
  signatureScheme: t,
  publicKey: r
}) {
  if (!r)
    throw new Error("`publicKey` is required");
  const n = r.toRawBytes(), a = new Uint8Array(1 + e.length + n.length);
  return a.set([Qe[t]]), a.set(e, 1), a.set(n, 1 + e.length), ee(a);
}
function $r(e) {
  const t = Ne(e), r = Xs[t[0]];
  switch (r) {
    case "MultiSig":
      const n = Ae.MultiSig.parse(t.slice(1));
      return {
        serializedSignature: e,
        signatureScheme: r,
        multisig: n,
        bytes: t
      };
    case "ZkLogin":
      return li(e);
    case "ED25519":
    case "Secp256k1":
    case "Secp256r1":
      const a = Nf[r], u = t.slice(1, t.length - a), p = t.slice(1 + u.length);
      return {
        serializedSignature: e,
        signatureScheme: r,
        signature: u,
        publicKey: p,
        bytes: t
      };
    default:
      throw new Error("Unsupported signature scheme");
  }
}
class ao extends Ti {
  constructor(t, r) {
    super(), this.finished = !1, this.destroyed = !1, Ma(t);
    const n = cr(r);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new Error("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const a = this.blockLen, u = new Uint8Array(a);
    u.set(n.length > a ? t.create().update(n).digest() : n);
    for (let p = 0; p < u.length; p++)
      u[p] ^= 54;
    this.iHash.update(u), this.oHash = t.create();
    for (let p = 0; p < u.length; p++)
      u[p] ^= 106;
    this.oHash.update(u), u.fill(0);
  }
  update(t) {
    return Rr(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    Rr(this), an(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: r, iHash: n, finished: a, destroyed: u, blockLen: p, outputLen: c } = this;
    return t = t, t.finished = a, t.destroyed = u, t.blockLen = p, t.outputLen = c, t.oHash = r._cloneInto(t.oHash), t.iHash = n._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const fo = (e, t, r) => new ao(e, t).update(r).digest();
fo.create = (e, t) => new ao(e, t);
function xc(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const a = BigInt(32), u = BigInt(4294967295), p = Number(r >> a & u), c = Number(r & u), y = n ? 4 : 0, m = n ? 0 : 4;
  e.setUint32(t + y, p, n), e.setUint32(t + m, c, n);
}
const yc = (e, t, r) => e & t ^ ~e & r, wc = (e, t, r) => e & t ^ e & r ^ t & r;
class bc extends Ti {
  constructor(t, r, n, a) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = a, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = Zn(this.buffer);
  }
  update(t) {
    Rr(this);
    const { view: r, buffer: n, blockLen: a } = this;
    t = cr(t);
    const u = t.length;
    for (let p = 0; p < u; ) {
      const c = Math.min(a - this.pos, u - p);
      if (c === a) {
        const y = Zn(t);
        for (; a <= u - p; p += a)
          this.process(y, p);
        continue;
      }
      n.set(t.subarray(p, p + c), this.pos), this.pos += c, p += c, this.pos === a && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    Rr(this), zs(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: a, isLE: u } = this;
    let { pos: p } = this;
    r[p++] = 128, this.buffer.subarray(p).fill(0), this.padOffset > a - p && (this.process(n, 0), p = 0);
    for (let v = p; v < a; v++)
      r[v] = 0;
    xc(n, a - 8, BigInt(this.length * 8), u), this.process(n, 0);
    const c = Zn(t), y = this.outputLen;
    if (y % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const m = y / 4, T = this.get();
    if (m > T.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let v = 0; v < m; v++)
      c.setUint32(4 * v, T[v], u);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: a, finished: u, destroyed: p, pos: c } = this;
    return t.length = a, t.pos = c, t.finished = u, t.destroyed = p, a % r && t.buffer.set(n), t;
  }
}
const mc = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), nr = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), ir = /* @__PURE__ */ new Uint32Array(64);
class Ec extends bc {
  constructor() {
    super(64, 32, 8, !1), this.A = nr[0] | 0, this.B = nr[1] | 0, this.C = nr[2] | 0, this.D = nr[3] | 0, this.E = nr[4] | 0, this.F = nr[5] | 0, this.G = nr[6] | 0, this.H = nr[7] | 0;
  }
  get() {
    const { A: t, B: r, C: n, D: a, E: u, F: p, G: c, H: y } = this;
    return [t, r, n, a, u, p, c, y];
  }
  // prettier-ignore
  set(t, r, n, a, u, p, c, y) {
    this.A = t | 0, this.B = r | 0, this.C = n | 0, this.D = a | 0, this.E = u | 0, this.F = p | 0, this.G = c | 0, this.H = y | 0;
  }
  process(t, r) {
    for (let v = 0; v < 16; v++, r += 4)
      ir[v] = t.getUint32(r, !1);
    for (let v = 16; v < 64; v++) {
      const V = ir[v - 15], M = ir[v - 2], F = Ve(V, 7) ^ Ve(V, 18) ^ V >>> 3, N = Ve(M, 17) ^ Ve(M, 19) ^ M >>> 10;
      ir[v] = N + ir[v - 7] + F + ir[v - 16] | 0;
    }
    let { A: n, B: a, C: u, D: p, E: c, F: y, G: m, H: T } = this;
    for (let v = 0; v < 64; v++) {
      const V = Ve(c, 6) ^ Ve(c, 11) ^ Ve(c, 25), M = T + V + yc(c, y, m) + mc[v] + ir[v] | 0, N = (Ve(n, 2) ^ Ve(n, 13) ^ Ve(n, 22)) + wc(n, a, u) | 0;
      T = m, m = y, y = c, c = p + M | 0, p = u, u = a, a = n, n = M + N | 0;
    }
    n = n + this.A | 0, a = a + this.B | 0, u = u + this.C | 0, p = p + this.D | 0, c = c + this.E | 0, y = y + this.F | 0, m = m + this.G | 0, T = T + this.H | 0, this.set(n, a, u, p, c, y, m, T);
  }
  roundClean() {
    ir.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const Pn = /* @__PURE__ */ Pa(() => new Ec());
var sn = {};
Object.defineProperty(sn, "__esModule", { value: !0 });
sn.bech32m = sn.bech32 = void 0;
const Ln = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", co = {};
for (let e = 0; e < Ln.length; e++) {
  const t = Ln.charAt(e);
  co[t] = e;
}
function Fr(e) {
  const t = e >> 25;
  return (e & 33554431) << 5 ^ -(t >> 0 & 1) & 996825010 ^ -(t >> 1 & 1) & 642813549 ^ -(t >> 2 & 1) & 513874426 ^ -(t >> 3 & 1) & 1027748829 ^ -(t >> 4 & 1) & 705979059;
}
function Ki(e) {
  let t = 1;
  for (let r = 0; r < e.length; ++r) {
    const n = e.charCodeAt(r);
    if (n < 33 || n > 126)
      return "Invalid prefix (" + e + ")";
    t = Fr(t) ^ n >> 5;
  }
  t = Fr(t);
  for (let r = 0; r < e.length; ++r) {
    const n = e.charCodeAt(r);
    t = Fr(t) ^ n & 31;
  }
  return t;
}
function Oi(e, t, r, n) {
  let a = 0, u = 0;
  const p = (1 << r) - 1, c = [];
  for (let y = 0; y < e.length; ++y)
    for (a = a << t | e[y], u += t; u >= r; )
      u -= r, c.push(a >> u & p);
  if (n)
    u > 0 && c.push(a << r - u & p);
  else {
    if (u >= t)
      return "Excess padding";
    if (a << r - u & p)
      return "Non-zero padding";
  }
  return c;
}
function Sc(e) {
  return Oi(e, 8, 5, !0);
}
function vc(e) {
  const t = Oi(e, 5, 8, !1);
  if (Array.isArray(t))
    return t;
}
function Bc(e) {
  const t = Oi(e, 5, 8, !1);
  if (Array.isArray(t))
    return t;
  throw new Error(t);
}
function uo(e) {
  let t;
  e === "bech32" ? t = 1 : t = 734539939;
  function r(p, c, y) {
    if (y = y || 90, p.length + 7 + c.length > y)
      throw new TypeError("Exceeds length limit");
    p = p.toLowerCase();
    let m = Ki(p);
    if (typeof m == "string")
      throw new Error(m);
    let T = p + "1";
    for (let v = 0; v < c.length; ++v) {
      const V = c[v];
      if (V >> 5)
        throw new Error("Non 5-bit word");
      m = Fr(m) ^ V, T += Ln.charAt(V);
    }
    for (let v = 0; v < 6; ++v)
      m = Fr(m);
    m ^= t;
    for (let v = 0; v < 6; ++v) {
      const V = m >> (5 - v) * 5 & 31;
      T += Ln.charAt(V);
    }
    return T;
  }
  function n(p, c) {
    if (c = c || 90, p.length < 8)
      return p + " too short";
    if (p.length > c)
      return "Exceeds length limit";
    const y = p.toLowerCase(), m = p.toUpperCase();
    if (p !== y && p !== m)
      return "Mixed-case string " + p;
    p = y;
    const T = p.lastIndexOf("1");
    if (T === -1)
      return "No separator character for " + p;
    if (T === 0)
      return "Missing prefix for " + p;
    const v = p.slice(0, T), V = p.slice(T + 1);
    if (V.length < 6)
      return "Data too short";
    let M = Ki(v);
    if (typeof M == "string")
      return M;
    const F = [];
    for (let N = 0; N < V.length; ++N) {
      const D = V.charAt(N), P = co[D];
      if (P === void 0)
        return "Unknown character " + D;
      M = Fr(M) ^ P, !(N + 6 >= V.length) && F.push(P);
    }
    return M !== t ? "Invalid checksum for " + p : { prefix: v, words: F };
  }
  function a(p, c) {
    const y = n(p, c);
    if (typeof y == "object")
      return y;
  }
  function u(p, c) {
    const y = n(p, c);
    if (typeof y == "object")
      return y;
    throw new Error(y);
  }
  return {
    decodeUnsafe: a,
    decode: u,
    encode: r,
    toWords: Sc,
    fromWordsUnsafe: vc,
    fromWords: Bc
  };
}
sn.bech32 = uo("bech32");
sn.bech32m = uo("bech32m");
class Ic {
  /**
   * Sign messages with a specific intent. By combining the message bytes with the intent before hashing and signing,
   * it ensures that a signed message is tied to a specific purpose and domain separator is provided
   */
  async signWithIntent(t, r) {
    const n = Zs(r, t), a = kn(n, { dkLen: 32 });
    return {
      signature: gc({
        signature: await this.sign(a),
        signatureScheme: this.getKeyScheme(),
        publicKey: this.getPublicKey()
      }),
      bytes: ee(t)
    };
  }
  /**
   * Signs provided transaction by calling `signWithIntent()` with a `TransactionData` provided as intent scope
   */
  async signTransaction(t) {
    return this.signWithIntent(t, "TransactionData");
  }
  /**
   * Signs provided personal message by calling `signWithIntent()` with a `PersonalMessage` provided as intent scope
   */
  async signPersonalMessage(t) {
    const { signature: r } = await this.signWithIntent(
      w.vector(w.u8()).serialize(t).toBytes(),
      "PersonalMessage"
    );
    return {
      bytes: ee(t),
      signature: r
    };
  }
  toSuiAddress() {
    return this.getPublicKey().toSuiAddress();
  }
}
function Ac(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var lo = { exports: {} };
const _c = {}, Tc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _c
}, Symbol.toStringTag, { value: "Module" })), Nc = /* @__PURE__ */ Go(Tc);
(function(e) {
  (function(t) {
    var r = function(f) {
      var d, l = new Float64Array(16);
      if (f) for (d = 0; d < f.length; d++) l[d] = f[d];
      return l;
    }, n = function() {
      throw new Error("no PRNG");
    }, a = new Uint8Array(16), u = new Uint8Array(32);
    u[0] = 9;
    var p = r(), c = r([1]), y = r([56129, 1]), m = r([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), T = r([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), v = r([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), V = r([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), M = r([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function F(f, d, l, i) {
      f[d] = l >> 24 & 255, f[d + 1] = l >> 16 & 255, f[d + 2] = l >> 8 & 255, f[d + 3] = l & 255, f[d + 4] = i >> 24 & 255, f[d + 5] = i >> 16 & 255, f[d + 6] = i >> 8 & 255, f[d + 7] = i & 255;
    }
    function N(f, d, l, i, g) {
      var S, B = 0;
      for (S = 0; S < g; S++) B |= f[d + S] ^ l[i + S];
      return (1 & B - 1 >>> 8) - 1;
    }
    function D(f, d, l, i) {
      return N(f, d, l, i, 16);
    }
    function P(f, d, l, i) {
      return N(f, d, l, i, 32);
    }
    function et(f, d, l, i) {
      for (var g = i[0] & 255 | (i[1] & 255) << 8 | (i[2] & 255) << 16 | (i[3] & 255) << 24, S = l[0] & 255 | (l[1] & 255) << 8 | (l[2] & 255) << 16 | (l[3] & 255) << 24, B = l[4] & 255 | (l[5] & 255) << 8 | (l[6] & 255) << 16 | (l[7] & 255) << 24, k = l[8] & 255 | (l[9] & 255) << 8 | (l[10] & 255) << 16 | (l[11] & 255) << 24, $ = l[12] & 255 | (l[13] & 255) << 8 | (l[14] & 255) << 16 | (l[15] & 255) << 24, rt = i[4] & 255 | (i[5] & 255) << 8 | (i[6] & 255) << 16 | (i[7] & 255) << 24, W = d[0] & 255 | (d[1] & 255) << 8 | (d[2] & 255) << 16 | (d[3] & 255) << 24, Lt = d[4] & 255 | (d[5] & 255) << 8 | (d[6] & 255) << 16 | (d[7] & 255) << 24, Z = d[8] & 255 | (d[9] & 255) << 8 | (d[10] & 255) << 16 | (d[11] & 255) << 24, ut = d[12] & 255 | (d[13] & 255) << 8 | (d[14] & 255) << 16 | (d[15] & 255) << 24, ht = i[8] & 255 | (i[9] & 255) << 8 | (i[10] & 255) << 16 | (i[11] & 255) << 24, bt = l[16] & 255 | (l[17] & 255) << 8 | (l[18] & 255) << 16 | (l[19] & 255) << 24, wt = l[20] & 255 | (l[21] & 255) << 8 | (l[22] & 255) << 16 | (l[23] & 255) << 24, dt = l[24] & 255 | (l[25] & 255) << 8 | (l[26] & 255) << 16 | (l[27] & 255) << 24, gt = l[28] & 255 | (l[29] & 255) << 8 | (l[30] & 255) << 16 | (l[31] & 255) << 24, pt = i[12] & 255 | (i[13] & 255) << 8 | (i[14] & 255) << 16 | (i[15] & 255) << 24, X = g, st = S, H = B, J = k, tt = $, q = rt, A = W, _ = Lt, L = Z, O = ut, C = ht, R = bt, ft = wt, mt = dt, vt = gt, Et = pt, b, It = 0; It < 20; It += 2)
        b = X + ft | 0, tt ^= b << 7 | b >>> 25, b = tt + X | 0, L ^= b << 9 | b >>> 23, b = L + tt | 0, ft ^= b << 13 | b >>> 19, b = ft + L | 0, X ^= b << 18 | b >>> 14, b = q + st | 0, O ^= b << 7 | b >>> 25, b = O + q | 0, mt ^= b << 9 | b >>> 23, b = mt + O | 0, st ^= b << 13 | b >>> 19, b = st + mt | 0, q ^= b << 18 | b >>> 14, b = C + A | 0, vt ^= b << 7 | b >>> 25, b = vt + C | 0, H ^= b << 9 | b >>> 23, b = H + vt | 0, A ^= b << 13 | b >>> 19, b = A + H | 0, C ^= b << 18 | b >>> 14, b = Et + R | 0, J ^= b << 7 | b >>> 25, b = J + Et | 0, _ ^= b << 9 | b >>> 23, b = _ + J | 0, R ^= b << 13 | b >>> 19, b = R + _ | 0, Et ^= b << 18 | b >>> 14, b = X + J | 0, st ^= b << 7 | b >>> 25, b = st + X | 0, H ^= b << 9 | b >>> 23, b = H + st | 0, J ^= b << 13 | b >>> 19, b = J + H | 0, X ^= b << 18 | b >>> 14, b = q + tt | 0, A ^= b << 7 | b >>> 25, b = A + q | 0, _ ^= b << 9 | b >>> 23, b = _ + A | 0, tt ^= b << 13 | b >>> 19, b = tt + _ | 0, q ^= b << 18 | b >>> 14, b = C + O | 0, R ^= b << 7 | b >>> 25, b = R + C | 0, L ^= b << 9 | b >>> 23, b = L + R | 0, O ^= b << 13 | b >>> 19, b = O + L | 0, C ^= b << 18 | b >>> 14, b = Et + vt | 0, ft ^= b << 7 | b >>> 25, b = ft + Et | 0, mt ^= b << 9 | b >>> 23, b = mt + ft | 0, vt ^= b << 13 | b >>> 19, b = vt + mt | 0, Et ^= b << 18 | b >>> 14;
      X = X + g | 0, st = st + S | 0, H = H + B | 0, J = J + k | 0, tt = tt + $ | 0, q = q + rt | 0, A = A + W | 0, _ = _ + Lt | 0, L = L + Z | 0, O = O + ut | 0, C = C + ht | 0, R = R + bt | 0, ft = ft + wt | 0, mt = mt + dt | 0, vt = vt + gt | 0, Et = Et + pt | 0, f[0] = X >>> 0 & 255, f[1] = X >>> 8 & 255, f[2] = X >>> 16 & 255, f[3] = X >>> 24 & 255, f[4] = st >>> 0 & 255, f[5] = st >>> 8 & 255, f[6] = st >>> 16 & 255, f[7] = st >>> 24 & 255, f[8] = H >>> 0 & 255, f[9] = H >>> 8 & 255, f[10] = H >>> 16 & 255, f[11] = H >>> 24 & 255, f[12] = J >>> 0 & 255, f[13] = J >>> 8 & 255, f[14] = J >>> 16 & 255, f[15] = J >>> 24 & 255, f[16] = tt >>> 0 & 255, f[17] = tt >>> 8 & 255, f[18] = tt >>> 16 & 255, f[19] = tt >>> 24 & 255, f[20] = q >>> 0 & 255, f[21] = q >>> 8 & 255, f[22] = q >>> 16 & 255, f[23] = q >>> 24 & 255, f[24] = A >>> 0 & 255, f[25] = A >>> 8 & 255, f[26] = A >>> 16 & 255, f[27] = A >>> 24 & 255, f[28] = _ >>> 0 & 255, f[29] = _ >>> 8 & 255, f[30] = _ >>> 16 & 255, f[31] = _ >>> 24 & 255, f[32] = L >>> 0 & 255, f[33] = L >>> 8 & 255, f[34] = L >>> 16 & 255, f[35] = L >>> 24 & 255, f[36] = O >>> 0 & 255, f[37] = O >>> 8 & 255, f[38] = O >>> 16 & 255, f[39] = O >>> 24 & 255, f[40] = C >>> 0 & 255, f[41] = C >>> 8 & 255, f[42] = C >>> 16 & 255, f[43] = C >>> 24 & 255, f[44] = R >>> 0 & 255, f[45] = R >>> 8 & 255, f[46] = R >>> 16 & 255, f[47] = R >>> 24 & 255, f[48] = ft >>> 0 & 255, f[49] = ft >>> 8 & 255, f[50] = ft >>> 16 & 255, f[51] = ft >>> 24 & 255, f[52] = mt >>> 0 & 255, f[53] = mt >>> 8 & 255, f[54] = mt >>> 16 & 255, f[55] = mt >>> 24 & 255, f[56] = vt >>> 0 & 255, f[57] = vt >>> 8 & 255, f[58] = vt >>> 16 & 255, f[59] = vt >>> 24 & 255, f[60] = Et >>> 0 & 255, f[61] = Et >>> 8 & 255, f[62] = Et >>> 16 & 255, f[63] = Et >>> 24 & 255;
    }
    function K(f, d, l, i) {
      for (var g = i[0] & 255 | (i[1] & 255) << 8 | (i[2] & 255) << 16 | (i[3] & 255) << 24, S = l[0] & 255 | (l[1] & 255) << 8 | (l[2] & 255) << 16 | (l[3] & 255) << 24, B = l[4] & 255 | (l[5] & 255) << 8 | (l[6] & 255) << 16 | (l[7] & 255) << 24, k = l[8] & 255 | (l[9] & 255) << 8 | (l[10] & 255) << 16 | (l[11] & 255) << 24, $ = l[12] & 255 | (l[13] & 255) << 8 | (l[14] & 255) << 16 | (l[15] & 255) << 24, rt = i[4] & 255 | (i[5] & 255) << 8 | (i[6] & 255) << 16 | (i[7] & 255) << 24, W = d[0] & 255 | (d[1] & 255) << 8 | (d[2] & 255) << 16 | (d[3] & 255) << 24, Lt = d[4] & 255 | (d[5] & 255) << 8 | (d[6] & 255) << 16 | (d[7] & 255) << 24, Z = d[8] & 255 | (d[9] & 255) << 8 | (d[10] & 255) << 16 | (d[11] & 255) << 24, ut = d[12] & 255 | (d[13] & 255) << 8 | (d[14] & 255) << 16 | (d[15] & 255) << 24, ht = i[8] & 255 | (i[9] & 255) << 8 | (i[10] & 255) << 16 | (i[11] & 255) << 24, bt = l[16] & 255 | (l[17] & 255) << 8 | (l[18] & 255) << 16 | (l[19] & 255) << 24, wt = l[20] & 255 | (l[21] & 255) << 8 | (l[22] & 255) << 16 | (l[23] & 255) << 24, dt = l[24] & 255 | (l[25] & 255) << 8 | (l[26] & 255) << 16 | (l[27] & 255) << 24, gt = l[28] & 255 | (l[29] & 255) << 8 | (l[30] & 255) << 16 | (l[31] & 255) << 24, pt = i[12] & 255 | (i[13] & 255) << 8 | (i[14] & 255) << 16 | (i[15] & 255) << 24, X = g, st = S, H = B, J = k, tt = $, q = rt, A = W, _ = Lt, L = Z, O = ut, C = ht, R = bt, ft = wt, mt = dt, vt = gt, Et = pt, b, It = 0; It < 20; It += 2)
        b = X + ft | 0, tt ^= b << 7 | b >>> 25, b = tt + X | 0, L ^= b << 9 | b >>> 23, b = L + tt | 0, ft ^= b << 13 | b >>> 19, b = ft + L | 0, X ^= b << 18 | b >>> 14, b = q + st | 0, O ^= b << 7 | b >>> 25, b = O + q | 0, mt ^= b << 9 | b >>> 23, b = mt + O | 0, st ^= b << 13 | b >>> 19, b = st + mt | 0, q ^= b << 18 | b >>> 14, b = C + A | 0, vt ^= b << 7 | b >>> 25, b = vt + C | 0, H ^= b << 9 | b >>> 23, b = H + vt | 0, A ^= b << 13 | b >>> 19, b = A + H | 0, C ^= b << 18 | b >>> 14, b = Et + R | 0, J ^= b << 7 | b >>> 25, b = J + Et | 0, _ ^= b << 9 | b >>> 23, b = _ + J | 0, R ^= b << 13 | b >>> 19, b = R + _ | 0, Et ^= b << 18 | b >>> 14, b = X + J | 0, st ^= b << 7 | b >>> 25, b = st + X | 0, H ^= b << 9 | b >>> 23, b = H + st | 0, J ^= b << 13 | b >>> 19, b = J + H | 0, X ^= b << 18 | b >>> 14, b = q + tt | 0, A ^= b << 7 | b >>> 25, b = A + q | 0, _ ^= b << 9 | b >>> 23, b = _ + A | 0, tt ^= b << 13 | b >>> 19, b = tt + _ | 0, q ^= b << 18 | b >>> 14, b = C + O | 0, R ^= b << 7 | b >>> 25, b = R + C | 0, L ^= b << 9 | b >>> 23, b = L + R | 0, O ^= b << 13 | b >>> 19, b = O + L | 0, C ^= b << 18 | b >>> 14, b = Et + vt | 0, ft ^= b << 7 | b >>> 25, b = ft + Et | 0, mt ^= b << 9 | b >>> 23, b = mt + ft | 0, vt ^= b << 13 | b >>> 19, b = vt + mt | 0, Et ^= b << 18 | b >>> 14;
      f[0] = X >>> 0 & 255, f[1] = X >>> 8 & 255, f[2] = X >>> 16 & 255, f[3] = X >>> 24 & 255, f[4] = q >>> 0 & 255, f[5] = q >>> 8 & 255, f[6] = q >>> 16 & 255, f[7] = q >>> 24 & 255, f[8] = C >>> 0 & 255, f[9] = C >>> 8 & 255, f[10] = C >>> 16 & 255, f[11] = C >>> 24 & 255, f[12] = Et >>> 0 & 255, f[13] = Et >>> 8 & 255, f[14] = Et >>> 16 & 255, f[15] = Et >>> 24 & 255, f[16] = A >>> 0 & 255, f[17] = A >>> 8 & 255, f[18] = A >>> 16 & 255, f[19] = A >>> 24 & 255, f[20] = _ >>> 0 & 255, f[21] = _ >>> 8 & 255, f[22] = _ >>> 16 & 255, f[23] = _ >>> 24 & 255, f[24] = L >>> 0 & 255, f[25] = L >>> 8 & 255, f[26] = L >>> 16 & 255, f[27] = L >>> 24 & 255, f[28] = O >>> 0 & 255, f[29] = O >>> 8 & 255, f[30] = O >>> 16 & 255, f[31] = O >>> 24 & 255;
    }
    function ot(f, d, l, i) {
      et(f, d, l, i);
    }
    function nt(f, d, l, i) {
      K(f, d, l, i);
    }
    var j = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function it(f, d, l, i, g, S, B) {
      var k = new Uint8Array(16), $ = new Uint8Array(64), rt, W;
      for (W = 0; W < 16; W++) k[W] = 0;
      for (W = 0; W < 8; W++) k[W] = S[W];
      for (; g >= 64; ) {
        for (ot($, k, B, j), W = 0; W < 64; W++) f[d + W] = l[i + W] ^ $[W];
        for (rt = 1, W = 8; W < 16; W++)
          rt = rt + (k[W] & 255) | 0, k[W] = rt & 255, rt >>>= 8;
        g -= 64, d += 64, i += 64;
      }
      if (g > 0)
        for (ot($, k, B, j), W = 0; W < g; W++) f[d + W] = l[i + W] ^ $[W];
      return 0;
    }
    function lt(f, d, l, i, g) {
      var S = new Uint8Array(16), B = new Uint8Array(64), k, $;
      for ($ = 0; $ < 16; $++) S[$] = 0;
      for ($ = 0; $ < 8; $++) S[$] = i[$];
      for (; l >= 64; ) {
        for (ot(B, S, g, j), $ = 0; $ < 64; $++) f[d + $] = B[$];
        for (k = 1, $ = 8; $ < 16; $++)
          k = k + (S[$] & 255) | 0, S[$] = k & 255, k >>>= 8;
        l -= 64, d += 64;
      }
      if (l > 0)
        for (ot(B, S, g, j), $ = 0; $ < l; $++) f[d + $] = B[$];
      return 0;
    }
    function ce(f, d, l, i, g) {
      var S = new Uint8Array(32);
      nt(S, i, g, j);
      for (var B = new Uint8Array(8), k = 0; k < 8; k++) B[k] = i[k + 16];
      return lt(f, d, l, B, S);
    }
    function Pt(f, d, l, i, g, S, B) {
      var k = new Uint8Array(32);
      nt(k, S, B, j);
      for (var $ = new Uint8Array(8), rt = 0; rt < 8; rt++) $[rt] = S[rt + 16];
      return it(f, d, l, i, g, $, k);
    }
    var At = function(f) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var d, l, i, g, S, B, k, $;
      d = f[0] & 255 | (f[1] & 255) << 8, this.r[0] = d & 8191, l = f[2] & 255 | (f[3] & 255) << 8, this.r[1] = (d >>> 13 | l << 3) & 8191, i = f[4] & 255 | (f[5] & 255) << 8, this.r[2] = (l >>> 10 | i << 6) & 7939, g = f[6] & 255 | (f[7] & 255) << 8, this.r[3] = (i >>> 7 | g << 9) & 8191, S = f[8] & 255 | (f[9] & 255) << 8, this.r[4] = (g >>> 4 | S << 12) & 255, this.r[5] = S >>> 1 & 8190, B = f[10] & 255 | (f[11] & 255) << 8, this.r[6] = (S >>> 14 | B << 2) & 8191, k = f[12] & 255 | (f[13] & 255) << 8, this.r[7] = (B >>> 11 | k << 5) & 8065, $ = f[14] & 255 | (f[15] & 255) << 8, this.r[8] = (k >>> 8 | $ << 8) & 8191, this.r[9] = $ >>> 5 & 127, this.pad[0] = f[16] & 255 | (f[17] & 255) << 8, this.pad[1] = f[18] & 255 | (f[19] & 255) << 8, this.pad[2] = f[20] & 255 | (f[21] & 255) << 8, this.pad[3] = f[22] & 255 | (f[23] & 255) << 8, this.pad[4] = f[24] & 255 | (f[25] & 255) << 8, this.pad[5] = f[26] & 255 | (f[27] & 255) << 8, this.pad[6] = f[28] & 255 | (f[29] & 255) << 8, this.pad[7] = f[30] & 255 | (f[31] & 255) << 8;
    };
    At.prototype.blocks = function(f, d, l) {
      for (var i = this.fin ? 0 : 2048, g, S, B, k, $, rt, W, Lt, Z, ut, ht, bt, wt, dt, gt, pt, X, st, H, J = this.h[0], tt = this.h[1], q = this.h[2], A = this.h[3], _ = this.h[4], L = this.h[5], O = this.h[6], C = this.h[7], R = this.h[8], ft = this.h[9], mt = this.r[0], vt = this.r[1], Et = this.r[2], b = this.r[3], It = this.r[4], Dt = this.r[5], Ft = this.r[6], Bt = this.r[7], Ot = this.r[8], kt = this.r[9]; l >= 16; )
        g = f[d + 0] & 255 | (f[d + 1] & 255) << 8, J += g & 8191, S = f[d + 2] & 255 | (f[d + 3] & 255) << 8, tt += (g >>> 13 | S << 3) & 8191, B = f[d + 4] & 255 | (f[d + 5] & 255) << 8, q += (S >>> 10 | B << 6) & 8191, k = f[d + 6] & 255 | (f[d + 7] & 255) << 8, A += (B >>> 7 | k << 9) & 8191, $ = f[d + 8] & 255 | (f[d + 9] & 255) << 8, _ += (k >>> 4 | $ << 12) & 8191, L += $ >>> 1 & 8191, rt = f[d + 10] & 255 | (f[d + 11] & 255) << 8, O += ($ >>> 14 | rt << 2) & 8191, W = f[d + 12] & 255 | (f[d + 13] & 255) << 8, C += (rt >>> 11 | W << 5) & 8191, Lt = f[d + 14] & 255 | (f[d + 15] & 255) << 8, R += (W >>> 8 | Lt << 8) & 8191, ft += Lt >>> 5 | i, Z = 0, ut = Z, ut += J * mt, ut += tt * (5 * kt), ut += q * (5 * Ot), ut += A * (5 * Bt), ut += _ * (5 * Ft), Z = ut >>> 13, ut &= 8191, ut += L * (5 * Dt), ut += O * (5 * It), ut += C * (5 * b), ut += R * (5 * Et), ut += ft * (5 * vt), Z += ut >>> 13, ut &= 8191, ht = Z, ht += J * vt, ht += tt * mt, ht += q * (5 * kt), ht += A * (5 * Ot), ht += _ * (5 * Bt), Z = ht >>> 13, ht &= 8191, ht += L * (5 * Ft), ht += O * (5 * Dt), ht += C * (5 * It), ht += R * (5 * b), ht += ft * (5 * Et), Z += ht >>> 13, ht &= 8191, bt = Z, bt += J * Et, bt += tt * vt, bt += q * mt, bt += A * (5 * kt), bt += _ * (5 * Ot), Z = bt >>> 13, bt &= 8191, bt += L * (5 * Bt), bt += O * (5 * Ft), bt += C * (5 * Dt), bt += R * (5 * It), bt += ft * (5 * b), Z += bt >>> 13, bt &= 8191, wt = Z, wt += J * b, wt += tt * Et, wt += q * vt, wt += A * mt, wt += _ * (5 * kt), Z = wt >>> 13, wt &= 8191, wt += L * (5 * Ot), wt += O * (5 * Bt), wt += C * (5 * Ft), wt += R * (5 * Dt), wt += ft * (5 * It), Z += wt >>> 13, wt &= 8191, dt = Z, dt += J * It, dt += tt * b, dt += q * Et, dt += A * vt, dt += _ * mt, Z = dt >>> 13, dt &= 8191, dt += L * (5 * kt), dt += O * (5 * Ot), dt += C * (5 * Bt), dt += R * (5 * Ft), dt += ft * (5 * Dt), Z += dt >>> 13, dt &= 8191, gt = Z, gt += J * Dt, gt += tt * It, gt += q * b, gt += A * Et, gt += _ * vt, Z = gt >>> 13, gt &= 8191, gt += L * mt, gt += O * (5 * kt), gt += C * (5 * Ot), gt += R * (5 * Bt), gt += ft * (5 * Ft), Z += gt >>> 13, gt &= 8191, pt = Z, pt += J * Ft, pt += tt * Dt, pt += q * It, pt += A * b, pt += _ * Et, Z = pt >>> 13, pt &= 8191, pt += L * vt, pt += O * mt, pt += C * (5 * kt), pt += R * (5 * Ot), pt += ft * (5 * Bt), Z += pt >>> 13, pt &= 8191, X = Z, X += J * Bt, X += tt * Ft, X += q * Dt, X += A * It, X += _ * b, Z = X >>> 13, X &= 8191, X += L * Et, X += O * vt, X += C * mt, X += R * (5 * kt), X += ft * (5 * Ot), Z += X >>> 13, X &= 8191, st = Z, st += J * Ot, st += tt * Bt, st += q * Ft, st += A * Dt, st += _ * It, Z = st >>> 13, st &= 8191, st += L * b, st += O * Et, st += C * vt, st += R * mt, st += ft * (5 * kt), Z += st >>> 13, st &= 8191, H = Z, H += J * kt, H += tt * Ot, H += q * Bt, H += A * Ft, H += _ * Dt, Z = H >>> 13, H &= 8191, H += L * It, H += O * b, H += C * Et, H += R * vt, H += ft * mt, Z += H >>> 13, H &= 8191, Z = (Z << 2) + Z | 0, Z = Z + ut | 0, ut = Z & 8191, Z = Z >>> 13, ht += Z, J = ut, tt = ht, q = bt, A = wt, _ = dt, L = gt, O = pt, C = X, R = st, ft = H, d += 16, l -= 16;
      this.h[0] = J, this.h[1] = tt, this.h[2] = q, this.h[3] = A, this.h[4] = _, this.h[5] = L, this.h[6] = O, this.h[7] = C, this.h[8] = R, this.h[9] = ft;
    }, At.prototype.finish = function(f, d) {
      var l = new Uint16Array(10), i, g, S, B;
      if (this.leftover) {
        for (B = this.leftover, this.buffer[B++] = 1; B < 16; B++) this.buffer[B] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (i = this.h[1] >>> 13, this.h[1] &= 8191, B = 2; B < 10; B++)
        this.h[B] += i, i = this.h[B] >>> 13, this.h[B] &= 8191;
      for (this.h[0] += i * 5, i = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += i, i = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += i, l[0] = this.h[0] + 5, i = l[0] >>> 13, l[0] &= 8191, B = 1; B < 10; B++)
        l[B] = this.h[B] + i, i = l[B] >>> 13, l[B] &= 8191;
      for (l[9] -= 8192, g = (i ^ 1) - 1, B = 0; B < 10; B++) l[B] &= g;
      for (g = ~g, B = 0; B < 10; B++) this.h[B] = this.h[B] & g | l[B];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, S = this.h[0] + this.pad[0], this.h[0] = S & 65535, B = 1; B < 8; B++)
        S = (this.h[B] + this.pad[B] | 0) + (S >>> 16) | 0, this.h[B] = S & 65535;
      f[d + 0] = this.h[0] >>> 0 & 255, f[d + 1] = this.h[0] >>> 8 & 255, f[d + 2] = this.h[1] >>> 0 & 255, f[d + 3] = this.h[1] >>> 8 & 255, f[d + 4] = this.h[2] >>> 0 & 255, f[d + 5] = this.h[2] >>> 8 & 255, f[d + 6] = this.h[3] >>> 0 & 255, f[d + 7] = this.h[3] >>> 8 & 255, f[d + 8] = this.h[4] >>> 0 & 255, f[d + 9] = this.h[4] >>> 8 & 255, f[d + 10] = this.h[5] >>> 0 & 255, f[d + 11] = this.h[5] >>> 8 & 255, f[d + 12] = this.h[6] >>> 0 & 255, f[d + 13] = this.h[6] >>> 8 & 255, f[d + 14] = this.h[7] >>> 0 & 255, f[d + 15] = this.h[7] >>> 8 & 255;
    }, At.prototype.update = function(f, d, l) {
      var i, g;
      if (this.leftover) {
        for (g = 16 - this.leftover, g > l && (g = l), i = 0; i < g; i++)
          this.buffer[this.leftover + i] = f[d + i];
        if (l -= g, d += g, this.leftover += g, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (l >= 16 && (g = l - l % 16, this.blocks(f, d, g), d += g, l -= g), l) {
        for (i = 0; i < l; i++)
          this.buffer[this.leftover + i] = f[d + i];
        this.leftover += l;
      }
    };
    function ie(f, d, l, i, g, S) {
      var B = new At(S);
      return B.update(l, i, g), B.finish(f, d), 0;
    }
    function ae(f, d, l, i, g, S) {
      var B = new Uint8Array(16);
      return ie(B, 0, l, i, g, S), D(f, d, B, 0);
    }
    function pe(f, d, l, i, g) {
      var S;
      if (l < 32) return -1;
      for (Pt(f, 0, d, 0, l, i, g), ie(f, 16, f, 32, l - 32, f), S = 0; S < 16; S++) f[S] = 0;
      return 0;
    }
    function z(f, d, l, i, g) {
      var S, B = new Uint8Array(32);
      if (l < 32 || (ce(B, 0, 32, i, g), ae(d, 16, d, 32, l - 32, B) !== 0)) return -1;
      for (Pt(f, 0, d, 0, l, i, g), S = 0; S < 32; S++) f[S] = 0;
      return 0;
    }
    function Y(f, d) {
      var l;
      for (l = 0; l < 16; l++) f[l] = d[l] | 0;
    }
    function yt(f) {
      var d, l, i = 1;
      for (d = 0; d < 16; d++)
        l = f[d] + i + 65535, i = Math.floor(l / 65536), f[d] = l - i * 65536;
      f[0] += i - 1 + 37 * (i - 1);
    }
    function Ut(f, d, l) {
      for (var i, g = ~(l - 1), S = 0; S < 16; S++)
        i = g & (f[S] ^ d[S]), f[S] ^= i, d[S] ^= i;
    }
    function _t(f, d) {
      var l, i, g, S = r(), B = r();
      for (l = 0; l < 16; l++) B[l] = d[l];
      for (yt(B), yt(B), yt(B), i = 0; i < 2; i++) {
        for (S[0] = B[0] - 65517, l = 1; l < 15; l++)
          S[l] = B[l] - 65535 - (S[l - 1] >> 16 & 1), S[l - 1] &= 65535;
        S[15] = B[15] - 32767 - (S[14] >> 16 & 1), g = S[15] >> 16 & 1, S[14] &= 65535, Ut(B, S, 1 - g);
      }
      for (l = 0; l < 16; l++)
        f[2 * l] = B[l] & 255, f[2 * l + 1] = B[l] >> 8;
    }
    function Gt(f, d) {
      var l = new Uint8Array(32), i = new Uint8Array(32);
      return _t(l, f), _t(i, d), P(l, 0, i, 0);
    }
    function Tt(f) {
      var d = new Uint8Array(32);
      return _t(d, f), d[0] & 1;
    }
    function Ct(f, d) {
      var l;
      for (l = 0; l < 16; l++) f[l] = d[2 * l] + (d[2 * l + 1] << 8);
      f[15] &= 32767;
    }
    function Yt(f, d, l) {
      for (var i = 0; i < 16; i++) f[i] = d[i] + l[i];
    }
    function qt(f, d, l) {
      for (var i = 0; i < 16; i++) f[i] = d[i] - l[i];
    }
    function ct(f, d, l) {
      var i, g, S = 0, B = 0, k = 0, $ = 0, rt = 0, W = 0, Lt = 0, Z = 0, ut = 0, ht = 0, bt = 0, wt = 0, dt = 0, gt = 0, pt = 0, X = 0, st = 0, H = 0, J = 0, tt = 0, q = 0, A = 0, _ = 0, L = 0, O = 0, C = 0, R = 0, ft = 0, mt = 0, vt = 0, Et = 0, b = l[0], It = l[1], Dt = l[2], Ft = l[3], Bt = l[4], Ot = l[5], kt = l[6], Qt = l[7], zt = l[8], Wt = l[9], Ht = l[10], Kt = l[11], se = l[12], le = l[13], he = l[14], de = l[15];
      i = d[0], S += i * b, B += i * It, k += i * Dt, $ += i * Ft, rt += i * Bt, W += i * Ot, Lt += i * kt, Z += i * Qt, ut += i * zt, ht += i * Wt, bt += i * Ht, wt += i * Kt, dt += i * se, gt += i * le, pt += i * he, X += i * de, i = d[1], B += i * b, k += i * It, $ += i * Dt, rt += i * Ft, W += i * Bt, Lt += i * Ot, Z += i * kt, ut += i * Qt, ht += i * zt, bt += i * Wt, wt += i * Ht, dt += i * Kt, gt += i * se, pt += i * le, X += i * he, st += i * de, i = d[2], k += i * b, $ += i * It, rt += i * Dt, W += i * Ft, Lt += i * Bt, Z += i * Ot, ut += i * kt, ht += i * Qt, bt += i * zt, wt += i * Wt, dt += i * Ht, gt += i * Kt, pt += i * se, X += i * le, st += i * he, H += i * de, i = d[3], $ += i * b, rt += i * It, W += i * Dt, Lt += i * Ft, Z += i * Bt, ut += i * Ot, ht += i * kt, bt += i * Qt, wt += i * zt, dt += i * Wt, gt += i * Ht, pt += i * Kt, X += i * se, st += i * le, H += i * he, J += i * de, i = d[4], rt += i * b, W += i * It, Lt += i * Dt, Z += i * Ft, ut += i * Bt, ht += i * Ot, bt += i * kt, wt += i * Qt, dt += i * zt, gt += i * Wt, pt += i * Ht, X += i * Kt, st += i * se, H += i * le, J += i * he, tt += i * de, i = d[5], W += i * b, Lt += i * It, Z += i * Dt, ut += i * Ft, ht += i * Bt, bt += i * Ot, wt += i * kt, dt += i * Qt, gt += i * zt, pt += i * Wt, X += i * Ht, st += i * Kt, H += i * se, J += i * le, tt += i * he, q += i * de, i = d[6], Lt += i * b, Z += i * It, ut += i * Dt, ht += i * Ft, bt += i * Bt, wt += i * Ot, dt += i * kt, gt += i * Qt, pt += i * zt, X += i * Wt, st += i * Ht, H += i * Kt, J += i * se, tt += i * le, q += i * he, A += i * de, i = d[7], Z += i * b, ut += i * It, ht += i * Dt, bt += i * Ft, wt += i * Bt, dt += i * Ot, gt += i * kt, pt += i * Qt, X += i * zt, st += i * Wt, H += i * Ht, J += i * Kt, tt += i * se, q += i * le, A += i * he, _ += i * de, i = d[8], ut += i * b, ht += i * It, bt += i * Dt, wt += i * Ft, dt += i * Bt, gt += i * Ot, pt += i * kt, X += i * Qt, st += i * zt, H += i * Wt, J += i * Ht, tt += i * Kt, q += i * se, A += i * le, _ += i * he, L += i * de, i = d[9], ht += i * b, bt += i * It, wt += i * Dt, dt += i * Ft, gt += i * Bt, pt += i * Ot, X += i * kt, st += i * Qt, H += i * zt, J += i * Wt, tt += i * Ht, q += i * Kt, A += i * se, _ += i * le, L += i * he, O += i * de, i = d[10], bt += i * b, wt += i * It, dt += i * Dt, gt += i * Ft, pt += i * Bt, X += i * Ot, st += i * kt, H += i * Qt, J += i * zt, tt += i * Wt, q += i * Ht, A += i * Kt, _ += i * se, L += i * le, O += i * he, C += i * de, i = d[11], wt += i * b, dt += i * It, gt += i * Dt, pt += i * Ft, X += i * Bt, st += i * Ot, H += i * kt, J += i * Qt, tt += i * zt, q += i * Wt, A += i * Ht, _ += i * Kt, L += i * se, O += i * le, C += i * he, R += i * de, i = d[12], dt += i * b, gt += i * It, pt += i * Dt, X += i * Ft, st += i * Bt, H += i * Ot, J += i * kt, tt += i * Qt, q += i * zt, A += i * Wt, _ += i * Ht, L += i * Kt, O += i * se, C += i * le, R += i * he, ft += i * de, i = d[13], gt += i * b, pt += i * It, X += i * Dt, st += i * Ft, H += i * Bt, J += i * Ot, tt += i * kt, q += i * Qt, A += i * zt, _ += i * Wt, L += i * Ht, O += i * Kt, C += i * se, R += i * le, ft += i * he, mt += i * de, i = d[14], pt += i * b, X += i * It, st += i * Dt, H += i * Ft, J += i * Bt, tt += i * Ot, q += i * kt, A += i * Qt, _ += i * zt, L += i * Wt, O += i * Ht, C += i * Kt, R += i * se, ft += i * le, mt += i * he, vt += i * de, i = d[15], X += i * b, st += i * It, H += i * Dt, J += i * Ft, tt += i * Bt, q += i * Ot, A += i * kt, _ += i * Qt, L += i * zt, O += i * Wt, C += i * Ht, R += i * Kt, ft += i * se, mt += i * le, vt += i * he, Et += i * de, S += 38 * st, B += 38 * H, k += 38 * J, $ += 38 * tt, rt += 38 * q, W += 38 * A, Lt += 38 * _, Z += 38 * L, ut += 38 * O, ht += 38 * C, bt += 38 * R, wt += 38 * ft, dt += 38 * mt, gt += 38 * vt, pt += 38 * Et, g = 1, i = S + g + 65535, g = Math.floor(i / 65536), S = i - g * 65536, i = B + g + 65535, g = Math.floor(i / 65536), B = i - g * 65536, i = k + g + 65535, g = Math.floor(i / 65536), k = i - g * 65536, i = $ + g + 65535, g = Math.floor(i / 65536), $ = i - g * 65536, i = rt + g + 65535, g = Math.floor(i / 65536), rt = i - g * 65536, i = W + g + 65535, g = Math.floor(i / 65536), W = i - g * 65536, i = Lt + g + 65535, g = Math.floor(i / 65536), Lt = i - g * 65536, i = Z + g + 65535, g = Math.floor(i / 65536), Z = i - g * 65536, i = ut + g + 65535, g = Math.floor(i / 65536), ut = i - g * 65536, i = ht + g + 65535, g = Math.floor(i / 65536), ht = i - g * 65536, i = bt + g + 65535, g = Math.floor(i / 65536), bt = i - g * 65536, i = wt + g + 65535, g = Math.floor(i / 65536), wt = i - g * 65536, i = dt + g + 65535, g = Math.floor(i / 65536), dt = i - g * 65536, i = gt + g + 65535, g = Math.floor(i / 65536), gt = i - g * 65536, i = pt + g + 65535, g = Math.floor(i / 65536), pt = i - g * 65536, i = X + g + 65535, g = Math.floor(i / 65536), X = i - g * 65536, S += g - 1 + 37 * (g - 1), g = 1, i = S + g + 65535, g = Math.floor(i / 65536), S = i - g * 65536, i = B + g + 65535, g = Math.floor(i / 65536), B = i - g * 65536, i = k + g + 65535, g = Math.floor(i / 65536), k = i - g * 65536, i = $ + g + 65535, g = Math.floor(i / 65536), $ = i - g * 65536, i = rt + g + 65535, g = Math.floor(i / 65536), rt = i - g * 65536, i = W + g + 65535, g = Math.floor(i / 65536), W = i - g * 65536, i = Lt + g + 65535, g = Math.floor(i / 65536), Lt = i - g * 65536, i = Z + g + 65535, g = Math.floor(i / 65536), Z = i - g * 65536, i = ut + g + 65535, g = Math.floor(i / 65536), ut = i - g * 65536, i = ht + g + 65535, g = Math.floor(i / 65536), ht = i - g * 65536, i = bt + g + 65535, g = Math.floor(i / 65536), bt = i - g * 65536, i = wt + g + 65535, g = Math.floor(i / 65536), wt = i - g * 65536, i = dt + g + 65535, g = Math.floor(i / 65536), dt = i - g * 65536, i = gt + g + 65535, g = Math.floor(i / 65536), gt = i - g * 65536, i = pt + g + 65535, g = Math.floor(i / 65536), pt = i - g * 65536, i = X + g + 65535, g = Math.floor(i / 65536), X = i - g * 65536, S += g - 1 + 37 * (g - 1), f[0] = S, f[1] = B, f[2] = k, f[3] = $, f[4] = rt, f[5] = W, f[6] = Lt, f[7] = Z, f[8] = ut, f[9] = ht, f[10] = bt, f[11] = wt, f[12] = dt, f[13] = gt, f[14] = pt, f[15] = X;
    }
    function Xt(f, d) {
      ct(f, d, d);
    }
    function ye(f, d) {
      var l = r(), i;
      for (i = 0; i < 16; i++) l[i] = d[i];
      for (i = 253; i >= 0; i--)
        Xt(l, l), i !== 2 && i !== 4 && ct(l, l, d);
      for (i = 0; i < 16; i++) f[i] = l[i];
    }
    function Be(f, d) {
      var l = r(), i;
      for (i = 0; i < 16; i++) l[i] = d[i];
      for (i = 250; i >= 0; i--)
        Xt(l, l), i !== 1 && ct(l, l, d);
      for (i = 0; i < 16; i++) f[i] = l[i];
    }
    function ue(f, d, l) {
      var i = new Uint8Array(32), g = new Float64Array(80), S, B, k = r(), $ = r(), rt = r(), W = r(), Lt = r(), Z = r();
      for (B = 0; B < 31; B++) i[B] = d[B];
      for (i[31] = d[31] & 127 | 64, i[0] &= 248, Ct(g, l), B = 0; B < 16; B++)
        $[B] = g[B], W[B] = k[B] = rt[B] = 0;
      for (k[0] = W[0] = 1, B = 254; B >= 0; --B)
        S = i[B >>> 3] >>> (B & 7) & 1, Ut(k, $, S), Ut(rt, W, S), Yt(Lt, k, rt), qt(k, k, rt), Yt(rt, $, W), qt($, $, W), Xt(W, Lt), Xt(Z, k), ct(k, rt, k), ct(rt, $, Lt), Yt(Lt, k, rt), qt(k, k, rt), Xt($, k), qt(rt, W, Z), ct(k, rt, y), Yt(k, k, W), ct(rt, rt, k), ct(k, W, Z), ct(W, $, g), Xt($, Lt), Ut(k, $, S), Ut(rt, W, S);
      for (B = 0; B < 16; B++)
        g[B + 16] = k[B], g[B + 32] = rt[B], g[B + 48] = $[B], g[B + 64] = W[B];
      var ut = g.subarray(32), ht = g.subarray(16);
      return ye(ut, ut), ct(ht, ht, ut), _t(f, ht), 0;
    }
    function we(f, d) {
      return ue(f, d, u);
    }
    function ur(f, d) {
      return n(d, 32), we(f, d);
    }
    function be(f, d, l) {
      var i = new Uint8Array(32);
      return ue(i, l, d), nt(f, a, i, j);
    }
    var Jt = pe, me = z;
    function Sr(f, d, l, i, g, S) {
      var B = new Uint8Array(32);
      return be(B, g, S), Jt(f, d, l, i, B);
    }
    function vr(f, d, l, i, g, S) {
      var B = new Uint8Array(32);
      return be(B, g, S), me(f, d, l, i, B);
    }
    var Br = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function ln(f, d, l, i) {
      for (var g = new Int32Array(16), S = new Int32Array(16), B, k, $, rt, W, Lt, Z, ut, ht, bt, wt, dt, gt, pt, X, st, H, J, tt, q, A, _, L, O, C, R, ft = f[0], mt = f[1], vt = f[2], Et = f[3], b = f[4], It = f[5], Dt = f[6], Ft = f[7], Bt = d[0], Ot = d[1], kt = d[2], Qt = d[3], zt = d[4], Wt = d[5], Ht = d[6], Kt = d[7], se = 0; i >= 128; ) {
        for (tt = 0; tt < 16; tt++)
          q = 8 * tt + se, g[tt] = l[q + 0] << 24 | l[q + 1] << 16 | l[q + 2] << 8 | l[q + 3], S[tt] = l[q + 4] << 24 | l[q + 5] << 16 | l[q + 6] << 8 | l[q + 7];
        for (tt = 0; tt < 80; tt++)
          if (B = ft, k = mt, $ = vt, rt = Et, W = b, Lt = It, Z = Dt, ut = Ft, ht = Bt, bt = Ot, wt = kt, dt = Qt, gt = zt, pt = Wt, X = Ht, st = Kt, A = Ft, _ = Kt, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = (b >>> 14 | zt << 18) ^ (b >>> 18 | zt << 14) ^ (zt >>> 9 | b << 23), _ = (zt >>> 14 | b << 18) ^ (zt >>> 18 | b << 14) ^ (b >>> 9 | zt << 23), L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, A = b & It ^ ~b & Dt, _ = zt & Wt ^ ~zt & Ht, L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, A = Br[tt * 2], _ = Br[tt * 2 + 1], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, A = g[tt % 16], _ = S[tt % 16], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, H = C & 65535 | R << 16, J = L & 65535 | O << 16, A = H, _ = J, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = (ft >>> 28 | Bt << 4) ^ (Bt >>> 2 | ft << 30) ^ (Bt >>> 7 | ft << 25), _ = (Bt >>> 28 | ft << 4) ^ (ft >>> 2 | Bt << 30) ^ (ft >>> 7 | Bt << 25), L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, A = ft & mt ^ ft & vt ^ mt & vt, _ = Bt & Ot ^ Bt & kt ^ Ot & kt, L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, ut = C & 65535 | R << 16, st = L & 65535 | O << 16, A = rt, _ = dt, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = H, _ = J, L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, rt = C & 65535 | R << 16, dt = L & 65535 | O << 16, mt = B, vt = k, Et = $, b = rt, It = W, Dt = Lt, Ft = Z, ft = ut, Ot = ht, kt = bt, Qt = wt, zt = dt, Wt = gt, Ht = pt, Kt = X, Bt = st, tt % 16 === 15)
            for (q = 0; q < 16; q++)
              A = g[q], _ = S[q], L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = g[(q + 9) % 16], _ = S[(q + 9) % 16], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, H = g[(q + 1) % 16], J = S[(q + 1) % 16], A = (H >>> 1 | J << 31) ^ (H >>> 8 | J << 24) ^ H >>> 7, _ = (J >>> 1 | H << 31) ^ (J >>> 8 | H << 24) ^ (J >>> 7 | H << 25), L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, H = g[(q + 14) % 16], J = S[(q + 14) % 16], A = (H >>> 19 | J << 13) ^ (J >>> 29 | H << 3) ^ H >>> 6, _ = (J >>> 19 | H << 13) ^ (H >>> 29 | J << 3) ^ (J >>> 6 | H << 26), L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, g[q] = C & 65535 | R << 16, S[q] = L & 65535 | O << 16;
        A = ft, _ = Bt, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = f[0], _ = d[0], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, f[0] = ft = C & 65535 | R << 16, d[0] = Bt = L & 65535 | O << 16, A = mt, _ = Ot, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = f[1], _ = d[1], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, f[1] = mt = C & 65535 | R << 16, d[1] = Ot = L & 65535 | O << 16, A = vt, _ = kt, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = f[2], _ = d[2], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, f[2] = vt = C & 65535 | R << 16, d[2] = kt = L & 65535 | O << 16, A = Et, _ = Qt, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = f[3], _ = d[3], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, f[3] = Et = C & 65535 | R << 16, d[3] = Qt = L & 65535 | O << 16, A = b, _ = zt, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = f[4], _ = d[4], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, f[4] = b = C & 65535 | R << 16, d[4] = zt = L & 65535 | O << 16, A = It, _ = Wt, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = f[5], _ = d[5], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, f[5] = It = C & 65535 | R << 16, d[5] = Wt = L & 65535 | O << 16, A = Dt, _ = Ht, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = f[6], _ = d[6], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, f[6] = Dt = C & 65535 | R << 16, d[6] = Ht = L & 65535 | O << 16, A = Ft, _ = Kt, L = _ & 65535, O = _ >>> 16, C = A & 65535, R = A >>> 16, A = f[7], _ = d[7], L += _ & 65535, O += _ >>> 16, C += A & 65535, R += A >>> 16, O += L >>> 16, C += O >>> 16, R += C >>> 16, f[7] = Ft = C & 65535 | R << 16, d[7] = Kt = L & 65535 | O << 16, se += 128, i -= 128;
      }
      return i;
    }
    function Ge(f, d, l) {
      var i = new Int32Array(8), g = new Int32Array(8), S = new Uint8Array(256), B, k = l;
      for (i[0] = 1779033703, i[1] = 3144134277, i[2] = 1013904242, i[3] = 2773480762, i[4] = 1359893119, i[5] = 2600822924, i[6] = 528734635, i[7] = 1541459225, g[0] = 4089235720, g[1] = 2227873595, g[2] = 4271175723, g[3] = 1595750129, g[4] = 2917565137, g[5] = 725511199, g[6] = 4215389547, g[7] = 327033209, ln(i, g, d, l), l %= 128, B = 0; B < l; B++) S[B] = d[k - l + B];
      for (S[l] = 128, l = 256 - 128 * (l < 112 ? 1 : 0), S[l - 9] = 0, F(S, l - 8, k / 536870912 | 0, k << 3), ln(i, g, S, l), B = 0; B < 8; B++) F(f, 8 * B, i[B], g[B]);
      return 0;
    }
    function lr(f, d) {
      var l = r(), i = r(), g = r(), S = r(), B = r(), k = r(), $ = r(), rt = r(), W = r();
      qt(l, f[1], f[0]), qt(W, d[1], d[0]), ct(l, l, W), Yt(i, f[0], f[1]), Yt(W, d[0], d[1]), ct(i, i, W), ct(g, f[3], d[3]), ct(g, g, T), ct(S, f[2], d[2]), Yt(S, S, S), qt(B, i, l), qt(k, S, g), Yt($, S, g), Yt(rt, i, l), ct(f[0], B, k), ct(f[1], rt, $), ct(f[2], $, k), ct(f[3], B, rt);
    }
    function hr(f, d, l) {
      var i;
      for (i = 0; i < 4; i++)
        Ut(f[i], d[i], l);
    }
    function Ee(f, d) {
      var l = r(), i = r(), g = r();
      ye(g, d[2]), ct(l, d[0], g), ct(i, d[1], g), _t(f, i), f[31] ^= Tt(l) << 7;
    }
    function dr(f, d, l) {
      var i, g;
      for (Y(f[0], p), Y(f[1], c), Y(f[2], c), Y(f[3], p), g = 255; g >= 0; --g)
        i = l[g / 8 | 0] >> (g & 7) & 1, hr(f, d, i), lr(d, f), lr(f, f), hr(f, d, i);
    }
    function Ir(f, d) {
      var l = [r(), r(), r(), r()];
      Y(l[0], v), Y(l[1], V), Y(l[2], c), ct(l[3], v, V), dr(f, l, d);
    }
    function Ue(f, d, l) {
      var i = new Uint8Array(64), g = [r(), r(), r(), r()], S;
      for (l || n(d, 32), Ge(i, d, 32), i[0] &= 248, i[31] &= 127, i[31] |= 64, Ir(g, i), Ee(f, g), S = 0; S < 32; S++) d[S + 32] = f[S];
      return 0;
    }
    var Ar = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function h(f, d) {
      var l, i, g, S;
      for (i = 63; i >= 32; --i) {
        for (l = 0, g = i - 32, S = i - 12; g < S; ++g)
          d[g] += l - 16 * d[i] * Ar[g - (i - 32)], l = Math.floor((d[g] + 128) / 256), d[g] -= l * 256;
        d[g] += l, d[i] = 0;
      }
      for (l = 0, g = 0; g < 32; g++)
        d[g] += l - (d[31] >> 4) * Ar[g], l = d[g] >> 8, d[g] &= 255;
      for (g = 0; g < 32; g++) d[g] -= l * Ar[g];
      for (i = 0; i < 32; i++)
        d[i + 1] += d[i] >> 8, f[i] = d[i] & 255;
    }
    function s(f) {
      var d = new Float64Array(64), l;
      for (l = 0; l < 64; l++) d[l] = f[l];
      for (l = 0; l < 64; l++) f[l] = 0;
      h(f, d);
    }
    function o(f, d, l, i) {
      var g = new Uint8Array(64), S = new Uint8Array(64), B = new Uint8Array(64), k, $, rt = new Float64Array(64), W = [r(), r(), r(), r()];
      Ge(g, i, 32), g[0] &= 248, g[31] &= 127, g[31] |= 64;
      var Lt = l + 64;
      for (k = 0; k < l; k++) f[64 + k] = d[k];
      for (k = 0; k < 32; k++) f[32 + k] = g[32 + k];
      for (Ge(B, f.subarray(32), l + 32), s(B), Ir(W, B), Ee(f, W), k = 32; k < 64; k++) f[k] = i[k];
      for (Ge(S, f, l + 64), s(S), k = 0; k < 64; k++) rt[k] = 0;
      for (k = 0; k < 32; k++) rt[k] = B[k];
      for (k = 0; k < 32; k++)
        for ($ = 0; $ < 32; $++)
          rt[k + $] += S[k] * g[$];
      return h(f.subarray(32), rt), Lt;
    }
    function x(f, d) {
      var l = r(), i = r(), g = r(), S = r(), B = r(), k = r(), $ = r();
      return Y(f[2], c), Ct(f[1], d), Xt(g, f[1]), ct(S, g, m), qt(g, g, f[2]), Yt(S, f[2], S), Xt(B, S), Xt(k, B), ct($, k, B), ct(l, $, g), ct(l, l, S), Be(l, l), ct(l, l, g), ct(l, l, S), ct(l, l, S), ct(f[0], l, S), Xt(i, f[0]), ct(i, i, S), Gt(i, g) && ct(f[0], f[0], M), Xt(i, f[0]), ct(i, i, S), Gt(i, g) ? -1 : (Tt(f[0]) === d[31] >> 7 && qt(f[0], p, f[0]), ct(f[3], f[0], f[1]), 0);
    }
    function E(f, d, l, i) {
      var g, S = new Uint8Array(32), B = new Uint8Array(64), k = [r(), r(), r(), r()], $ = [r(), r(), r(), r()];
      if (l < 64 || x($, i)) return -1;
      for (g = 0; g < l; g++) f[g] = d[g];
      for (g = 0; g < 32; g++) f[g + 32] = i[g];
      if (Ge(B, f, l), s(B), dr(k, $, B), Ir($, d.subarray(32)), lr(k, $), Ee(S, k), l -= 64, P(d, 0, S, 0)) {
        for (g = 0; g < l; g++) f[g] = 0;
        return -1;
      }
      for (g = 0; g < l; g++) f[g] = d[g + 64];
      return l;
    }
    var I = 32, U = 24, xt = 32, Vt = 16, $t = 32, jt = 32, Mt = 32, qr = 32, zn = 32, Fi = U, No = xt, Uo = Vt, Ye = 64, pr = 32, _r = 64, jn = 32, qn = 64;
    t.lowlevel = {
      crypto_core_hsalsa20: nt,
      crypto_stream_xor: Pt,
      crypto_stream: ce,
      crypto_stream_salsa20_xor: it,
      crypto_stream_salsa20: lt,
      crypto_onetimeauth: ie,
      crypto_onetimeauth_verify: ae,
      crypto_verify_16: D,
      crypto_verify_32: P,
      crypto_secretbox: pe,
      crypto_secretbox_open: z,
      crypto_scalarmult: ue,
      crypto_scalarmult_base: we,
      crypto_box_beforenm: be,
      crypto_box_afternm: Jt,
      crypto_box: Sr,
      crypto_box_open: vr,
      crypto_box_keypair: ur,
      crypto_hash: Ge,
      crypto_sign: o,
      crypto_sign_keypair: Ue,
      crypto_sign_open: E,
      crypto_secretbox_KEYBYTES: I,
      crypto_secretbox_NONCEBYTES: U,
      crypto_secretbox_ZEROBYTES: xt,
      crypto_secretbox_BOXZEROBYTES: Vt,
      crypto_scalarmult_BYTES: $t,
      crypto_scalarmult_SCALARBYTES: jt,
      crypto_box_PUBLICKEYBYTES: Mt,
      crypto_box_SECRETKEYBYTES: qr,
      crypto_box_BEFORENMBYTES: zn,
      crypto_box_NONCEBYTES: Fi,
      crypto_box_ZEROBYTES: No,
      crypto_box_BOXZEROBYTES: Uo,
      crypto_sign_BYTES: Ye,
      crypto_sign_PUBLICKEYBYTES: pr,
      crypto_sign_SECRETKEYBYTES: _r,
      crypto_sign_SEEDBYTES: jn,
      crypto_hash_BYTES: qn,
      gf: r,
      D: m,
      L: Ar,
      pack25519: _t,
      unpack25519: Ct,
      M: ct,
      A: Yt,
      S: Xt,
      Z: qt,
      pow2523: Be,
      add: lr,
      set25519: Y,
      modL: h,
      scalarmult: dr,
      scalarbase: Ir
    };
    function Ri(f, d) {
      if (f.length !== I) throw new Error("bad key size");
      if (d.length !== U) throw new Error("bad nonce size");
    }
    function Oo(f, d) {
      if (f.length !== Mt) throw new Error("bad public key size");
      if (d.length !== qr) throw new Error("bad secret key size");
    }
    function Ie() {
      for (var f = 0; f < arguments.length; f++)
        if (!(arguments[f] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function Pi(f) {
      for (var d = 0; d < f.length; d++) f[d] = 0;
    }
    t.randomBytes = function(f) {
      var d = new Uint8Array(f);
      return n(d, f), d;
    }, t.secretbox = function(f, d, l) {
      Ie(f, d, l), Ri(l, d);
      for (var i = new Uint8Array(xt + f.length), g = new Uint8Array(i.length), S = 0; S < f.length; S++) i[S + xt] = f[S];
      return pe(g, i, i.length, d, l), g.subarray(Vt);
    }, t.secretbox.open = function(f, d, l) {
      Ie(f, d, l), Ri(l, d);
      for (var i = new Uint8Array(Vt + f.length), g = new Uint8Array(i.length), S = 0; S < f.length; S++) i[S + Vt] = f[S];
      return i.length < 32 || z(g, i, i.length, d, l) !== 0 ? null : g.subarray(xt);
    }, t.secretbox.keyLength = I, t.secretbox.nonceLength = U, t.secretbox.overheadLength = Vt, t.scalarMult = function(f, d) {
      if (Ie(f, d), f.length !== jt) throw new Error("bad n size");
      if (d.length !== $t) throw new Error("bad p size");
      var l = new Uint8Array($t);
      return ue(l, f, d), l;
    }, t.scalarMult.base = function(f) {
      if (Ie(f), f.length !== jt) throw new Error("bad n size");
      var d = new Uint8Array($t);
      return we(d, f), d;
    }, t.scalarMult.scalarLength = jt, t.scalarMult.groupElementLength = $t, t.box = function(f, d, l, i) {
      var g = t.box.before(l, i);
      return t.secretbox(f, d, g);
    }, t.box.before = function(f, d) {
      Ie(f, d), Oo(f, d);
      var l = new Uint8Array(zn);
      return be(l, f, d), l;
    }, t.box.after = t.secretbox, t.box.open = function(f, d, l, i) {
      var g = t.box.before(l, i);
      return t.secretbox.open(f, d, g);
    }, t.box.open.after = t.secretbox.open, t.box.keyPair = function() {
      var f = new Uint8Array(Mt), d = new Uint8Array(qr);
      return ur(f, d), { publicKey: f, secretKey: d };
    }, t.box.keyPair.fromSecretKey = function(f) {
      if (Ie(f), f.length !== qr)
        throw new Error("bad secret key size");
      var d = new Uint8Array(Mt);
      return we(d, f), { publicKey: d, secretKey: new Uint8Array(f) };
    }, t.box.publicKeyLength = Mt, t.box.secretKeyLength = qr, t.box.sharedKeyLength = zn, t.box.nonceLength = Fi, t.box.overheadLength = t.secretbox.overheadLength, t.sign = function(f, d) {
      if (Ie(f, d), d.length !== _r)
        throw new Error("bad secret key size");
      var l = new Uint8Array(Ye + f.length);
      return o(l, f, f.length, d), l;
    }, t.sign.open = function(f, d) {
      if (Ie(f, d), d.length !== pr)
        throw new Error("bad public key size");
      var l = new Uint8Array(f.length), i = E(l, f, f.length, d);
      if (i < 0) return null;
      for (var g = new Uint8Array(i), S = 0; S < g.length; S++) g[S] = l[S];
      return g;
    }, t.sign.detached = function(f, d) {
      for (var l = t.sign(f, d), i = new Uint8Array(Ye), g = 0; g < i.length; g++) i[g] = l[g];
      return i;
    }, t.sign.detached.verify = function(f, d, l) {
      if (Ie(f, d, l), d.length !== Ye)
        throw new Error("bad signature size");
      if (l.length !== pr)
        throw new Error("bad public key size");
      var i = new Uint8Array(Ye + f.length), g = new Uint8Array(Ye + f.length), S;
      for (S = 0; S < Ye; S++) i[S] = d[S];
      for (S = 0; S < f.length; S++) i[S + Ye] = f[S];
      return E(g, i, i.length, l) >= 0;
    }, t.sign.keyPair = function() {
      var f = new Uint8Array(pr), d = new Uint8Array(_r);
      return Ue(f, d), { publicKey: f, secretKey: d };
    }, t.sign.keyPair.fromSecretKey = function(f) {
      if (Ie(f), f.length !== _r)
        throw new Error("bad secret key size");
      for (var d = new Uint8Array(pr), l = 0; l < d.length; l++) d[l] = f[32 + l];
      return { publicKey: d, secretKey: new Uint8Array(f) };
    }, t.sign.keyPair.fromSeed = function(f) {
      if (Ie(f), f.length !== jn)
        throw new Error("bad seed size");
      for (var d = new Uint8Array(pr), l = new Uint8Array(_r), i = 0; i < 32; i++) l[i] = f[i];
      return Ue(d, l, !0), { publicKey: d, secretKey: l };
    }, t.sign.publicKeyLength = pr, t.sign.secretKeyLength = _r, t.sign.seedLength = jn, t.sign.signatureLength = Ye, t.hash = function(f) {
      Ie(f);
      var d = new Uint8Array(qn);
      return Ge(d, f, f.length), d;
    }, t.hash.hashLength = qn, t.verify = function(f, d) {
      return Ie(f, d), f.length === 0 || d.length === 0 || f.length !== d.length ? !1 : N(f, 0, d, 0, f.length) === 0;
    }, t.setPRNG = function(f) {
      n = f;
    }, function() {
      var f = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (f && f.getRandomValues) {
        var d = 65536;
        t.setPRNG(function(l, i) {
          var g, S = new Uint8Array(i);
          for (g = 0; g < i; g += d)
            f.getRandomValues(S.subarray(g, g + Math.min(i - g, d)));
          for (g = 0; g < i; g++) l[g] = S[g];
          Pi(S);
        });
      } else typeof Ac < "u" && (f = Nc, f && f.randomBytes && t.setPRNG(function(l, i) {
        var g, S = f.randomBytes(i);
        for (g = 0; g < i; g++) l[g] = S[g];
        Pi(S);
      }));
    }();
  })(e.exports ? e.exports : self.nacl = self.nacl || {});
})(lo);
var Uc = lo.exports;
const Oc = /* @__PURE__ */ ds(Uc), hi = 32;
class ho extends fn {
  /**
   * Create a new Ed25519PublicKey object
   * @param value ed25519 public key as buffer or base-64 encoded string
   */
  constructor(t) {
    if (super(), typeof t == "string" ? this.data = Ne(t) : t instanceof Uint8Array ? this.data = t : this.data = Uint8Array.from(t), this.data.length !== hi)
      throw new Error(
        `Invalid public key input. Expected ${hi} bytes, got ${this.data.length}`
      );
  }
  /**
   * Checks if two Ed25519 public keys are equal
   */
  equals(t) {
    return super.equals(t);
  }
  /**
   * Return the byte array representation of the Ed25519 public key
   */
  toRawBytes() {
    return this.data;
  }
  /**
   * Return the Sui address associated with this Ed25519 public key
   */
  flag() {
    return Qe.ED25519;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(t, r) {
    let n;
    if (typeof r == "string") {
      const a = $r(r);
      if (a.signatureScheme !== "ED25519")
        throw new Error("Invalid signature scheme");
      if (!Pr(this.toRawBytes(), a.publicKey))
        throw new Error("Signature does not match public key");
      n = a.signature;
    } else
      n = r;
    return Oc.sign.detached.verify(t, n, this.toRawBytes());
  }
}
ho.SIZE = hi;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const po = BigInt(0), $n = BigInt(1), kc = BigInt(2);
function Er(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function cn(e) {
  if (!Er(e))
    throw new Error("Uint8Array expected");
}
const Cc = /* @__PURE__ */ Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Vr(e) {
  cn(e);
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += Cc[e[r]];
  return t;
}
function go(e) {
  const t = e.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function ki(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
const He = { _0: 48, _9: 57, _A: 65, _F: 70, _a: 97, _f: 102 };
function Zi(e) {
  if (e >= He._0 && e <= He._9)
    return e - He._0;
  if (e >= He._A && e <= He._F)
    return e - (He._A - 10);
  if (e >= He._a && e <= He._f)
    return e - (He._a - 10);
}
function zr(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  const t = e.length, r = t / 2;
  if (t % 2)
    throw new Error("padded hex string expected, got unpadded hex of length " + t);
  const n = new Uint8Array(r);
  for (let a = 0, u = 0; a < r; a++, u += 2) {
    const p = Zi(e.charCodeAt(u)), c = Zi(e.charCodeAt(u + 1));
    if (p === void 0 || c === void 0) {
      const y = e[u] + e[u + 1];
      throw new Error('hex string expected, got non-hex character "' + y + '" at index ' + u);
    }
    n[a] = p * 16 + c;
  }
  return n;
}
function mr(e) {
  return ki(Vr(e));
}
function Ci(e) {
  return cn(e), ki(Vr(Uint8Array.from(e).reverse()));
}
function jr(e, t) {
  return zr(e.toString(16).padStart(t * 2, "0"));
}
function Mi(e, t) {
  return jr(e, t).reverse();
}
function Mc(e) {
  return zr(go(e));
}
function Fe(e, t, r) {
  let n;
  if (typeof t == "string")
    try {
      n = zr(t);
    } catch (u) {
      throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${u}`);
    }
  else if (Er(t))
    n = Uint8Array.from(t);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const a = n.length;
  if (typeof r == "number" && a !== r)
    throw new Error(`${e} expected ${r} bytes, got ${a}`);
  return n;
}
function on(...e) {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    cn(a), t += a.length;
  }
  const r = new Uint8Array(t);
  for (let n = 0, a = 0; n < e.length; n++) {
    const u = e[n];
    r.set(u, a), a += u.length;
  }
  return r;
}
function Lc(e, t) {
  if (e.length !== t.length)
    return !1;
  let r = 0;
  for (let n = 0; n < e.length; n++)
    r |= e[n] ^ t[n];
  return r === 0;
}
function Dc(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function Fc(e) {
  let t;
  for (t = 0; e > po; e >>= $n, t += 1)
    ;
  return t;
}
function Rc(e, t) {
  return e >> BigInt(t) & $n;
}
function Pc(e, t, r) {
  return e | (r ? $n : po) << BigInt(t);
}
const Li = (e) => (kc << BigInt(e - 1)) - $n, ri = (e) => new Uint8Array(e), Xi = (e) => Uint8Array.from(e);
function xo(e, t, r) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let n = ri(e), a = ri(e), u = 0;
  const p = () => {
    n.fill(1), a.fill(0), u = 0;
  }, c = (...v) => r(a, n, ...v), y = (v = ri()) => {
    a = c(Xi([0]), v), n = c(), v.length !== 0 && (a = c(Xi([1]), v), n = c());
  }, m = () => {
    if (u++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let v = 0;
    const V = [];
    for (; v < t; ) {
      n = c();
      const M = n.slice();
      V.push(M), v += n.length;
    }
    return on(...V);
  };
  return (v, V) => {
    p(), y(v);
    let M;
    for (; !(M = V(m())); )
      y();
    return p(), M;
  };
}
const $c = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  stringOrUint8Array: (e) => typeof e == "string" || Er(e),
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function un(e, t, r = {}) {
  const n = (a, u, p) => {
    const c = $c[u];
    if (typeof c != "function")
      throw new Error(`Invalid validator "${u}", expected function`);
    const y = e[a];
    if (!(p && y === void 0) && !c(y, e))
      throw new Error(`Invalid param ${String(a)}=${y} (${typeof y}), expected ${u}`);
  };
  for (const [a, u] of Object.entries(t))
    n(a, u, !1);
  for (const [a, u] of Object.entries(r))
    n(a, u, !0);
  return e;
}
const Vc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abytes: cn,
  bitGet: Rc,
  bitLen: Fc,
  bitMask: Li,
  bitSet: Pc,
  bytesToHex: Vr,
  bytesToNumberBE: mr,
  bytesToNumberLE: Ci,
  concatBytes: on,
  createHmacDrbg: xo,
  ensureBytes: Fe,
  equalBytes: Lc,
  hexToBytes: zr,
  hexToNumber: ki,
  isBytes: Er,
  numberToBytesBE: jr,
  numberToBytesLE: Mi,
  numberToHexUnpadded: go,
  numberToVarBytesBE: Mc,
  utf8ToBytes: Dc,
  validateObject: un
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const fe = BigInt(0), te = BigInt(1), yr = BigInt(2), zc = BigInt(3), di = BigInt(4), Ji = BigInt(5), Qi = BigInt(8);
BigInt(9);
BigInt(16);
function ve(e, t) {
  const r = e % t;
  return r >= fe ? r : t + r;
}
function jc(e, t, r) {
  if (r <= fe || t < fe)
    throw new Error("Expected power/modulo > 0");
  if (r === te)
    return fe;
  let n = te;
  for (; t > fe; )
    t & te && (n = n * e % r), e = e * e % r, t >>= te;
  return n;
}
function Oe(e, t, r) {
  let n = e;
  for (; t-- > fe; )
    n *= n, n %= r;
  return n;
}
function pi(e, t) {
  if (e === fe || t <= fe)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let r = ve(e, t), n = t, a = fe, u = te;
  for (; r !== fe; ) {
    const c = n / r, y = n % r, m = a - u * c;
    n = r, r = y, a = u, u = m;
  }
  if (n !== te)
    throw new Error("invert: does not exist");
  return ve(a, t);
}
function qc(e) {
  const t = (e - te) / yr;
  let r, n, a;
  for (r = e - te, n = 0; r % yr === fe; r /= yr, n++)
    ;
  for (a = yr; a < e && jc(a, t, e) !== e - te; a++)
    ;
  if (n === 1) {
    const p = (e + te) / di;
    return function(y, m) {
      const T = y.pow(m, p);
      if (!y.eql(y.sqr(T), m))
        throw new Error("Cannot find square root");
      return T;
    };
  }
  const u = (r + te) / yr;
  return function(c, y) {
    if (c.pow(y, t) === c.neg(c.ONE))
      throw new Error("Cannot find square root");
    let m = n, T = c.pow(c.mul(c.ONE, a), r), v = c.pow(y, u), V = c.pow(y, r);
    for (; !c.eql(V, c.ONE); ) {
      if (c.eql(V, c.ZERO))
        return c.ZERO;
      let M = 1;
      for (let N = c.sqr(V); M < m && !c.eql(N, c.ONE); M++)
        N = c.sqr(N);
      const F = c.pow(T, te << BigInt(m - M - 1));
      T = c.sqr(F), v = c.mul(v, F), V = c.mul(V, T), m = M;
    }
    return v;
  };
}
function Gc(e) {
  if (e % di === zc) {
    const t = (e + te) / di;
    return function(n, a) {
      const u = n.pow(a, t);
      if (!n.eql(n.sqr(u), a))
        throw new Error("Cannot find square root");
      return u;
    };
  }
  if (e % Qi === Ji) {
    const t = (e - Ji) / Qi;
    return function(n, a) {
      const u = n.mul(a, yr), p = n.pow(u, t), c = n.mul(a, p), y = n.mul(n.mul(c, yr), p), m = n.mul(c, n.sub(y, n.ONE));
      if (!n.eql(n.sqr(m), a))
        throw new Error("Cannot find square root");
      return m;
    };
  }
  return qc(e);
}
const Yc = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function Wc(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = Yc.reduce((n, a) => (n[a] = "function", n), t);
  return un(e, r);
}
function Hc(e, t, r) {
  if (r < fe)
    throw new Error("Expected power > 0");
  if (r === fe)
    return e.ONE;
  if (r === te)
    return t;
  let n = e.ONE, a = t;
  for (; r > fe; )
    r & te && (n = e.mul(n, a)), a = e.sqr(a), r >>= te;
  return n;
}
function Kc(e, t) {
  const r = new Array(t.length), n = t.reduce((u, p, c) => e.is0(p) ? u : (r[c] = u, e.mul(u, p)), e.ONE), a = e.inv(n);
  return t.reduceRight((u, p, c) => e.is0(p) ? u : (r[c] = e.mul(u, r[c]), e.mul(u, p)), a), r;
}
function yo(e, t) {
  const r = t !== void 0 ? t : e.toString(2).length, n = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: n };
}
function wo(e, t, r = !1, n = {}) {
  if (e <= fe)
    throw new Error(`Expected Field ORDER > 0, got ${e}`);
  const { nBitLength: a, nByteLength: u } = yo(e, t);
  if (u > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const p = Gc(e), c = Object.freeze({
    ORDER: e,
    BITS: a,
    BYTES: u,
    MASK: Li(a),
    ZERO: fe,
    ONE: te,
    create: (y) => ve(y, e),
    isValid: (y) => {
      if (typeof y != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof y}`);
      return fe <= y && y < e;
    },
    is0: (y) => y === fe,
    isOdd: (y) => (y & te) === te,
    neg: (y) => ve(-y, e),
    eql: (y, m) => y === m,
    sqr: (y) => ve(y * y, e),
    add: (y, m) => ve(y + m, e),
    sub: (y, m) => ve(y - m, e),
    mul: (y, m) => ve(y * m, e),
    pow: (y, m) => Hc(c, y, m),
    div: (y, m) => ve(y * pi(m, e), e),
    // Same as above, but doesn't normalize
    sqrN: (y) => y * y,
    addN: (y, m) => y + m,
    subN: (y, m) => y - m,
    mulN: (y, m) => y * m,
    inv: (y) => pi(y, e),
    sqrt: n.sqrt || ((y) => p(c, y)),
    invertBatch: (y) => Kc(c, y),
    // TODO: do we really need constant cmov?
    // We don't have const-time bigints anyway, so probably will be not very useful
    cmov: (y, m, T) => T ? m : y,
    toBytes: (y) => r ? Mi(y, u) : jr(y, u),
    fromBytes: (y) => {
      if (y.length !== u)
        throw new Error(`Fp.fromBytes: expected ${u}, got ${y.length}`);
      return r ? Ci(y) : mr(y);
    }
  });
  return Object.freeze(c);
}
function bo(e) {
  if (typeof e != "bigint")
    throw new Error("field order must be bigint");
  const t = e.toString(2).length;
  return Math.ceil(t / 8);
}
function mo(e) {
  const t = bo(e);
  return t + Math.ceil(t / 2);
}
function Zc(e, t, r = !1) {
  const n = e.length, a = bo(t), u = mo(t);
  if (n < 16 || n < u || n > 1024)
    throw new Error(`expected ${u}-1024 bytes of input, got ${n}`);
  const p = r ? mr(e) : Ci(e), c = ve(p, t - te) + te;
  return r ? Mi(c, a) : jr(c, a);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Xc = BigInt(0), ni = BigInt(1);
function Jc(e, t) {
  const r = (a, u) => {
    const p = u.negate();
    return a ? p : u;
  }, n = (a) => {
    const u = Math.ceil(t / a) + 1, p = 2 ** (a - 1);
    return { windows: u, windowSize: p };
  };
  return {
    constTimeNegate: r,
    // non-const time multiplication ladder
    unsafeLadder(a, u) {
      let p = e.ZERO, c = a;
      for (; u > Xc; )
        u & ni && (p = p.add(c)), c = c.double(), u >>= ni;
      return p;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(a, u) {
      const { windows: p, windowSize: c } = n(u), y = [];
      let m = a, T = m;
      for (let v = 0; v < p; v++) {
        T = m, y.push(T);
        for (let V = 1; V < c; V++)
          T = T.add(m), y.push(T);
        m = T.double();
      }
      return y;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(a, u, p) {
      const { windows: c, windowSize: y } = n(a);
      let m = e.ZERO, T = e.BASE;
      const v = BigInt(2 ** a - 1), V = 2 ** a, M = BigInt(a);
      for (let F = 0; F < c; F++) {
        const N = F * y;
        let D = Number(p & v);
        p >>= M, D > y && (D -= V, p += ni);
        const P = N, et = N + Math.abs(D) - 1, K = F % 2 !== 0, ot = D < 0;
        D === 0 ? T = T.add(r(K, u[P])) : m = m.add(r(ot, u[et]));
      }
      return { p: m, f: T };
    },
    wNAFCached(a, u, p, c) {
      const y = a._WINDOW_SIZE || 1;
      let m = u.get(a);
      return m || (m = this.precomputeWindow(a, y), y !== 1 && u.set(a, c(m))), this.wNAF(y, m, p);
    }
  };
}
function Eo(e) {
  return Wc(e.Fp), un(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...yo(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Qc(e) {
  const t = Eo(e);
  un(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: r, Fp: n, a } = t;
  if (r) {
    if (!n.eql(a, n.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof r != "object" || typeof r.beta != "bigint" || typeof r.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: tu, hexToBytes: eu } = Vc, br = {
  // asn.1 DER encoding utils
  Err: class extends Error {
    constructor(t = "") {
      super(t);
    }
  },
  _parseInt(e) {
    const { Err: t } = br;
    if (e.length < 2 || e[0] !== 2)
      throw new t("Invalid signature integer tag");
    const r = e[1], n = e.subarray(2, r + 2);
    if (!r || n.length !== r)
      throw new t("Invalid signature integer: wrong length");
    if (n[0] & 128)
      throw new t("Invalid signature integer: negative");
    if (n[0] === 0 && !(n[1] & 128))
      throw new t("Invalid signature integer: unnecessary leading zero");
    return { d: tu(n), l: e.subarray(r + 2) };
  },
  toSig(e) {
    const { Err: t } = br, r = typeof e == "string" ? eu(e) : e;
    cn(r);
    let n = r.length;
    if (n < 2 || r[0] != 48)
      throw new t("Invalid signature tag");
    if (r[1] !== n - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: a, l: u } = br._parseInt(r.subarray(2)), { d: p, l: c } = br._parseInt(u);
    if (c.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: a, s: p };
  },
  hexFromSig(e) {
    const t = (m) => Number.parseInt(m[0], 16) & 8 ? "00" + m : m, r = (m) => {
      const T = m.toString(16);
      return T.length & 1 ? `0${T}` : T;
    }, n = t(r(e.s)), a = t(r(e.r)), u = n.length / 2, p = a.length / 2, c = r(u), y = r(p);
    return `30${r(p + u + 4)}02${y}${a}02${c}${n}`;
  }
}, Je = BigInt(0), Me = BigInt(1);
BigInt(2);
const ts = BigInt(3);
BigInt(4);
function ru(e) {
  const t = Qc(e), { Fp: r } = t, n = t.toBytes || ((F, N, D) => {
    const P = N.toAffine();
    return on(Uint8Array.from([4]), r.toBytes(P.x), r.toBytes(P.y));
  }), a = t.fromBytes || ((F) => {
    const N = F.subarray(1), D = r.fromBytes(N.subarray(0, r.BYTES)), P = r.fromBytes(N.subarray(r.BYTES, 2 * r.BYTES));
    return { x: D, y: P };
  });
  function u(F) {
    const { a: N, b: D } = t, P = r.sqr(F), et = r.mul(P, F);
    return r.add(r.add(et, r.mul(F, N)), D);
  }
  if (!r.eql(r.sqr(t.Gy), u(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function p(F) {
    return typeof F == "bigint" && Je < F && F < t.n;
  }
  function c(F) {
    if (!p(F))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function y(F) {
    const { allowedPrivateKeyLengths: N, nByteLength: D, wrapPrivateKey: P, n: et } = t;
    if (N && typeof F != "bigint") {
      if (Er(F) && (F = Vr(F)), typeof F != "string" || !N.includes(F.length))
        throw new Error("Invalid key");
      F = F.padStart(D * 2, "0");
    }
    let K;
    try {
      K = typeof F == "bigint" ? F : mr(Fe("private key", F, D));
    } catch {
      throw new Error(`private key must be ${D} bytes, hex or bigint, not ${typeof F}`);
    }
    return P && (K = ve(K, et)), c(K), K;
  }
  const m = /* @__PURE__ */ new Map();
  function T(F) {
    if (!(F instanceof v))
      throw new Error("ProjectivePoint expected");
  }
  class v {
    constructor(N, D, P) {
      if (this.px = N, this.py = D, this.pz = P, N == null || !r.isValid(N))
        throw new Error("x required");
      if (D == null || !r.isValid(D))
        throw new Error("y required");
      if (P == null || !r.isValid(P))
        throw new Error("z required");
    }
    // Does not validate if the point is on-curve.
    // Use fromHex instead, or call assertValidity() later.
    static fromAffine(N) {
      const { x: D, y: P } = N || {};
      if (!N || !r.isValid(D) || !r.isValid(P))
        throw new Error("invalid affine point");
      if (N instanceof v)
        throw new Error("projective point not allowed");
      const et = (K) => r.eql(K, r.ZERO);
      return et(D) && et(P) ? v.ZERO : new v(D, P, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    /**
     * Takes a bunch of Projective Points but executes only one
     * inversion on all of them. Inversion is very slow operation,
     * so this improves performance massively.
     * Optimization: converts a list of projective points to a list of identical points with Z=1.
     */
    static normalizeZ(N) {
      const D = r.invertBatch(N.map((P) => P.pz));
      return N.map((P, et) => P.toAffine(D[et])).map(v.fromAffine);
    }
    /**
     * Converts hash string or Uint8Array to Point.
     * @param hex short/long ECDSA hex
     */
    static fromHex(N) {
      const D = v.fromAffine(a(Fe("pointHex", N)));
      return D.assertValidity(), D;
    }
    // Multiplies generator point by privateKey.
    static fromPrivateKey(N) {
      return v.BASE.multiply(y(N));
    }
    // "Private method", don't use it directly
    _setWindowSize(N) {
      this._WINDOW_SIZE = N, m.delete(this);
    }
    // A point on curve is valid if it conforms to equation.
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint && !r.is0(this.py))
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: N, y: D } = this.toAffine();
      if (!r.isValid(N) || !r.isValid(D))
        throw new Error("bad point: x or y not FE");
      const P = r.sqr(D), et = u(N);
      if (!r.eql(P, et))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: N } = this.toAffine();
      if (r.isOdd)
        return !r.isOdd(N);
      throw new Error("Field doesn't support isOdd");
    }
    /**
     * Compare one point to another.
     */
    equals(N) {
      T(N);
      const { px: D, py: P, pz: et } = this, { px: K, py: ot, pz: nt } = N, j = r.eql(r.mul(D, nt), r.mul(K, et)), it = r.eql(r.mul(P, nt), r.mul(ot, et));
      return j && it;
    }
    /**
     * Flips point to one corresponding to (x, -y) in Affine coordinates.
     */
    negate() {
      return new v(this.px, r.neg(this.py), this.pz);
    }
    // Renes-Costello-Batina exception-free doubling formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 3
    // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
    double() {
      const { a: N, b: D } = t, P = r.mul(D, ts), { px: et, py: K, pz: ot } = this;
      let nt = r.ZERO, j = r.ZERO, it = r.ZERO, lt = r.mul(et, et), ce = r.mul(K, K), Pt = r.mul(ot, ot), At = r.mul(et, K);
      return At = r.add(At, At), it = r.mul(et, ot), it = r.add(it, it), nt = r.mul(N, it), j = r.mul(P, Pt), j = r.add(nt, j), nt = r.sub(ce, j), j = r.add(ce, j), j = r.mul(nt, j), nt = r.mul(At, nt), it = r.mul(P, it), Pt = r.mul(N, Pt), At = r.sub(lt, Pt), At = r.mul(N, At), At = r.add(At, it), it = r.add(lt, lt), lt = r.add(it, lt), lt = r.add(lt, Pt), lt = r.mul(lt, At), j = r.add(j, lt), Pt = r.mul(K, ot), Pt = r.add(Pt, Pt), lt = r.mul(Pt, At), nt = r.sub(nt, lt), it = r.mul(Pt, ce), it = r.add(it, it), it = r.add(it, it), new v(nt, j, it);
    }
    // Renes-Costello-Batina exception-free addition formula.
    // There is 30% faster Jacobian formula, but it is not complete.
    // https://eprint.iacr.org/2015/1060, algorithm 1
    // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
    add(N) {
      T(N);
      const { px: D, py: P, pz: et } = this, { px: K, py: ot, pz: nt } = N;
      let j = r.ZERO, it = r.ZERO, lt = r.ZERO;
      const ce = t.a, Pt = r.mul(t.b, ts);
      let At = r.mul(D, K), ie = r.mul(P, ot), ae = r.mul(et, nt), pe = r.add(D, P), z = r.add(K, ot);
      pe = r.mul(pe, z), z = r.add(At, ie), pe = r.sub(pe, z), z = r.add(D, et);
      let Y = r.add(K, nt);
      return z = r.mul(z, Y), Y = r.add(At, ae), z = r.sub(z, Y), Y = r.add(P, et), j = r.add(ot, nt), Y = r.mul(Y, j), j = r.add(ie, ae), Y = r.sub(Y, j), lt = r.mul(ce, z), j = r.mul(Pt, ae), lt = r.add(j, lt), j = r.sub(ie, lt), lt = r.add(ie, lt), it = r.mul(j, lt), ie = r.add(At, At), ie = r.add(ie, At), ae = r.mul(ce, ae), z = r.mul(Pt, z), ie = r.add(ie, ae), ae = r.sub(At, ae), ae = r.mul(ce, ae), z = r.add(z, ae), At = r.mul(ie, z), it = r.add(it, At), At = r.mul(Y, z), j = r.mul(pe, j), j = r.sub(j, At), At = r.mul(pe, ie), lt = r.mul(Y, lt), lt = r.add(lt, At), new v(j, it, lt);
    }
    subtract(N) {
      return this.add(N.negate());
    }
    is0() {
      return this.equals(v.ZERO);
    }
    wNAF(N) {
      return M.wNAFCached(this, m, N, (D) => {
        const P = r.invertBatch(D.map((et) => et.pz));
        return D.map((et, K) => et.toAffine(P[K])).map(v.fromAffine);
      });
    }
    /**
     * Non-constant-time multiplication. Uses double-and-add algorithm.
     * It's faster, but should only be used when you don't care about
     * an exposed private key e.g. sig verification, which works over *public* keys.
     */
    multiplyUnsafe(N) {
      const D = v.ZERO;
      if (N === Je)
        return D;
      if (c(N), N === Me)
        return this;
      const { endo: P } = t;
      if (!P)
        return M.unsafeLadder(this, N);
      let { k1neg: et, k1: K, k2neg: ot, k2: nt } = P.splitScalar(N), j = D, it = D, lt = this;
      for (; K > Je || nt > Je; )
        K & Me && (j = j.add(lt)), nt & Me && (it = it.add(lt)), lt = lt.double(), K >>= Me, nt >>= Me;
      return et && (j = j.negate()), ot && (it = it.negate()), it = new v(r.mul(it.px, P.beta), it.py, it.pz), j.add(it);
    }
    /**
     * Constant time multiplication.
     * Uses wNAF method. Windowed method may be 10% faster,
     * but takes 2x longer to generate and consumes 2x memory.
     * Uses precomputes when available.
     * Uses endomorphism for Koblitz curves.
     * @param scalar by which the point would be multiplied
     * @returns New point
     */
    multiply(N) {
      c(N);
      let D = N, P, et;
      const { endo: K } = t;
      if (K) {
        const { k1neg: ot, k1: nt, k2neg: j, k2: it } = K.splitScalar(D);
        let { p: lt, f: ce } = this.wNAF(nt), { p: Pt, f: At } = this.wNAF(it);
        lt = M.constTimeNegate(ot, lt), Pt = M.constTimeNegate(j, Pt), Pt = new v(r.mul(Pt.px, K.beta), Pt.py, Pt.pz), P = lt.add(Pt), et = ce.add(At);
      } else {
        const { p: ot, f: nt } = this.wNAF(D);
        P = ot, et = nt;
      }
      return v.normalizeZ([P, et])[0];
    }
    /**
     * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
     * Not using Strauss-Shamir trick: precomputation tables are faster.
     * The trick could be useful if both P and Q are not G (not in our case).
     * @returns non-zero affine point
     */
    multiplyAndAddUnsafe(N, D, P) {
      const et = v.BASE, K = (nt, j) => j === Je || j === Me || !nt.equals(et) ? nt.multiplyUnsafe(j) : nt.multiply(j), ot = K(this, D).add(K(N, P));
      return ot.is0() ? void 0 : ot;
    }
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    toAffine(N) {
      const { px: D, py: P, pz: et } = this, K = this.is0();
      N == null && (N = K ? r.ONE : r.inv(et));
      const ot = r.mul(D, N), nt = r.mul(P, N), j = r.mul(et, N);
      if (K)
        return { x: r.ZERO, y: r.ZERO };
      if (!r.eql(j, r.ONE))
        throw new Error("invZ was invalid");
      return { x: ot, y: nt };
    }
    isTorsionFree() {
      const { h: N, isTorsionFree: D } = t;
      if (N === Me)
        return !0;
      if (D)
        return D(v, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: N, clearCofactor: D } = t;
      return N === Me ? this : D ? D(v, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(N = !0) {
      return this.assertValidity(), n(v, this, N);
    }
    toHex(N = !0) {
      return Vr(this.toRawBytes(N));
    }
  }
  v.BASE = new v(t.Gx, t.Gy, r.ONE), v.ZERO = new v(r.ZERO, r.ONE, r.ZERO);
  const V = t.nBitLength, M = Jc(v, t.endo ? Math.ceil(V / 2) : V);
  return {
    CURVE: t,
    ProjectivePoint: v,
    normPrivateKeyToScalar: y,
    weierstrassEquation: u,
    isWithinCurveOrder: p
  };
}
function nu(e) {
  const t = Eo(e);
  return un(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function iu(e) {
  const t = nu(e), { Fp: r, n } = t, a = r.BYTES + 1, u = 2 * r.BYTES + 1;
  function p(z) {
    return Je < z && z < r.ORDER;
  }
  function c(z) {
    return ve(z, n);
  }
  function y(z) {
    return pi(z, n);
  }
  const { ProjectivePoint: m, normPrivateKeyToScalar: T, weierstrassEquation: v, isWithinCurveOrder: V } = ru({
    ...t,
    toBytes(z, Y, yt) {
      const Ut = Y.toAffine(), _t = r.toBytes(Ut.x), Gt = on;
      return yt ? Gt(Uint8Array.from([Y.hasEvenY() ? 2 : 3]), _t) : Gt(Uint8Array.from([4]), _t, r.toBytes(Ut.y));
    },
    fromBytes(z) {
      const Y = z.length, yt = z[0], Ut = z.subarray(1);
      if (Y === a && (yt === 2 || yt === 3)) {
        const _t = mr(Ut);
        if (!p(_t))
          throw new Error("Point is not on curve");
        const Gt = v(_t);
        let Tt;
        try {
          Tt = r.sqrt(Gt);
        } catch (qt) {
          const ct = qt instanceof Error ? ": " + qt.message : "";
          throw new Error("Point is not on curve" + ct);
        }
        const Ct = (Tt & Me) === Me;
        return (yt & 1) === 1 !== Ct && (Tt = r.neg(Tt)), { x: _t, y: Tt };
      } else if (Y === u && yt === 4) {
        const _t = r.fromBytes(Ut.subarray(0, r.BYTES)), Gt = r.fromBytes(Ut.subarray(r.BYTES, 2 * r.BYTES));
        return { x: _t, y: Gt };
      } else
        throw new Error(`Point of length ${Y} was invalid. Expected ${a} compressed bytes or ${u} uncompressed bytes`);
    }
  }), M = (z) => Vr(jr(z, t.nByteLength));
  function F(z) {
    const Y = n >> Me;
    return z > Y;
  }
  function N(z) {
    return F(z) ? c(-z) : z;
  }
  const D = (z, Y, yt) => mr(z.slice(Y, yt));
  class P {
    constructor(Y, yt, Ut) {
      this.r = Y, this.s = yt, this.recovery = Ut, this.assertValidity();
    }
    // pair (bytes of r, bytes of s)
    static fromCompact(Y) {
      const yt = t.nByteLength;
      return Y = Fe("compactSignature", Y, yt * 2), new P(D(Y, 0, yt), D(Y, yt, 2 * yt));
    }
    // DER encoded ECDSA signature
    // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
    static fromDER(Y) {
      const { r: yt, s: Ut } = br.toSig(Fe("DER", Y));
      return new P(yt, Ut);
    }
    assertValidity() {
      if (!V(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!V(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(Y) {
      return new P(this.r, this.s, Y);
    }
    recoverPublicKey(Y) {
      const { r: yt, s: Ut, recovery: _t } = this, Gt = it(Fe("msgHash", Y));
      if (_t == null || ![0, 1, 2, 3].includes(_t))
        throw new Error("recovery id invalid");
      const Tt = _t === 2 || _t === 3 ? yt + t.n : yt;
      if (Tt >= r.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Ct = _t & 1 ? "03" : "02", Yt = m.fromHex(Ct + M(Tt)), qt = y(Tt), ct = c(-Gt * qt), Xt = c(Ut * qt), ye = m.BASE.multiplyAndAddUnsafe(Yt, ct, Xt);
      if (!ye)
        throw new Error("point at infinify");
      return ye.assertValidity(), ye;
    }
    // Signatures should be low-s, to prevent malleability.
    hasHighS() {
      return F(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new P(this.r, c(-this.s), this.recovery) : this;
    }
    // DER-encoded
    toDERRawBytes() {
      return zr(this.toDERHex());
    }
    toDERHex() {
      return br.hexFromSig({ r: this.r, s: this.s });
    }
    // padded bytes of r, then padded bytes of s
    toCompactRawBytes() {
      return zr(this.toCompactHex());
    }
    toCompactHex() {
      return M(this.r) + M(this.s);
    }
  }
  const et = {
    isValidPrivateKey(z) {
      try {
        return T(z), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: T,
    /**
     * Produces cryptographically secure private key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */
    randomPrivateKey: () => {
      const z = mo(t.n);
      return Zc(t.randomBytes(z), t.n);
    },
    /**
     * Creates precompute table for an arbitrary EC point. Makes point "cached".
     * Allows to massively speed-up `point.multiply(scalar)`.
     * @returns cached point
     * @example
     * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
     * fast.multiply(privKey); // much faster ECDH now
     */
    precompute(z = 8, Y = m.BASE) {
      return Y._setWindowSize(z), Y.multiply(BigInt(3)), Y;
    }
  };
  function K(z, Y = !0) {
    return m.fromPrivateKey(z).toRawBytes(Y);
  }
  function ot(z) {
    const Y = Er(z), yt = typeof z == "string", Ut = (Y || yt) && z.length;
    return Y ? Ut === a || Ut === u : yt ? Ut === 2 * a || Ut === 2 * u : z instanceof m;
  }
  function nt(z, Y, yt = !0) {
    if (ot(z))
      throw new Error("first arg must be private key");
    if (!ot(Y))
      throw new Error("second arg must be public key");
    return m.fromHex(Y).multiply(T(z)).toRawBytes(yt);
  }
  const j = t.bits2int || function(z) {
    const Y = mr(z), yt = z.length * 8 - t.nBitLength;
    return yt > 0 ? Y >> BigInt(yt) : Y;
  }, it = t.bits2int_modN || function(z) {
    return c(j(z));
  }, lt = Li(t.nBitLength);
  function ce(z) {
    if (typeof z != "bigint")
      throw new Error("bigint expected");
    if (!(Je <= z && z < lt))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return jr(z, t.nByteLength);
  }
  function Pt(z, Y, yt = At) {
    if (["recovered", "canonical"].some((ue) => ue in yt))
      throw new Error("sign() legacy options not supported");
    const { hash: Ut, randomBytes: _t } = t;
    let { lowS: Gt, prehash: Tt, extraEntropy: Ct } = yt;
    Gt == null && (Gt = !0), z = Fe("msgHash", z), Tt && (z = Fe("prehashed msgHash", Ut(z)));
    const Yt = it(z), qt = T(Y), ct = [ce(qt), ce(Yt)];
    if (Ct != null && Ct !== !1) {
      const ue = Ct === !0 ? _t(r.BYTES) : Ct;
      ct.push(Fe("extraEntropy", ue));
    }
    const Xt = on(...ct), ye = Yt;
    function Be(ue) {
      const we = j(ue);
      if (!V(we))
        return;
      const ur = y(we), be = m.BASE.multiply(we).toAffine(), Jt = c(be.x);
      if (Jt === Je)
        return;
      const me = c(ur * c(ye + Jt * qt));
      if (me === Je)
        return;
      let Sr = (be.x === Jt ? 0 : 2) | Number(be.y & Me), vr = me;
      return Gt && F(me) && (vr = N(me), Sr ^= 1), new P(Jt, vr, Sr);
    }
    return { seed: Xt, k2sig: Be };
  }
  const At = { lowS: t.lowS, prehash: !1 }, ie = { lowS: t.lowS, prehash: !1 };
  function ae(z, Y, yt = At) {
    const { seed: Ut, k2sig: _t } = Pt(z, Y, yt), Gt = t;
    return xo(Gt.hash.outputLen, Gt.nByteLength, Gt.hmac)(Ut, _t);
  }
  m.BASE._setWindowSize(8);
  function pe(z, Y, yt, Ut = ie) {
    var be;
    const _t = z;
    if (Y = Fe("msgHash", Y), yt = Fe("publicKey", yt), "strict" in Ut)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: Gt, prehash: Tt } = Ut;
    let Ct, Yt;
    try {
      if (typeof _t == "string" || Er(_t))
        try {
          Ct = P.fromDER(_t);
        } catch (Jt) {
          if (!(Jt instanceof br.Err))
            throw Jt;
          Ct = P.fromCompact(_t);
        }
      else if (typeof _t == "object" && typeof _t.r == "bigint" && typeof _t.s == "bigint") {
        const { r: Jt, s: me } = _t;
        Ct = new P(Jt, me);
      } else
        throw new Error("PARSE");
      Yt = m.fromHex(yt);
    } catch (Jt) {
      if (Jt.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (Gt && Ct.hasHighS())
      return !1;
    Tt && (Y = t.hash(Y));
    const { r: qt, s: ct } = Ct, Xt = it(Y), ye = y(ct), Be = c(Xt * ye), ue = c(qt * ye), we = (be = m.BASE.multiplyAndAddUnsafe(Yt, Be, ue)) == null ? void 0 : be.toAffine();
    return we ? c(we.x) === qt : !1;
  }
  return {
    CURVE: t,
    getPublicKey: K,
    getSharedSecret: nt,
    sign: ae,
    verify: pe,
    ProjectivePoint: m,
    Signature: P,
    utils: et
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function su(e) {
  return {
    hash: e,
    hmac: (t, ...r) => fo(e, t, Ra(...r)),
    randomBytes: Va
  };
}
function So(e, t) {
  const r = (n) => iu({ ...e, ...su(n) });
  return Object.freeze({ ...r(t), create: r });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const vo = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), es = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), ou = BigInt(1), gi = BigInt(2), rs = (e, t) => (e + t / gi) / t;
function au(e) {
  const t = vo, r = BigInt(3), n = BigInt(6), a = BigInt(11), u = BigInt(22), p = BigInt(23), c = BigInt(44), y = BigInt(88), m = e * e * e % t, T = m * m * e % t, v = Oe(T, r, t) * T % t, V = Oe(v, r, t) * T % t, M = Oe(V, gi, t) * m % t, F = Oe(M, a, t) * M % t, N = Oe(F, u, t) * F % t, D = Oe(N, c, t) * N % t, P = Oe(D, y, t) * D % t, et = Oe(P, c, t) * N % t, K = Oe(et, r, t) * T % t, ot = Oe(K, p, t) * F % t, nt = Oe(ot, n, t) * m % t, j = Oe(nt, gi, t);
  if (!xi.eql(xi.sqr(j), e))
    throw new Error("Cannot find square root");
  return j;
}
const xi = wo(vo, void 0, void 0, { sqrt: au }), yi = So({
  a: BigInt(0),
  // equation params: a, b
  b: BigInt(7),
  // Seem to be rigid: bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975
  Fp: xi,
  // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
  n: es,
  // Curve order, total count of valid points in the field
  // Base point (x, y) aka generator point
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  // Cofactor
  lowS: !0,
  // Allow only low-S signatures by default in sign() and verify()
  /**
   * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
   * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
   * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
   * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
   */
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = es, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -ou * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), a = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), u = r, p = BigInt("0x100000000000000000000000000000000"), c = rs(u * e, t), y = rs(-n * e, t);
      let m = ve(e - c * r - y * a, t), T = ve(-c * n - y * u, t);
      const v = m > p, V = T > p;
      if (v && (m = t - m), V && (T = t - T), m > p || T > p)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: v, k1: m, k2neg: V, k2: T };
    }
  }
}, Pn);
BigInt(0);
yi.ProjectivePoint;
const wi = 33;
class Bo extends fn {
  /**
   * Create a new Secp256k1PublicKey object
   * @param value secp256k1 public key as buffer or base-64 encoded string
   */
  constructor(t) {
    if (super(), typeof t == "string" ? this.data = Ne(t) : t instanceof Uint8Array ? this.data = t : this.data = Uint8Array.from(t), this.data.length !== wi)
      throw new Error(
        `Invalid public key input. Expected ${wi} bytes, got ${this.data.length}`
      );
  }
  /**
   * Checks if two Secp256k1 public keys are equal
   */
  equals(t) {
    return super.equals(t);
  }
  /**
   * Return the byte array representation of the Secp256k1 public key
   */
  toRawBytes() {
    return this.data;
  }
  /**
   * Return the Sui address associated with this Secp256k1 public key
   */
  flag() {
    return Qe.Secp256k1;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(t, r) {
    let n;
    if (typeof r == "string") {
      const a = $r(r);
      if (a.signatureScheme !== "Secp256k1")
        throw new Error("Invalid signature scheme");
      if (!Pr(this.toRawBytes(), a.publicKey))
        throw new Error("Signature does not match public key");
      n = a.signature;
    } else
      n = r;
    return yi.verify(
      yi.Signature.fromCompact(n),
      Pn(t),
      this.toRawBytes()
    );
  }
}
Bo.SIZE = wi;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Io = wo(BigInt("0xffffffff00000001000000000000000000000000ffffffffffffffffffffffff")), fu = Io.create(BigInt("-3")), cu = BigInt("0x5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b"), uu = So({
  a: fu,
  // Equation params: a, b
  b: cu,
  Fp: Io,
  // Field: 2n**224n * (2n**32n-1n) + 2n**192n + 2n**96n-1n
  // Curve order, total count of valid points in the field
  n: BigInt("0xffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551"),
  // Base (generator) point (x, y)
  Gx: BigInt("0x6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296"),
  Gy: BigInt("0x4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"),
  h: BigInt(1),
  lowS: !1
}, Pn), ns = uu, bi = 33;
class Ao extends fn {
  /**
   * Create a new Secp256r1PublicKey object
   * @param value secp256r1 public key as buffer or base-64 encoded string
   */
  constructor(t) {
    if (super(), typeof t == "string" ? this.data = Ne(t) : t instanceof Uint8Array ? this.data = t : this.data = Uint8Array.from(t), this.data.length !== bi)
      throw new Error(
        `Invalid public key input. Expected ${bi} bytes, got ${this.data.length}`
      );
  }
  /**
   * Checks if two Secp256r1 public keys are equal
   */
  equals(t) {
    return super.equals(t);
  }
  /**
   * Return the byte array representation of the Secp256r1 public key
   */
  toRawBytes() {
    return this.data;
  }
  /**
   * Return the Sui address associated with this Secp256r1 public key
   */
  flag() {
    return Qe.Secp256r1;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(t, r) {
    let n;
    if (typeof r == "string") {
      const a = $r(r);
      if (a.signatureScheme !== "Secp256r1")
        throw new Error("Invalid signature scheme");
      if (!Pr(this.toRawBytes(), a.publicKey))
        throw new Error("Signature does not match public key");
      n = a.signature;
    } else
      n = r;
    return ns.verify(
      ns.Signature.fromCompact(n),
      Pn(t),
      this.toRawBytes()
    );
  }
}
Ao.SIZE = bi;
var _o = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, Gr = (e, t, r) => (_o(e, t, "read from private field"), r ? r.call(e) : t.get(e)), is = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, ss = (e, t, r, n) => (_o(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), kr, Zr;
class lu extends Ic {
  constructor(t, r = []) {
    var p;
    super(), is(this, kr, void 0), is(this, Zr, void 0), ss(this, kr, t), ss(this, Zr, r);
    let n = /* @__PURE__ */ new Set(), a = 0;
    const u = t.getPublicKeys().map(({ weight: c, publicKey: y }) => ({
      weight: c,
      address: y.toSuiAddress()
    }));
    for (let c of r) {
      const y = c.toSuiAddress();
      if (n.has(y))
        throw new Error("Can't create MultiSigSigner with duplicate signers");
      n.add(y);
      const m = (p = u.find((T) => T.address === y)) == null ? void 0 : p.weight;
      if (!m)
        throw new Error(`Signer ${y} is not part of the MultiSig public key`);
      a += m;
    }
    if (a < t.getThreshold())
      throw new Error("Combined weight of signers is less than threshold");
  }
  getKeyScheme() {
    return "MultiSig";
  }
  getPublicKey() {
    return Gr(this, kr);
  }
  sign(t) {
    throw new Error(
      "MultiSigSigner does not support signing directly. Use signTransaction or signPersonalMessage instead"
    );
  }
  signData(t) {
    throw new Error(
      "MultiSigSigner does not support signing directly. Use signTransaction or signPersonalMessage instead"
    );
  }
  async signTransaction(t) {
    return {
      signature: Gr(this, kr).combinePartialSignatures(
        await Promise.all(
          Gr(this, Zr).map(async (n) => (await n.signTransaction(t)).signature)
        )
      ),
      bytes: ee(t)
    };
  }
  async signPersonalMessage(t) {
    return {
      signature: Gr(this, kr).combinePartialSignatures(
        await Promise.all(
          Gr(this, Zr).map(async (n) => (await n.signPersonalMessage(t)).signature)
        )
      ),
      bytes: ee(t)
    };
  }
}
kr = /* @__PURE__ */ new WeakMap();
Zr = /* @__PURE__ */ new WeakMap();
const Yr = 10, os = 1;
class Vn extends fn {
  /**
   * Create a new MultiSigPublicKey object
   */
  constructor(t, r = {}) {
    if (super(), typeof t == "string" ? (this.rawBytes = Ne(t), this.multisigPublicKey = Ae.MultiSigPublicKey.parse(this.rawBytes)) : t instanceof Uint8Array ? (this.rawBytes = t, this.multisigPublicKey = Ae.MultiSigPublicKey.parse(this.rawBytes)) : (this.multisigPublicKey = t, this.rawBytes = Ae.MultiSigPublicKey.serialize(t).toBytes()), this.multisigPublicKey.threshold < 1)
      throw new Error("Invalid threshold");
    const n = /* @__PURE__ */ new Set();
    this.publicKeys = this.multisigPublicKey.pk_map.map(({ pubKey: u, weight: p }) => {
      const [c, y] = Object.entries(u).filter(([T]) => T !== "$kind")[0], m = Uint8Array.from(y).toString();
      if (n.has(m))
        throw new Error("Multisig does not support duplicate public keys");
      if (n.add(m), p < 1)
        throw new Error("Invalid weight");
      return {
        publicKey: Di(c, Uint8Array.from(y), r),
        weight: p
      };
    });
    const a = this.publicKeys.reduce((u, { weight: p }) => u + p, 0);
    if (this.multisigPublicKey.threshold > a)
      throw new Error("Unreachable threshold");
    if (this.publicKeys.length > Yr)
      throw new Error(`Max number of signers in a multisig is ${Yr}`);
    if (this.publicKeys.length < os)
      throw new Error(`Min number of signers in a multisig is ${os}`);
  }
  /**
   * 	A static method to create a new MultiSig publickey instance from a set of public keys and their associated weights pairs and threshold.
   */
  static fromPublicKeys({
    threshold: t,
    publicKeys: r
  }) {
    return new Vn({
      pk_map: r.map(({ publicKey: n, weight: a }) => ({
        pubKey: { [Xs[n.flag()]]: Array.from(n.toRawBytes()) },
        weight: a
      })),
      threshold: t
    });
  }
  /**
   * Checks if two MultiSig public keys are equal
   */
  equals(t) {
    return super.equals(t);
  }
  /**
   * Return the byte array representation of the MultiSig public key
   */
  toRawBytes() {
    return this.rawBytes;
  }
  getPublicKeys() {
    return this.publicKeys;
  }
  getThreshold() {
    return this.multisigPublicKey.threshold;
  }
  getSigner(...t) {
    return new lu(this, t);
  }
  /**
   * Return the Sui address associated with this MultiSig public key
   */
  toSuiAddress() {
    const t = 1 + 65 * Yr + 2, r = new Uint8Array(t);
    r.set([Qe.MultiSig]), r.set(Ae.u16().serialize(this.multisigPublicKey.threshold).toBytes(), 1);
    let n = 3;
    for (const { publicKey: a, weight: u } of this.publicKeys) {
      const p = a.toSuiBytes();
      r.set(p, n), n += p.length, r.set([u], n++);
    }
    return _e(qs(kn(r.slice(0, n), { dkLen: 32 })));
  }
  /**
   * Return the Sui address associated with this MultiSig public key
   */
  flag() {
    return Qe.MultiSig;
  }
  /**
   * Verifies that the signature is valid for for the provided message
   */
  async verify(t, r) {
    const n = $r(r);
    if (n.signatureScheme !== "MultiSig")
      throw new Error("Invalid signature scheme");
    const { multisig: a } = n;
    let u = 0;
    if (!Pr(
      Ae.MultiSigPublicKey.serialize(this.multisigPublicKey).toBytes(),
      Ae.MultiSigPublicKey.serialize(a.multisig_pk).toBytes()
    ))
      return !1;
    for (const { publicKey: p, weight: c, signature: y } of hu(a)) {
      if (!await p.verify(t, y))
        return !1;
      u += c;
    }
    return u >= this.multisigPublicKey.threshold;
  }
  /**
   * Combines multiple partial signatures into a single multisig, ensuring that each public key signs only once
   * and that all the public keys involved are known and valid, and then serializes multisig into the standard format
   */
  combinePartialSignatures(t) {
    var c, y;
    if (t.length > Yr)
      throw new Error(`Max number of signatures in a multisig is ${Yr}`);
    let r = 0;
    const n = new Array(t.length);
    for (let m = 0; m < t.length; m++) {
      let T = $r(t[m]);
      if (T.signatureScheme === "MultiSig")
        throw new Error("MultiSig is not supported inside MultiSig");
      let v;
      T.signatureScheme === "ZkLogin" ? v = oo(
        (c = T.zkLogin) == null ? void 0 : c.addressSeed,
        (y = T.zkLogin) == null ? void 0 : y.iss
      ).toRawBytes() : v = T.publicKey, n[m] = {
        [T.signatureScheme]: Array.from(T.signature.map((M) => Number(M)))
      };
      let V;
      for (let M = 0; M < this.publicKeys.length; M++)
        if (Pr(v, this.publicKeys[M].publicKey.toRawBytes())) {
          if (r & 1 << M)
            throw new Error("Received multiple signatures from the same public key");
          V = M;
          break;
        }
      if (V === void 0)
        throw new Error("Received signature from unknown public key");
      r |= 1 << V;
    }
    let a = {
      sigs: n,
      bitmap: r,
      multisig_pk: this.multisigPublicKey
    };
    const u = Ae.MultiSig.serialize(a, { maxSize: 8192 }).toBytes();
    let p = new Uint8Array(u.length + 1);
    return p.set([Qe.MultiSig]), p.set(u, 1), ee(p);
  }
}
function hu(e, t = {}) {
  let r = new Array(e.sigs.length);
  for (let n = 0; n < e.sigs.length; n++) {
    const [a, u] = Object.entries(e.sigs[n]).filter(
      ([T]) => T !== "$kind"
    )[0], p = du(e.bitmap).at(n), c = e.multisig_pk.pk_map[p], y = Uint8Array.from(Object.values(c.pubKey)[0]);
    if (a === "MultiSig")
      throw new Error("MultiSig is not supported inside MultiSig");
    const m = Di(a, y, t);
    r[n] = {
      signatureScheme: a,
      signature: Uint8Array.from(u),
      publicKey: m,
      weight: c.weight
    };
  }
  return r;
}
function du(e) {
  if (e < 0 || e > 1024)
    throw new Error("Invalid bitmap");
  let t = [];
  for (let r = 0; r < 10; r++)
    e & 1 << r && t.push(r);
  return Uint8Array.from(t);
}
async function pu(e, t, r = {}) {
  const n = To(t, r);
  if (!await n.publicKey.verifyPersonalMessage(
    e,
    n.serializedSignature
  ))
    throw new Error("Signature is not valid for the provided message");
  return n.publicKey;
}
async function gu(e, t) {
  const r = To(t);
  if (!await r.publicKey.verifyTransaction(
    e,
    r.serializedSignature
  ))
    throw new Error("Signature is not valid for the provided Transaction");
  return r.publicKey;
}
function To(e, t = {}) {
  const r = $r(e);
  if (r.signatureScheme === "MultiSig")
    return {
      ...r,
      publicKey: new Vn(r.multisig.multisig_pk)
    };
  const n = Di(
    r.signatureScheme,
    r.publicKey,
    t
  );
  return {
    ...r,
    publicKey: n
  };
}
function Di(e, t, r = {}) {
  switch (e) {
    case "ED25519":
      return new ho(t);
    case "Secp256k1":
      return new Bo(t);
    case "Secp256r1":
      return new Ao(t);
    case "MultiSig":
      return new Vn(t);
    case "ZkLogin":
      return new so(t, r);
    default:
      throw new Error(`Unsupported signature scheme ${e}`);
  }
}
async function xu({
  txb: e,
  client: t,
  sdk: r
}) {
  const n = await e.build({ client: t }), { signature: a } = await Hs(r, {
    method: Ys.SIGN_TRANSACTION,
    param: Ni.Buffer.from(n).toString("base64")
  });
  return await gu(n, a), { signature: a, transactionBlock: n };
}
async function yu({ message: e, sdk: t }) {
  const r = await Hs(t, {
    method: Ys.SIGN_PERSONAL_MESSAGE,
    param: Ni.Buffer.from(e).toString("base64")
  });
  return await pu(new TextEncoder().encode(e), r.signature), r;
}
class wu {
  constructor({ suiNetwork: t = qe.MAINNET, extensions: r }) {
    Se(this, "name", "sui");
    Se(this, "zkLogin");
    Se(this, "sdk");
    Se(this, "client");
    Se(this, "gqlClient");
    Se(this, "suiAddress");
    Se(this, "currentSuiNetwork");
    Se(this, "extensions", []);
    Se(this, "_isZkActive", !1);
    Se(this, "_signSuiBlockData");
    Se(this, "_signSuiPersonalMessage");
    Se(this, "_getSuiAddress");
    this.switchNetwork(t);
    for (const n of r || [])
      Object.assign(this, { [n.name]: n }), this.extensions.push(n.name);
  }
  async _initialize(t) {
    var r;
    this.sdk = t;
    for (const n of this.extensions)
      await ((r = this[n]) == null ? void 0 : r._initialize(this.sdk)), this[n].name === "zkLogin" && this.sdk.env === tn.PROD && (this._isZkActive = !0);
    if (this.sdk.on(bf.LOGOUT, () => {
      this.suiAddress = void 0;
    }), this._isZkActive && t.env === tn.PROD) {
      this._signSuiBlockData = t.sui.zkLogin.signTransactionBlock.bind(this.sdk.sui.zkLogin), this._signSuiPersonalMessage = t.sui.zkLogin.signPersonalMessage.bind(this.sdk.sui.zkLogin), this._getSuiAddress = t.sui.zkLogin.getAddress.bind(this.sdk.sui.zkLogin);
      return;
    }
    this._signSuiBlockData = async (n) => await xu({
      txb: n,
      client: this.client,
      sdk: this.sdk
    }), this._signSuiPersonalMessage = async (n) => await yu({ message: n, sdk: this.sdk }), this._getSuiAddress = async () => await mf(this.sdk);
  }
  _assureLogin() {
    const t = this.sdk.getAccessToken();
    if (!t) throw new Error("User is not logged in");
    return t;
  }
  switchNetwork(t) {
    if (this._isZkActive) throw new Error("SUI ZK Login is active, cannot switch network");
    if (this.client && this.currentSuiNetwork === t) throw new Error(`Already on sui ${t}`);
    return this.client = new xf({ url: yf[t] }), this.gqlClient = new eo({
      url: wf[t]
    }), this.currentSuiNetwork = t, this.suiAddress = void 0, { client: this.getSuiClient(), network: this.getNetworkName() };
  }
  getSuiGqlClient() {
    return this.gqlClient;
  }
  getSuiClient() {
    return this.client;
  }
  getNetworkName() {
    return this.currentSuiNetwork;
  }
  async getAddress() {
    if (this._assureLogin(), !this.suiAddress) {
      const { address: t } = await this._getSuiAddress();
      this.suiAddress = t;
    }
    return this.suiAddress;
  }
  async signPersonalMessage(t) {
    return this._assureLogin(), this._signSuiPersonalMessage(t);
  }
  async signTransactionBlock(t) {
    this._assureLogin(), t.setSenderIfNotSet(await this.getAddress());
    const { signature: r, transactionBlock: n } = await this._signSuiBlockData(t);
    return { signature: r, transactionBlock: n };
  }
  async signAndExecuteTransactionBlock(t) {
    const r = await this.signTransactionBlock(t);
    return await this.client.executeTransactionBlock(r);
  }
}
Se(wu, "SUI_NETWORK", qe);
export {
  wu as SuiExtension
};
